import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  CardHeader,
  Row,
  FloatingLabel,
  Form,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalTitle,
  Container,
  OverlayTrigger,
  Tooltip,
  Spinner,
} from "react-bootstrap";
import { BsFillHouseFill } from "react-icons/bs";
import { RiArrowDropDownLine } from "react-icons/ri";
import { FaArrowAltCircleUp, FaHome, FaQuestionCircle } from "react-icons/fa";
import { ReactMultiEmail, isEmail } from "react-multi-email";
import "react-multi-email/dist/style.css";
import api from "../../services/api";
import { Link, useNavigate } from "react-router-dom";
import { jwtDecode as jwt_decode } from "jwt-decode";
import "./Purchase.css";
import { height } from "@fortawesome/free-regular-svg-icons/faAddressBook";
import {
  POST_ORDER_REPORTS,
  POST_ORDER_CREDITS,
  TOKEN,
  GET_ALL_SAVED_CARD_DETAILS,
  SECRET_KEY,
  IV_KEY,
  BASEURL,
  CUSTOMERID,
  POST_PAYPAL_PAYMENT,
  GetToken,
  GetCustomerId,
  GET_CC_EMAILS,
} from "../../CONSTANTS";
import CryptoJS from "crypto-js";
import { Loader, LoadingIndicator } from "../Loader";
import { useStepper } from "../../context/stepperContext";
import { StepHeader } from "../StepHeader";
import Cookies from "js-cookie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faChevronDown,
  faChevronUp,
  faArrowAltCircleUp,
  faCircleArrowUp,
  faCircleExclamation, 
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";
import { use } from "react";
import toast from "react-hot-toast";
import { useSearchParams } from "react-router-dom";
import { useCustomScreen, useScreenSize } from "../Utils";

const Purchase = () => {
  const token = Cookies.get("token") || localStorage.getItem("token");
  const customerId =
    Cookies.get("customerId") || localStorage.getItem("customerId");

  const { isLandscape1024, isPortrait1024, isIpadProPortrait } =
    useCustomScreen();
  const [reportType, setReportType] = useState("");
  const [reportPrice, setReportprice] = useState(0);  
  const [deliveryOption, setDeliveryOption] = useState("");
  const [deliveryPrice, setdeliveryprice] = useState(0);
  const [dprice, setdprice] = useState(0);
  const [rprice, setrprice] = useState(0);
  const [selAddress, setSelAddress] = useState([]);    
  const [selType, setSelType] = useState("");
  const [selDelivery, setSelDelivery] = useState("");
  const [emails, setEmails] = useState([]);
  const [focused, setFocused] = useState(false);
  const [reports, setReports] = useState([]);
  const [ccFilteredReports, setCCFilteredReports] = useState([]);
  const [checkout, setCheckout] = useState(false);
  const [afterCreditsApply, setAfterCreditsApply] = useState([]);
  const [cardNumber, setCardNumber] = useState("");
  const [error, setError] = useState("");
  const [cardType, setCardType] = useState("");
  const [isCardDefault, setIsCardDefault] = useState(false);
  const [selBrick, setSelBrick] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingReports, setLoadingReports] = useState(false);
  const [orderBricksCount, setOrderBricksCount] = useState([
    {
      type: "STANDARD",
      count: 0,
      price: 0,
    },
    {
      type: "EXPANDED​",
      count: 0,
      price: 0,
    },
    {
      type: "CLAIMS​",
      count: 0,
      price: 0,
    },
  ]);

  const steps = [
    { label: "Enter Address " },
    { label: "Add Instructions " },
    { label: "Confirm Order " },
  ];

  const [searchParams, setSearchParams] = useSearchParams();
  const pageNumber = searchParams.get("step") || "1";
  const navigate = useNavigate();
  const [showCredits, setShowCredits] = useState(false);
  const [creditSummary, setCreditSummary] = useState([]);
  const [filteredCreditSUmmary, setFilteredCreditSummary] = useState([]);
  const [onPayBtnSel, setOnPayBtnSel] = useState(null);
  const [trueToggle, setTrueToggle] = useState({});
  const [toggleOrderPromo, setToggleOrderPromo] = useState(false);
  const [selBrickToBuy, setSelBrickToBuy] = useState({
    brickName: "",
    price: 0,
    brickCount: 0,
  });
  const [standardBrickCount, setStandardBrickCount] = useState(0);
  const [claimsBrickCount, setClaimsBrickCount] = useState(0);
  const [expandedBrickCount, setExpandedBrickCount] = useState(0);
  const [remainingBricks, setRemainingBricks] = useState([]);
  const [paymentDetails, setPaymentDetails] = useState({
    customerId: `${customerId}`,
    expMonth: "string",
    expYear: "string",
    cardName: "string",
    cardNumber: "string", 
    amount: 0,
    saveCard: false,
    makeDefaultCard: false,
    vaultId: "string",
    paypalCustomerId: "string",
  });
  const [buyCreditItems, setBuyCreditItems] = useState([
    {
      type: "BASIC",
      count: 0,
      price: 0,
    },
    {
      type: "STANDARD",
      count: 0,
      price: 0,
    }, 
    {
      type: "COMPREHENSIVE",
      count: 0,
      price: 0,
    },
    {
      type: "CLAIMS",
      count: 0,
      price: 0,
    },
  ]);

  const [discount, setDiscount] = useState(0);

  const [secCoseProduct, setSecCoseProduct] = useState({});
  const [highestBrickCostProduct, setHighestBrickCostProduct] = useState({});
  const [secHighestBrickCost, setSecHighestBrickCost] = useState({});
  const [thirdHighestBrickCost, setThirdHighestBrickCost] = useState({});
  const [leastBrickCost, setLeastBrickCost] = useState({});
  const [discountNotFlag, setDiscountNotFlag] = useState(false);
  const [brickDiscountNotFlag, setBrickDiscountNotFlag] = useState(false);
  const [showBrickPromoErrorMsg, setShowBrickPromoErrorMsg] = useState(false);
  const [creditsTotal, setCreditsTotal] = useState(0);
  const [loadingDefault, setLoadingDefault] = useState(false);
  const [saveAndAddRadio, setSaveAndAddRadio] = useState("savedCard");
  const [selectCardType, setSelectCardType] = useState("savedCard");
  const [paymentLoading, setPaymentLoading] = useState(false);

  // const [cardExpirationDetails, setCardExpirationDetails] = useState("");
  // const [isCardDefault, setIsCardDefault] = useState(false);
  const [saveCard, setSaveCard] = useState(false);
  const [makeDefaultCard, setMakeDefaultCard] = useState(false);

  const [showAddOrRemoveCardPopup, setShowAddOrRemoveCardPopup] =
    useState(false);
  const [summaryOptions, setSummaryOptions] = useState([
    {
      type: "Basic",
      count: 0,
      value: 0,
    },
    {
      type: "Standard",
      count: 0,
      value: 0,
    },
    {
      type: "Claims",
      count: 0,
      value: 0,
    },
    {
      type: "Comprehensive",
      count: 0,
      value: 0,
    },
    {
      type: "Rush",
      count: 0,
      value: 0,
    },
  ]);
  const [toggleSummaryBtn, setToggleSummaryBtn] = useState(true);

  const defaultSummaryOptions = [
    {
      type: "Basic",
      count: 0,
      value: 0,
    },
    {
      type: "Standard",
      count: 0,
      value: 0,
    },
    {
      type: "Claims",
      count: 0,
      value: 0,
    },
    {
      type: "Comprehensive",
      count: 0,
      value: 0,
    },
    {
      type: "Rush",
      count: 0,
      value: 0,
    },
  ];
  const [discountPerc, setDiscountPerc] = useState(0);
  const [brickDiscountPerc, setBrickDiscountPerc] = useState(0);
  const [promo, setPromo] = useState("");
  const [showPromoErrorMsg, setShowPromoErrorMsg] = useState(false);
  const [highestCostProduct, setHighestCostProduct] = useState({});
  const [secHighest, setSecHighest] = useState({});
  const [thirdHighest, setThirdHighest] = useState({});
  const [leastCost, setLeastCost] = useState({});
  const [brickPromo, setBrickPromo] = useState("");
  // const token = localStorage.getItem("token");
  const [allCards, setAllCards] = useState([]);
  const [cardExpirationDetails, setCardExpirationDetails] = useState("");
  const [selectedCard, setSelectedCard] = useState("");
  const [cardName, setCardName] = useState("");
  const [defaultCardNumber, setDefaultCardNumber] = useState("");
  const [paidTransactionId, setPaidTransactionId] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState(false);
  const [saveCardLoading, setSaveCardLoading] = useState(false);
  const [additionalInfo, setAdditionalInfo] = useState([]);
  const [listOfEmails, setListOfEmails] = useState([]);
  const [creditsApplied, setCreditsApplied] = useState(false);
  const [disablecreditsRadio, setDisableCreditsRadio] = useState(false);
  const [disableBasicCredit, setDisableBasicCredit] = useState(false);
  const [showToolTip, setShowToolTip] = useState(false);

  const deliveryOptions = [
    {
      label: "RUSH",
      showLabel: "Rush",
      price: 15,
      toolTipDes:
        "Rush deliveries are prioritized and often get delivered same day if received before 3 pm PST",
    },
    {
      label: "NORMAL",
      showLabel: "Normal",
      price: 0,
      toolTipDes:
        "Reports are processed in a first-come-first-serve basis and are typically  delivered in just one business day",
    },
  ];

  const [changeCardLoading, setChanegCardLoading] = useState(false);
  const [inputData, setInputData] = useState(1);

  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();

  const [productId, setProductId] = useState(0);
  const [brickDiscount, setBrickDiscount] = useState(0);
  const EstimatedTotal =
    summaryOptions.reduce((accum, item) => accum + item.value, 0) -
    discount -
    creditsTotal;
  const EstimateBrickTotal = inputData
    ? buyCreditItems.reduce((accum, item) => accum + item.price, 0) -
      brickDiscount
    : 0;

  const quantityOfBrics = parseInt(inputData) * 10;

  useEffect(() => {
    onCreditCheckHandler();
    onReportsHandler();
    filteredCreitsCheckHandler();
  }, []);

  useEffect(() => {
    if (selAddress.length > 0 && additionalInfo.length === 0) {
      const initialData = selAddress.map(() => ({
        notes: "",
        additionalMails: [],
        claimNumber: "",
      }));
      setAdditionalInfo(initialData);
    }
  }, [selAddress]);

  const handleAdditionalInfoChange = (addressIndex, field) => (e) => {
    setAdditionalInfo((prev) => {
      const newData = [...prev]; // Create a copy of the current state
      newData[addressIndex] = {
        ...newData[addressIndex],
        [field]: e.target.value,
      }; // Update the specific field for the specific address
      return newData; // Return the updated state
    });
  };

  const onPromoHandler = (e) => {
    if (!e.target.value) {
      setDiscount(0);
      setIsPromoApplied(false);
      setShowPromoErrorMsg(false);
      setDiscountNotFlag(false);
    }
    let temp = promo;
    temp = e.target.value;
    setPromo(temp);
  };

  const onBrickPromoHandler = (e) => {
    if (!e.target.value) {
      setBrickDiscount(0);
      setIsBricksPromoApplied(false);
      setShowBrickPromoErrorMsg(false);
    }
    let tempB = brickPromo;
    tempB = e.target.value;
    setBrickPromo(tempB);
  };
  const applyPromo = () => {};

  useEffect(() => {
    getProducts();
    savedCards();
    onCreditCheckHandler();
    checkCreditsAvailabe();
    loadCCEmails();
  }, []);

  useEffect(() => {
    if (creditSummary.length > 0) {
      checkCreditsAvailabe();
    }
  }, [creditSummary]);

  useEffect(() => {
    const token = localStorage.getItem("token");
  }, []);
  useEffect(() => {
    if (selAddress?.length > 0) {
      let c = 0;
      for (let a = 0; a < selAddress?.length; a++) {
        if (selAddress[a]["type"] !== "" && selAddress[a]["delivery"] !== "") {
          c = c + 1;
        }
      }
      if (c === selAddress?.length) {
        setToggleSummaryBtn(false);
      } else {
        setToggleSummaryBtn(true);
      }
    }
  }, [selAddress]);
  useEffect(() => {
    let temp = JSON.parse(localStorage.getItem("sel-places"));

    let modifiedPlaces = [];
    temp?.length &&
      temp?.map((addr, addrIndex) => {
        let address = {
          address: addr?.address ? addr?.address : "",
          street: addr?.street ? addr?.street : "",
          city: addr?.city ? addr?.city : "",
          state: addr?.state ? addr?.state : "",
          country: addr?.country ? addr?.country : "",
          postalCode: addr?.postalCode ? addr?.postalCode : "",
          lat: addr?.lat ? addr?.lat : 0,
          lng: addr?.lng ? addr?.lng : 0,
          type: "",
          price: "",
          delivery: "",
          deliveryPrice: "",
        };
        modifiedPlaces.push(address);
      });

    setSelAddress([...modifiedPlaces]);
  }, []);

  useEffect(() => {
    // payWithCredits(null, true);
    checkCreditsAvailabe();
  }, [selAddress.length]);

  useEffect(() => {
    if (pageNumber === "1") {
      const temp = JSON.parse(localStorage.getItem("sel-places") || "[]");

      if (Array.isArray(temp) && temp.length > 0) {
        const modifiedPlaces = temp.map((addr) => ({
          address: addr?.address || "",
          street: addr?.street || "",
          city: addr?.city || "",
          state: addr?.state || "",
          country: addr?.country || "",
          postalCode: addr?.postalCode || "",
          lat: addr?.lat || 0,
          lng: addr?.lng || 0,
          type: addr?.type || "", // restore type and price too
          price: addr?.price || "",
          delivery: addr?.delivery || "",
          deliveryPrice: addr?.deliveryPrice || "",
        }));

        setSelAddress(modifiedPlaces);
        setPromo("");
        setDiscount(0);
        setIsPromoApplied(false);
        setIsBricksPromoApplied(false);
        setShowPromoErrorMsg(false);
        setDiscountNotFlag(false);
        setAfterCreditsApply([]);
        setOnPayBtnSel(0);
        setCreditsApplied(false);
        setAfterCreditsApply([]);
        setCreditsTotal(0);
        setSummaryOptions([
          {
            type: "Basic",
            count: 0,
            value: 0,
          },
          {
            type: "Standard",
            count: 0,
            value: 0,
          },
          {
            type: "Claims",
            count: 0,
            value: 0,
          },
          {
            type: "Comprehensive",
            count: 0,
            value: 0,
          },
          {
            type: "Rush",
            count: 0,
            value: 0,
          },
        ]);
      }
    }
  }, [pageNumber]);

  const [manualOverride, setManualOverride] = useState(false);

  useEffect(() => {
    if (pageNumber !== 2) {
      setCreditsApplied(false);
      setManualOverride(false); // reset when leaving page
    }
  }, [pageNumber]);

  useEffect(() => {
    if (onPayBtnSel === 0 && !disablecreditsRadio && !creditsApplied) {
     
      payWithCredits(null, true);
      setCreditsApplied(true);
    } else if (onPayBtnSel === 1 && disablecreditsRadio) {


      setCreditsApplied(false);
      setAfterCreditsApply([]);
      setCreditsTotal(0);
    }

    // Detect when user manually changes payment method
    if (!manualOverride) {
      // Allow auto-fallback until the user picks something different
      if (
        (!disablecreditsRadio && onPayBtnSel === 1) ||
        (disablecreditsRadio && onPayBtnSel === 0)
      ) {
        setManualOverride(true);
      }
    }
  }, [onPayBtnSel, disablecreditsRadio, creditsApplied, manualOverride]);

  useEffect(() => {
    if (!manualOverride) {
      if (disablecreditsRadio && onPayBtnSel !== 1) {
       
        setOnPayBtnSel(1);
      } else if (!disablecreditsRadio && onPayBtnSel !== 0) {
      
        setOnPayBtnSel(0);
      }
    }
  }, [onPayBtnSel, disablecreditsRadio, manualOverride]);

  //working part

  // useEffect(() => {
  //   if (pageNumber !== 2) {
  //     setCreditsApplied(false);
  //   }
  // }, [pageNumber]);

  // useEffect(() => {
  //   if (onPayBtnSel === 0 && !disablecreditsRadio && !creditsApplied) {
  //     console.log("✅ Applying credits payment logic");
  //     payWithCredits(null, true);
  //     setCreditsApplied(true);
  //   } else if (onPayBtnSel === 1 && disablecreditsRadio) {
  //     console.log("✅ Applying card payment logic");
  //     // Example: if you have a function like `selectCardPayment()`, call it
  //     setCreditsApplied(false);
  //     setAfterCreditsApply([]);
  //     setCreditsTotal(0);
  //   }
  // }, [onPayBtnSel, disablecreditsRadio, creditsApplied]);

  // const [test,setTest] = useState(false);
  // useEffect(()=>{

  // },[onPayBtnSel])

  // useEffect(() => {
  //   if (disablecreditsRadio && onPayBtnSel !== 1) {
  //     console.log("🔄 Forcing fallback: No credits, setting card as default");
  //     setOnPayBtnSel(1);
  //   } else if (!disablecreditsRadio && onPayBtnSel !== 0) {
  //     console.log(
  //       "🔄 Forcing fallback: Credits available, setting credits as default"
  //     );
  //     setOnPayBtnSel(0);
  //   }
  // }, [ onPayBtnSel,disablecreditsRadio]);

  const makeCardDefault = () => {
    setIsCardDefault(true);
  };
  const changeCardNameHandler = (e) => {
    setCardName(e.target.value);
  };

  const loadCCEmails = async () => {
    try {
      const res = await fetch(GET_CC_EMAILS(), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${GetToken()}`,
        },
      });

      if (res.ok) {
        const result = await res.json();
        if (Array.isArray(result)) {
          const extractedEmails = result
            .filter((item) => item.alwaysCc === true)
            .map((item) => item.email)
            .filter(
              (email) => typeof email === "string" && email.includes("@")
            );
          setListOfEmails(extractedEmails);
          setAdditionalInfo((prev) =>
            prev.map((item) => ({
              ...item,
              additionalMails: item.additionalMails?.length
                ? item.additionalMails
                : extractedEmails, // prefill if empty
            }))
          );
        }

      }
    } catch (e) {
      console.error("Failed loading CC emails:", e);
    }
  };

  const [invalidExpiry, setInValidExpiry] = useState(false);

  const changeCardExpirationDetails = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters

    if (value.length > 4) {
      value = value.substring(0, 4);
    }

    if (value.length > 2) {
      value = value.substring(0, 2) + "/" + value.substring(2, 4);
    }

    // Validate expiry date
    if (value.length === 5) {
      // MM/YY format has 5 characters including the slash
      const [month, year] = value.split("/").map(Number);

      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1; // JS months are 0-based
      const currentYear = currentDate.getFullYear() % 100; // Get last 2 digits of year

      if (
        year < currentYear ||
        (year === currentYear && month < currentMonth) ||
        month < 1 ||
        month > 12
      ) {
        setInValidExpiry(true);
      } else {
        setInValidExpiry(false);
      }
    } else {
      setInValidExpiry(false);
    }

    // Update the state with the formatted value
    setCardExpirationDetails(value);
    setNewCardDetails((prevDetails) => ({
      ...prevDetails,
      expiryDate: value,
    }));
  };

  const handleBackspace = (e) => {
    if (e.key === "Backspace" && cardExpirationDetails.length <= 3) {
      setCardExpirationDetails("");
      setNewCardDetails((prevDetails) => ({
        ...prevDetails,
        expiryDate: "",
      }));
    }
  };

  const clearFields = () => {
    setCardName("");
    setCardNumber("");
    setCardType("");
    setIsCardDefault(false);
    setCardExpirationDetails("");
  };

  const saveCardHandler = async () => {
    if (!cardName || !cardNumber || !cardExpirationDetails) return;
    const [expMonth, expYear] = cardExpirationDetails.split("/");
    const yearPrefix = new Date().getFullYear();
    const stringfiedYearPrefix = yearPrefix.toString().slice(0, 2);
    const expiry = stringfiedYearPrefix + expYear;

    // console.log("exp date", expDate);
    // const expArr = String(expDate)?.split("-");
    // const expMonth = expArr.length > 0 ? expArr[1] : "";
    // const expYear = expArr.length > 0 ? expArr[0] : "";
    const tempCardNumber = cardNumber
      ? String(cardNumber).replaceAll(" ", "")
      : "";
    let res = {
      customerId: `${GetCustomerId()}`,
      expMonth: `${expMonth}`,
      expYear: `${expiry}`,
      cardName: `${cardName}`,
      cardNumber: `${tempCardNumber}`,
      paypalCustomerId: "",
    };
    try {
      setLoading(true);
      const response = await fetch(`${BASEURL}paymentcards/add-card`, {
        method: "POST",
        body: JSON.stringify(res),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${GetToken()}`, // Add your TOKEN here
        },
      });
      if (response) {
        savedCards();

        clearFields();
      }
    } catch (e) {
      if (e?.status === 401) {
        navigate("/login");
      }
    } finally {
      setLoading(false);
    }
    // handleCardPopupClose();
  };

  const encryptKey = (data) => {
    const encrypted = CryptoJS.AES.encrypt(
      data,
      CryptoJS.enc.Utf8.parse(SECRET_KEY),
      {
        iv: CryptoJS.enc.Utf8.parse(IV_KEY),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return encrypted.toString();
  };

  const decryptKey = (encrptedData) => {
    const decrypted = CryptoJS.AES.decrypt(
      encrptedData,
      CryptoJS.enc.Utf8.parse(SECRET_KEY),
      {
        iv: CryptoJS.enc.Utf8.parse(IV_KEY),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return decrypted.toString(CryptoJS.enc.Utf8);
  };

  const placeOrderHandlerFromBricks = async () => {
    let tempPaymentDetails = {
      customerId: `${customerId}`,
      expMonth: "",
      expYear: "",
      cardName: "",
      cardNumber: "",
      amount: 0,
      saveCard: false,
      makeDefaultCard: false,
      vaultId: "",
      paypalCustomerId: "",
    };
    tempPaymentDetails.amount = EstimatedTotal;
    tempPaymentDetails.cardName = selectedCard?.cardName;
    let expDetails = selectedCard?.expDetails
      ? selectedCard?.expDetails?.split("-")
      : [];
    tempPaymentDetails.expMonth = expDetails.length > 1 ? expDetails[1] : "";
    tempPaymentDetails.expYear = expDetails.length > 0 ? expDetails[0] : "";
    tempPaymentDetails.cardNumber = selectedCard?.cardNumber;
    tempPaymentDetails.vaultId = selectedCard?.vaultId;
    tempPaymentDetails.paypalCustomerId = selectedCard?.paypalCustomerId;
    let temp = {
      paypalRequest: "",
    };
    temp.paypalRequest = encryptKey(JSON.stringify(tempPaymentDetails));
    try {
      let result = await fetch(`${POST_PAYPAL_PAYMENT}`, {
        method: "POST",
        body: JSON.stringify(temp),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Add your token here
        },
      });

      if (result.ok) {
        const res = await result.json();

        setPaidTransactionId(res?.transactionId);
        const info = {
          customerId: Number(customerId),
          productId: 1,
          brickPrice: EstimateBrickTotal,
          brickQuantity: 10,
          refundPrice: 0,
          isAutorenew: "No",
          paymentParams: "",
          refundParams: "",
          paymentType: "Invoice",
          cardLastDigits: "1111",
          paymentTransactionId: res?.transactionId,
        };

        const brickRes = await fetch(`${POST_ORDER_CREDITS}`, {
          method: "POST",
          body: JSON.stringify(info),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Add your token here
          },
        });

        if (brickRes) {
          setShowCredits(false);
          navigate("/profile/billing-info");
        }
        // }
      }
    } catch (e) {
      if (e?.status === 401) {
        navigate("/login");
      }

    }
  };

  const deleteSavedCard = async (selCard) => {
    // http://apiqa.rooftopmeasurements.com/paymentcards/delete-card/{PaymentCardId}/{VaultId}
    const response = await fetch(
      `${BASEURL}paymentcards/delete-card/${selCard?.paymentCardId}/${selCard?.vaultId}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Add your token here
        },
      }
    );
    if (response) {
      handleCardPopupClose();
    }
  };

  const saveChangedDefaultCard = async () => {
    try {
      setLoading(!loading);
      const response = await fetch(
        `${BASEURL}paymentcards/${GetCustomerId}/true/${selectedCard?.paymentCardId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Add your token here
          },
        }
      );
      if (response) {
        // const result = await response.json();
        handleCardPopupClose();
      } else {
        // console.log("failed to update card");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const [customerName, setCustomerName] = useState("");

  const savedCards = async () => {
    const response = await fetch(
      `${GET_ALL_SAVED_CARD_DETAILS}/${GetCustomerId()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${GetToken()}`, // Add your token here
        },
      }
    );
    if (response.ok) {
      const result = await response.json();
      setCustomerName(result.fullName);
      let tempRes = result["paymentCards"];
      tempRes.map((r, rInx) => {
        if ("isDefault" in r) {
          if (r["isDefault"]) {
            "paymentCardId" in r && setSelectedCard(r);
            "cardNumber" in r && setDefaultCardNumber(r["cardNumber"]);
          }
        }
      });
      setAllCards([...result["paymentCards"]]);
    } else {
      // console.error("Failed to fetch data");
    }
  };

  // const checkCreditsAvailabe = () => {
  //   let tempCredits = [...creditSummary]; // Available credits
  //   let allReportsHaveCredits = true; // Assume all have credits
  //   let totalMatchingCreditsCount = 0;

  //   selAddress.forEach((address) => {
  //     console.log("address", address);
  //     let reportType = address?.type?.trim().toUpperCase(); // Handle null/undefined safely
  //     console.log("checking report type", reportType);

  //     if (!reportType) {
  //       console.error("❌ Address type is missing or undefined!", address);
  //       allReportsHaveCredits = false;
  //       return;
  //     }

  //     let matchingCredits = tempCredits.find(
  //       (credit) => credit?.productName?.trim().toUpperCase() === reportType
  //     );
  //     if (matchingCredits) {
  //       totalMatchingCreditsCount++;
  //     }
  //     console.log(
  //       "matchingCredits",
  //       matchingCredits,
  //       totalMatchingCreditsCount
  //     );

  //     if (!matchingCredits) {
  //       console.error(
  //         `❌ No matching credit found for ${reportType}. Available types:`,
  //         tempCredits.map((c) => c.productName)
  //       );
  //       allReportsHaveCredits = false;
  //       return;
  //     }

  //     console.log(
  //       `✅ Checking credits for ${reportType}: Available = ${matchingCredits.overAllRemaining}`
  //     );

  //     if (
  //       matchingCredits.overAllRemaining === undefined ||
  //       matchingCredits.overAllRemaining <= 0 ||
  //       matchingCredits.overAllRemaining < totalMatchingCreditsCount
  //     ) {
  //       console.error(`❌ No credits available for ${reportType}`);
  //       allReportsHaveCredits = false;
  //     }
  //   });

  //   setDisableCreditsRadio(!allReportsHaveCredits);
  // };

const checkCreditsAvailabe = () => {
  let tempCredits = [...creditSummary]; // Available credits
  let allReportsHaveCredits = true; // Assume all have credits

  // Count how many times each report type occurs in selAddress
  const reportTypeCount = {};
  selAddress.forEach((address) => {
    let reportType = address?.type?.trim().toUpperCase();
    if (reportType) {
      reportTypeCount[reportType] = (reportTypeCount[reportType] || 0) + 1;
    }
  });

  selAddress.forEach((address) => {
    let reportType = address?.type?.trim().toUpperCase();

    if (!reportType) {
      // console.error("❌ Address type is missing or undefined!", address);
      allReportsHaveCredits = false;
      return;
    }

    let matchingCredits = tempCredits.find(
      (credit) => credit?.productName?.trim().toUpperCase() === reportType
    );

    if (!matchingCredits) {
      console.error(
        `❌ No matching credit found for ${reportType}. Available types:`,
        tempCredits.map((c) => c.productName)
      );
      allReportsHaveCredits = false;
      return;
    }

    let requiredCount = reportTypeCount[reportType] || 0;

  

    if (
      matchingCredits.overAllRemaining === undefined ||
      matchingCredits.overAllRemaining <= 0 ||
      matchingCredits.overAllRemaining < requiredCount
    ) {
      console.error(`❌ Not enough credits for ${reportType}`);
      allReportsHaveCredits = false;
    }
  });

  setDisableCreditsRadio(!allReportsHaveCredits);
};


  const payWithCredits = (e, force = false) => {
   
    if (creditsApplied && !force) {
      return;
    }
    let allCredits = afterCreditsApply.length > 0 ? [...afterCreditsApply] : [];
    let tempSummary = [...summaryOptions];
    let tempCredits = [...creditSummary];

    tempSummary.forEach((t) => {
      if (t.count > 0) {
        // Find the matching credit for the current item type
        let matchingCredit = tempCredits.find((c) => {
          if (c && c.productName) {
            return c.productName.toUpperCase() === t.type.toUpperCase();
          }
          return false;
        });

        if (matchingCredit) {
          if (matchingCredit.overAllRemaining > 0) {
            if (matchingCredit.overAllRemaining >= t.count) {
              // If credit balance is sufficient, apply the full count
              let temp = { ...t };
              allCredits.push(temp);
            } else if (matchingCredit.overAllRemaining < t.count) {
              // If credit balance is insufficient, adjust the count
              let temp = { ...t };
              temp.count = matchingCredit.overAllRemaining;
              allCredits.push(temp);
            }
          }
        }
      }
    });

    // Calculate the total value of applied credits
    let total = allCredits.reduce((sum, item) => sum + item.value, 0);
    setCreditsTotal(total);
    setAfterCreditsApply([...allCredits]);
    setCreditsApplied(true);
  };

  const getProducts = async () => {
    try {
      setLoadingReports(true);
      let result = await api({
        method: "GET",
        url: "/products",
      });
      const filteredReports = result.filter((item) => item.name !== "EXPANDED");
      setReports(filteredReports);
      let tempH = filteredReports.reduce((prev, current) => {
        return prev.price > current.price ? prev : current;
      });
      let tempBrickH = filteredReports.reduce((prev, current) => {
        return prev.brickPrice > current.brickPrice ? prev : current;
      });
      const tempFIlteredReports = [...filteredReports];
      const sortedByHighestPrice = tempFIlteredReports.sort(
        (a, b) => b.price - a.price
      );
      const firstHighestPrice = sortedByHighestPrice[0];
      const secondHighestPrice = sortedByHighestPrice[1];
      const thirdHighestPrice = sortedByHighestPrice[2];
      const leastPrice = sortedByHighestPrice.at(-1);

      setHighestCostProduct(firstHighestPrice);
      setSecHighest(secondHighestPrice);
      setThirdHighest(thirdHighestPrice);
      setLeastCost(leastPrice);
      setHighestBrickCostProduct({ ...tempBrickH });

      setHighestBrickCostProduct(firstHighestPrice);
      setSecHighestBrickCost(secondHighestPrice);
      setThirdHighestBrickCost(thirdHighestPrice);
      setLeastBrickCost(leastPrice);

      let secH = result.sort((a, b) => a.price - b.price)[1];

      // setSecHighest(secH);
      let secBrickH = result.sort((a, b) => a.brickPrice - b.brickPrice)[1];

      let tempLeast = result.sort((a, b) => a.price - b.price)[0];
      // setLeastCost(tempLeast);
      let tempBrickLeast = result.sort(
        (a, b) => a.brickPrice - b.brickPrice
      )[0];
    } catch (e) {
      if (e?.status === 401) {
        navigate("/login");
      }
      console.log(e);
    } finally {
      setLoadingReports(false);
    }
  };

  const filteredReports = () =>
    reports.filter((item) => item.name !== "EXPANDED");

  const recalcDeliverySummary = (addresses, summary) => {
    summary[4]["count"] = 0;
    summary[4]["value"] = 0;

    let counter = 1;
    for (let p = 0; p < addresses.length; p++) {
      if (addresses[p]["delivery"] && addresses[p]["delivery"] !== "NORMAL") {
        summary[4]["count"] = counter;
        summary[4]["value"] += Number(addresses[p]["deliveryPrice"]);
        counter++;
      }
    }
    return summary;
  };

  const onReportSelect = (addressIndex, selOption) => {
    let addresses = [...selAddress];

    addresses[addressIndex]["type"] = selOption.name;
    addresses[addressIndex]["price"] = selOption.price;

    if (!addresses[addressIndex]["delivery"]) {
      addresses[addressIndex]["delivery"] = "NORMAL";
      addresses[addressIndex]["deliveryPrice"] = 0;
    }

    let summary = [...defaultSummaryOptions];
    for (let p = 0; p < addresses.length; p++) {
      if (addresses[p]["type"] !== "") {
        for (let s = 0; s < summary.length; s++) {
          if (summary[s]["type"]?.toUpperCase() === addresses[p]["type"]) {
            summary[s]["count"] += 1;
            summary[s]["value"] += Number(addresses[p]["price"]);
          }
        }
      }
    }

    summary = recalcDeliverySummary(addresses, summary);

    setSummaryOptions([...summary]);
    setSelAddress([...addresses]);
  };

  const navigateToPurchaseSummary = () => {
    setSearchParams({ step: "2" });
    checkCreditsAvailabe();
  };

  const onDeliveryTypeSelect = (addressIndex, selDelivery) => {
    let addresses = [...selAddress];
    addresses[addressIndex]["delivery"] = selDelivery.label;
    addresses[addressIndex]["deliveryPrice"] =
      selDelivery.label === "NORMAL" ? 0 : selDelivery.price;

    let summary = [...summaryOptions];
    summary = recalcDeliverySummary(addresses, summary);

    setSummaryOptions([...summary]);
    setSelAddress([...addresses]);
  };

  const handleCreditClose = () => {
    setShowCredits(false);
  };

  const onCreditCheckHandler = async () => {
    try {
      let result = await api({
        method: "GET",
        url: `customerbricks/GetAvailableCredits/${customerId}`,
      });
      if (result) {
        const filteredReports = result.filter(
          (item) => item.productName !== "EXPANDED"
        );
        setCreditSummary(filteredReports);

        let brickItems = [];
        result.map((item, index) => {
          let temp = {};
          temp["brickName"] = item.reportType;
          temp["brickCount"] = item.balance;
          brickItems.push(temp);
        });
      }
    } catch (e) {
      console.log(e.status, "error with 401");
    }
  };

  async function filteredCreitsCheckHandler() {
    try {
      setCreditsLoading(!creditsLoading);
      let result = await api({
        method: "GET",
        url: `customerbricks/GetAvailableCredits/${customerId}`,
      });
      if (result) {
        const filteredReports = result.filter(
          (item) => item.productName !== "EXPANDED"
        );
        setFilteredCreditSummary(filteredReports);
      }
    } catch (e) {
      toast.error(e, {
        duration: 6000,
        icon: (
          <FontAwesomeIcon
            style={{
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.6rem"
                : isXlScreen
                ? "1.5rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "0.9rem"
                : isMediumScreen
                ? "1.4rem"
                : "1rem",
            }}
            icon={faCircleExclamation}
          />
        ),
        style: {
          backgroundColor: "#FFC1B4",
          color: "red",
          fontSize: is4kScreen
            ? "1.9rem"
            : isXxlScreen
            ? "1.15rem"
            : isXlScreen
            ? "1rem"
            : isIpadProPortrait
            ? "1.8rem"
            : isLargeScreen
            ? "1rem"
            : isMediumScreen
            ? "1.1rem"
            : "1rem",
          marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
        },
      });
      navigate("/login");
    } finally {
      setCreditsLoading(false);
    }
  }

  const [isBricksPromoApplied, setIsBricksPromoApplied] = useState(false);

  const checkBrickPromo = async () => {
    const url = `${BASEURL}promocodes/promocode-validation`;

    const payloadData = {
      code: brickPromo,
      customerId: customerId,
      appliesOnBrick: true,
    };

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${GetToken()}`,
      },
      body: JSON.stringify(payloadData),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw response;
      })
      .then((data) => {
        setBrickDiscountNotFlag(false);
        if (typeof data === "object") {
          if ("isValid" in data && data["isValid"]) {
            setShowBrickPromoErrorMsg(false);
            const promoFor = data.promoCodeFor;
            const appliesOn = data.appliesOn;
            const discount = data.discount;
            const discountType = data.discountType;
            const promoReportType = data.reportType?.toUpperCase(); // normalize

            if (promoFor === "AccountCredits") {
              if (discountType === "P") {
                if (appliesOn === "singleReport") {
                  setBrickDiscountPerc(discount);
                  sumaryCalAfterBrickDiscount(promoReportType, discount);
                } else if (appliesOn === "entire") {
                  setDiscountPerc(discount);
                  sumaryCalEntireAfterBrickDiscount(promoReportType);
                }
              } else if (discountType === "F") {
                if (appliesOn === "entire") {
                  setDiscount(discount);
                } else if (appliesOn === "singleReport") {
                  if (promoReportType === "ANY") {
                    let basicCredits = buyCreditItems.find(
                      (item) => item.type.toUpperCase() === "BASIC"
                    );
                    let standardCredits = buyCreditItems.find(
                      (item) => item.type.toUpperCase() === "STANDARD"
                    );
                    let comprehensiveCredits = buyCreditItems.find(
                      (item) => item.type.toUpperCase() === "COMPREHENSIVE"
                    );
                    let claimsCredits = buyCreditItems.find(
                      (item) => item.type.toUpperCase() === "CLAIMS"
                    );
                    if (basicCredits.count > 0) {
                      let baseValue = basicCredits.price;
                      let capedValue =
                        data.discount > baseValue ? baseValue : data.discount;
                      setBrickDiscount(capedValue);
                      setIsBricksPromoApplied(true);
                      setShowBrickPromoErrorMsg(false);
                    } else if (standardCredits.count > 0) {
                      let baseValue = standardCredits.price;
                      let capedValue =
                        data.discount > baseValue ? baseValue : data.discount;
                      setBrickDiscount(capedValue);
                      setIsBricksPromoApplied(true);
                      setShowBrickPromoErrorMsg(false);
                    } else if (comprehensiveCredits.count > 0) {
                      let baseValue = comprehensiveCredits.price;
                      let capedValue =
                        data.discount > baseValue ? baseValue : data.discount;
                      setBrickDiscount(capedValue);
                      setIsBricksPromoApplied(true);
                      setShowBrickPromoErrorMsg(false);
                    } else if (claimsCredits.count > 0) {
                      let baseValue = claimsCredits.price;
                      let capedValue =
                        data.discount > baseValue ? baseValue : data.discount;
                      setBrickDiscount(capedValue);
                      setIsBricksPromoApplied(true);
                      setShowBrickPromoErrorMsg(false);
                    } else {
                      setBrickDiscount(0);
                      setIsBricksPromoApplied(false);
                      setShowBrickPromoErrorMsg(true);
                    }
                  } else if (data.reportType.toUpperCase() === "BASIC") {
                    if (buyCreditItems[0].count > 0) {
                      let baseValue = buyCreditItems[0].price;
                      let capedValue =
                        data.discount > baseValue ? baseValue : data.discount;
                      setBrickDiscount(capedValue);
                      setIsBricksPromoApplied(true);
                      setShowBrickPromoErrorMsg(false);
                    } else {
                      setBrickDiscount(0);
                      setIsBricksPromoApplied(false);
                      setShowBrickPromoErrorMsg(true);
                    }
                  } else if (data.reportType.toUpperCase() === "STANDARD") {
                    if (buyCreditItems[1].count > 0) {
                      let baseValue = buyCreditItems[1].price;
                      let capedValue =
                        data.discount > baseValue ? baseValue : data.discount;
                      setBrickDiscount(capedValue);
                      setShowBrickPromoErrorMsg(false);
                      setIsBricksPromoApplied(true);
                    } else {
                      setBrickDiscount(0);
                      setShowBrickPromoErrorMsg(true);
                      setIsBricksPromoApplied(false);
                    }
                  } else if (
                    data.reportType.toUpperCase() === "COMPREHENSIVE"
                  ) {
                    if (buyCreditItems[2].count > 0) {
                      let baseValue = buyCreditItems[2].price;
                      let capedValue =
                        data.discount > baseValue ? baseValue : data.discount;
                      setBrickDiscount(capedValue);
                      setShowBrickPromoErrorMsg(false);
                      setIsBricksPromoApplied(true);
                    } else {
                      setBrickDiscount(0);
                      setShowBrickPromoErrorMsg(true);
                      setIsBricksPromoApplied(false);
                    }
                  } else if (data.reportType.toUpperCase() === "CLAIMS") {
                    if (buyCreditItems[3].count > 0) {
                      let baseValue = buyCreditItems[3].price;
                      let capedValue =
                        data.discount > baseValue ? baseValue : data.discount;
                      setBrickDiscount(capedValue);
                      setShowBrickPromoErrorMsg(false);
                      setIsBricksPromoApplied(true);
                    } else {
                      setBrickDiscount(0);
                      setShowBrickPromoErrorMsg(true);
                      setIsBricksPromoApplied(false);
                    }
                  }
                }
              }
            }
          } else {
            setShowBrickPromoErrorMsg(true); // invalid code
          }
        }
      })
      .catch((error) => {
        console.error("Promo check failed:", error);
        setShowBrickPromoErrorMsg(true); // fallback error handler
      });
  };

  const sumaryCalEntireAfterBrickDiscount = (dis) => {
    if (dis === "any") {
      let temp = buyCreditItems.reduce((accum, item) => {
        if (item.type !== "RUSH") {
          return accum + item.price;
        } else {
          return accum;
        }
      }, 0);
      setBrickDiscount((temp * brickDiscountPerc) / 100);
    } else if (dis.toLowerCase() === "standard") {
      let temp = buyCreditItems.reduce((accum, item) => {
        if (item.type === "STANDARD") {
          return accum + item.price;
        } else {
          return accum;
        }
      }, 0);
      setBrickDiscount((temp * brickDiscountPerc) / 100);
    } else if (dis.toLowerCase() === "expanded") {
      let temp = buyCreditItems.reduce((accum, item) => {
        if (item.type === "Expanded") {
          return accum + item.price;
        } else {
          return accum;
        }
      }, 0);
      setBrickDiscount((temp * brickDiscountPerc) / 100);
    } else if (dis.toLowerCase() === "claims") {
      let temp = buyCreditItems.reduce((accum, item) => {
        if (item.type === "Claims") {
          return accum + item.price;
        } else {
          return accum;
        }
      }, 0);
      setBrickDiscount((temp * brickDiscountPerc) / 100);
    }
  };

  const [discountMataData, setDiscountMetaData] = useState(null);
  const [isPromoApplied, setIsPromoApplied] = useState(false);

  const checkPromo = async () => {
    const url = `${BASEURL}promocodes/promocode-validation`;
    setIsPromoApplied(false);
    const payload = {
      code: promo, // or encodeURIComponent(promo) if needed
      customerId: customerId,
      appliesOnBrick: toggleOrderPromo, // assuming toggleOrderPromo is boolean
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${GetToken()}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw response;
      }

      const data = await response.json();
      setDiscountNotFlag(false);
      if (typeof data === "object") {
        if ("isValid" in data && data["isValid"]) {
          setShowPromoErrorMsg(false);
          setDiscountMetaData(data);
          // Handle percentage discount
          if ("discountType" in data && data["discountType"] === "P") {
            if ("promoCodeFor" in data && data["promoCodeFor"] === "Order") {
              if ("appliesOn" in data && data["appliesOn"] === "singleReport") {
                setDiscountPerc(data["discount"]);
                sumaryCalAfterDiscount(data["reportType"], data["discount"]);
              } else if (
                "appliesOn" in data &&
                data["appliesOn"] === "entire"
              ) {
                setDiscountPerc(data["discount"]);
                sumaryCalEntireAfterDiscount(
                  data["reportType"],
                  data["discount"]
                );
              }
            } else if (
              "promoCodeFor" in data &&
              data["promoCodeFor"].toUpperCase() === "RUSH"
            ) {
              let checkNormalDeliveryReport = selAddress.filter(
                (report) => report.delivery === "NORMAL"
              );
              if (summaryOptions[4].count > 0) {
                setDiscountPerc(data["discount"]);
                if ("appliesOn" in data && data["appliesOn"] === "entire") {
                  let temp = summaryOptions.reduce((accum, item) => {
                    return item.type.toUpperCase() === "RUSH"
                      ? accum + item.value
                      : accum;
                  }, 0);

                  setDiscount((temp * data["discount"]) / 100);
                  if (temp > 0) {
                    setIsPromoApplied(true);
                  } else {
                    setDiscountNotFlag(true);
                  }
                } else {
                  setDiscount((15 * data["discount"]) / 100);
                  setIsPromoApplied(true);
                }
              } else if (checkNormalDeliveryReport) {
                setDiscountNotFlag(true);
                setDiscount(0);
              }
            }
          }

          // Handle fixed discount
          else if ("discountType" in data && data["discountType"] === "F") {
            if ("promoCodeFor" in data && data["promoCodeFor"] === "Order") {
              if ("appliesOn" in data && data["appliesOn"] === "entire") {
                sumaryCalEntireFixedDiscount(
                  data["reportType"],
                  data["discount"]
                );
              } else if (
                "appliesOn" in data &&
                data["appliesOn"] === "singleReport"
              ) {
                if ("reportType" in data) {
                  const reportType = data["reportType"].toUpperCase();
                  const map = {
                    BASIC: 0,
                    STANDARD: 1,
                    CLAIMS: 2,
                    COMPREHENSIVE: 3,
                    RUSH: 4,
                  };
                  if (reportType === "ANY") {
                    let productsToCheck = [
                      highestCostProduct,
                      secHighest,
                      thirdHighest,
                      leastCost,
                    ];
                    for (let product of productsToCheck) {
                      let foundProduct = summaryOptions.find(
                        (s) =>
                          s.count > 0 && s.type.toUpperCase() === product.name
                      );
                      if (foundProduct) {
                        let baseValue = foundProduct.value / foundProduct.count;
                        let capedValue = Math.min(data["discount"], baseValue);
                        setDiscount(capedValue);
                        setIsPromoApplied(true);
                        return;
                      } else {
                        setIsPromoApplied(false);
                      }
                    }
                    setDiscountNotFlag(true);
                    setDiscount(0);
                  } else if (
                    map[reportType] !== undefined &&
                    summaryOptions[map[reportType]].count > 0
                  ) {
                    let baseValue =
                      summaryOptions[map[reportType]].value /
                      summaryOptions[map[reportType]].count;
                    let capedValue = Math.min(data["discount"], baseValue);
                    setDiscount(capedValue);
                    setIsPromoApplied(true);
                  } else {
                    setDiscountNotFlag(true);
                    setDiscount(0);
                    setIsPromoApplied(false);
                  }
                }
              }
            } else if (
              "promoCodeFor" in data &&
              data["promoCodeFor"].toUpperCase() === "RUSH"
            ) {
              let checkNormalDeliveryReport = selAddress.filter(
                (report) => report.delivery === "NORMAL"
              );
              if (summaryOptions[4].count > 0) {
                setDiscountPerc(data["discount"]);
                if ("appliesOn" in data && data["appliesOn"] === "entire") {
                  let temp = summaryOptions.reduce((accum, item) => {
                    return item.type.toUpperCase() === "RUSH"
                      ? accum + item.value
                      : accum;
                  }, 0);
                  const rushDeliveryCount = selAddress.filter(
                    (item) => item.delivery?.toUpperCase() === "RUSH"
                  ).length;

                  let baseValue = temp;
                  let capedValue = Math.min(data["discount"], baseValue);
                  setDiscount(capedValue);
                  if (temp > 0) {
                    setIsPromoApplied(true);
                  } else {
                    setDiscountNotFlag(true);
                  }
                } else {
                  let baseValue = 15;
                  let capedValue = Math.min(data["discount"], baseValue);
                  setDiscount(capedValue);
                  setIsPromoApplied(true);
                }
              } else if (checkNormalDeliveryReport) {
                setDiscountNotFlag(true);
                setDiscount(0);
              }
            }
          } else {
            setDiscount(0);
            setShowPromoErrorMsg(true);
          }
        } else {
          setDiscount(0);

          setDiscountNotFlag(true);
        }
      }
    } catch (e) {
      if (e?.status === 401) {
        navigate("/login");
      }
      console.error("Promo validation error:", e);
    }
  };

  const sumaryCalAfterBrickDiscount = (reportType, discountPercentage) => {
    if (reportType.toLowerCase() === "any") {
      let basicCredits = buyCreditItems.find(
        (item) => item.type.toUpperCase() === "BASIC"
      );

      let standardCredits = buyCreditItems.find(
        (item) => item.type.toUpperCase() === "STANDARD"
      );

      let comprehensiveCredits = buyCreditItems.find(
        (item) => item.type.toUpperCase() === "COMPREHENSIVE"
      );

      let claimsCredits = buyCreditItems.find(
        (item) => item.type.toUpperCase() === "CLAIMS"
      );

      if (basicCredits.count > 0) {
        setBrickDiscount((basicCredits.price * discountPercentage) / 100);
        setIsBricksPromoApplied(true);
        setShowBrickPromoErrorMsg(false);
      } else if (standardCredits.count > 0) {
        setBrickDiscount((standardCredits.price * discountPercentage) / 100);
        setIsBricksPromoApplied(true);
        setShowBrickPromoErrorMsg(false);
      } else if (comprehensiveCredits.count > 0) {
        setBrickDiscount(
          (comprehensiveCredits.price * discountPercentage) / 100
        );
        setIsBricksPromoApplied(true);
        setShowBrickPromoErrorMsg(false);
      } else if (claimsCredits.count > 0) {
        setBrickDiscount((claimsCredits.price * discountPercentage) / 100);
        setIsBricksPromoApplied(true);
        setShowBrickPromoErrorMsg(false);
      } else {
        setBrickDiscount(0);
        setIsBricksPromoApplied(false);

        setShowBrickPromoErrorMsg(true);
      }
    } else if (reportType.toUpperCase() === "BASIC") {
      let tempS = buyCreditItems.filter((s) => {
        if (s.count > 0 && s.type.toUpperCase() === "BASIC") {
          setBrickDiscount((s.price * discountPercentage) / 100);
          setIsBricksPromoApplied(true);
          return s;
        }
      });
      if (tempS.length > 0) {
        setIsBricksPromoApplied(true);
      } else if (!tempS.length) {
        setShowBrickPromoErrorMsg(true);
        setDiscount(0);
        setIsBricksPromoApplied(false);
      }
    } else if (reportType.toUpperCase() === "STANDARD") {
      let tempS = buyCreditItems.filter((s) => {
        if (s.count > 0 && s.type.toUpperCase() === "STANDARD") {
          setBrickDiscount((s.price * discountPercentage) / 100);
          setIsBricksPromoApplied(true);
          return s;
        }
      });
      if (tempS.length > 0) {
        setIsBricksPromoApplied(true);
      } else if (!tempS.length) {
        setDiscount(0);
        setIsBricksPromoApplied(false);
        setShowBrickPromoErrorMsg(true);
      }
    } else if (reportType.toUpperCase() === "COMPREHENSIVE") {
      let tempS = buyCreditItems.filter((s) => {
        if (s.count > 0 && s.type.toUpperCase() === "COMPREHENSIVE") {
          setBrickDiscount((s.price * discountPercentage) / 100);
          setIsBricksPromoApplied(true);
          return s;
        }
      });
      if (tempS.length > 0) {
        setIsBricksPromoApplied(true);
      } else if (!tempS.length) {
        setDiscount(0);
        setIsBricksPromoApplied(false);
        setShowBrickPromoErrorMsg(true);
      }
    } else if (reportType.toUpperCase() === "CLAIMS") {
      let tempS = buyCreditItems.filter((s) => {
        if (s.count > 0 && s.type.toUpperCase() === "CLAIMS") {
          setBrickDiscount((s.price * discountPercentage) / 100);
          setIsBricksPromoApplied(true);
          return s;
        }
      });
      if (tempS.length > 0) {
        setIsBricksPromoApplied(true);
      } else if (!tempS.length) {
        setShowBrickPromoErrorMsg(true);
        setDiscount(0);
        setIsBricksPromoApplied(false);
      }
    } else {
      setBrickDiscount(0);
      setIsBricksPromoApplied(false);
      setShowBrickPromoErrorMsg(true);
    }
  };

  const sumaryCalEntireAfterDiscount = (reportType, discountPercent) => {
    let found = false;
    if (reportType === "any") {
      let temp = summaryOptions.reduce((accum, item) => {
        if (item.type !== "Rush") {
          return accum + item.value;
        } else {
          return accum;
        }
      }, 0);

      if (temp > 0) {
        setIsPromoApplied(true);
        setDiscount((temp * discountPercent) / 100);
        setShowPromoErrorMsg(false);
      } else {
        setIsPromoApplied(false);
        setShowPromoErrorMsg(true);
      }
    } else if (reportType.toUpperCase() === "BASIC") {
      let temp = summaryOptions.reduce((accum, item) => {
        if (item.type === "Basic") {
          return accum + item.value;
        } else {
          return accum;
        }
      }, 0);

      if (temp > 0) {
        setIsPromoApplied(true);
        setDiscount((temp * discountPercent) / 100);
        setShowPromoErrorMsg(false);
      } else {
        setIsPromoApplied(false);
        setShowPromoErrorMsg(true);
      }
    } else if (reportType.toUpperCase() === "STANDARD") {
      let temp = summaryOptions.reduce((accum, item) => {
        if (item.type === "Standard") {
          return accum + item.value;
        } else {
          return accum;
        }
      }, 0);

      if (temp > 0) {
        setIsPromoApplied(true);
        setDiscount((temp * discountPercent) / 100);
        setShowPromoErrorMsg(false);
      } else {
        setIsPromoApplied(false);
        setShowPromoErrorMsg(true);
      }
    } else if (reportType.toUpperCase() === "COMPREHENSIVE") {
      let temp = summaryOptions.reduce((accum, item) => {
        if (item.type === "Comprehensive") {
          return accum + item.value;
        } else {
          return accum;
        }
      }, 0);

      if (temp > 0) {
        setDiscount((temp * discountPercent) / 100);
        setIsPromoApplied(true);
        setShowPromoErrorMsg(false);
      } else {
        setIsPromoApplied(false);
        setShowPromoErrorMsg(true);
      }
    } else if (reportType.toUpperCase() === "CLAIMS") {
      let temp = summaryOptions.reduce((accum, item) => {
        if (item.type === "Claims") {
          return accum + item.value;
        } else {
          return accum;
        }
      }, 0);

      if (temp > 0) {
        setIsPromoApplied(true);
        setDiscount((temp * discountPercent) / 100);
        setShowPromoErrorMsg(false);
      } else {
        setIsPromoApplied(false);
        setShowPromoErrorMsg(true);
      }
    }
  };

  const sumaryCalEntireFixedDiscount = (reportType, fixedDiscountAmount) => {
    if (reportType === "any") {
      let temp = summaryOptions.reduce((accum, item) => {
        return item.type !== "Rush" ? accum + item.value : accum;
      }, 0);
      const nonRushItems = summaryOptions
        .filter((item) => item.type !== "Rush" && item.count > 0)
        .sort((a, b) => b.value - a.value);

      const totalOrderCount = nonRushItems.reduce(
        (sum, item) => sum + item.count,
        0
      );

      if (totalOrderCount === 0) {
        setDiscount(0);
        setIsPromoApplied(false);
        setShowPromoErrorMsg(true);
        return;
      }

      // Step 1: Equal share of discount per unit
      const perUnitDiscount = fixedDiscountAmount / totalOrderCount;
      let appliedDiscount = 0;

      for (const item of nonRushItems) {
        const baseUnitPrice = item.value / item.count; // value = total for all counts
        const cappedUnitDiscount = Math.min(perUnitDiscount, baseUnitPrice);

        // Total discount for this item = unit discount * count
        const totalItemDiscount = cappedUnitDiscount * item.count;

        appliedDiscount += totalItemDiscount;
      }

      if (nonRushItems.length > 0) {
        setIsPromoApplied(true);
        setDiscount(appliedDiscount); // fixed amount, no percent
        setShowPromoErrorMsg(false);
      } else {
        setDiscount(0);
        setIsPromoApplied(false);
        setShowPromoErrorMsg(true);
      }
    } else {
      const typeMap = {
        BASIC: "Basic",
        STANDARD: "Standard",
        COMPREHENSIVE: "Comprehensive",
        CLAIMS: "Claims",
      };

      const matchType = typeMap[reportType.toUpperCase()];
      if (!matchType) {
        console.warn("Invalid report type for fixed discount:", reportType);
        setIsPromoApplied(false);
        setDiscount(0);
        setShowPromoErrorMsg(true);
        return;
      }

      let temp = summaryOptions.reduce((accum, item) => {
        return item.type === matchType ? accum + item.value : accum;
      }, 0);

      let foundItem = summaryOptions.find((s) => s.type === matchType);

      let baseValue = foundItem ? foundItem?.value : 0;

      let capedValue =
        fixedDiscountAmount > baseValue ? baseValue : fixedDiscountAmount;

      if (temp > 0) {
        setIsPromoApplied(true);
        setDiscount(capedValue); // fixed discount
        setShowPromoErrorMsg(false);
      } else {
        setIsPromoApplied(false);
        setDiscount(0);
        setShowPromoErrorMsg(true);
      }
    }
  };

  const sumaryCalAfterDiscount = (reportType, discountPercent) => {
    if (reportType === "any") {
      if (Object.keys(highestCostProduct).length > 0) {
        let productsToCheck = [
          highestCostProduct,
          secHighest,
          thirdHighest,
          leastCost,
        ];
        for (let product of productsToCheck) {
          let foundProduct = summaryOptions.find((s) => {
            return s.count > 0 && s.type.toUpperCase() === product.name;
          });
          if (foundProduct) {
            setDiscount((product.price * discountPercent) / 100);
            setIsPromoApplied(true);
            return;
          }
        }
        // setDiscountNotFlag(true);
        setShowPromoErrorMsg(true);
        setDiscount(0);
      } else {
        setIsPromoApplied(false);
        setShowPromoErrorMsg(true);
      }
    } else if (reportType.toUpperCase() === "BASIC") {
      let tempS = summaryOptions.filter((s) => {
        if (s.count > 0 && s.type.toUpperCase() === "BASIC") {
          setDiscount(((s.value / s.count) * discountPercent) / 100);
          setIsPromoApplied(true);
          return s;
        }
      });
      if (tempS.length > 0) {
        setIsPromoApplied(true);
        setShowPromoErrorMsg(false);
      } else if (!tempS.length) {
        setShowPromoErrorMsg(true);
        setDiscount(0);
        setIsPromoApplied(false);
      }
    } else if (reportType.toUpperCase() === "STANDARD") {
      let tempS = summaryOptions.filter((s) => {
        if (s.count > 0 && s.type.toUpperCase() === "STANDARD") {
          setDiscount(((s.value / s.count) * discountPercent) / 100);
          setIsPromoApplied(true);
          return s;
        }
      });
      if (tempS.length > 0) {
        setIsPromoApplied(true);
        setShowPromoErrorMsg(false);
      } else if (!tempS.length) {
        setShowPromoErrorMsg(true);
        setDiscount(0);
        setIsPromoApplied(false);
      }
    } else if (reportType.toUpperCase() === "COMPREHENSIVE") {
      let tempE = summaryOptions.filter((s) => {
        if (s.count > 0 && s.type.toUpperCase() === "COMPREHENSIVE") {
          setDiscount(((s.value / s.count) * discountPercent) / 100);
          setIsPromoApplied(true);
          return s;
        }
      });
      if (tempE.length > 0) {
        setIsPromoApplied(true);
        setShowPromoErrorMsg(false);
      }
      if (!tempE.length) {
        setShowPromoErrorMsg(true);
        setDiscount(0);
        setIsPromoApplied(false);
      }
    } else if (reportType.toUpperCase() === "CLAIMS") {
      let tempC = summaryOptions.filter((s) => {
        if (s.count > 0 && s.type.toUpperCase() === "CLAIMS") {
          setDiscount(((s.value / s.count) * discountPercent) / 100);
          setIsPromoApplied(true);
          return s;
        }
      });
      if (tempC.length > 0) {
        setIsPromoApplied(true);
        setShowPromoErrorMsg(false);
      }
      if (!tempC.length) {
        setShowPromoErrorMsg(true);
        setDiscount(0);
        setIsPromoApplied(false);
      }
    }
  };

  const brickSelectionHandler = (credit) => {
    setIsBricksPromoApplied(false);
    setIsBricksPromoApplied(false);
    setShowBrickPromoErrorMsg(false);
    setProductId(credit.productId);
    setInputData(1); // Reset quantity to 1

    let temp = { ...selBrickToBuy };
    temp.brickName = credit.name;
    temp.price = credit.brickPrice;
    temp.brickCount = credit.brickQuantity;
    setSelBrickToBuy({
      brickName: credit.name,
      price: credit.brickPrice,
      brickCount: credit.brickQuantity,
    });
    setBrickPromo("");
    setBrickDiscount(0);
    // Call the correct count handler with initial quantity 1
    switch (credit.name) {
      case "BASIC":
        basicCountHandler(1);
        break;
      case "STANDARD":
        standardCountHandler(1);
        break;
      case "CLAIMS":
        claimCountHandler(1);
        break;
      case "COMPREHENSIVE":
        comprehensiveCountHandler(1);
        break;
    }
  };

  const basicCountHandler = (value) => {
    // Clone current credit items
    const cred = [...buyCreditItems];

    // If value is empty, reset everything to 0
    if (!value || isNaN(value)) {
      cred.forEach((c) => { 
        c.count = 0;
        c.price = 0;
      });
      setBuyCreditItems([...cred]);
      return;
    }

    cred.forEach((c) => {
      c.count = 0;
      c.price = 0;
    });

    const resReport = reports.find((option) => option?.name === "BASIC");
    const brickPrice = resReport?.brickPrice || 0;

    cred.forEach((c) => {
      if (c.type === "BASIC") {
        c.count = Number(value) * 10;
        c.price = Number(value) * brickPrice;
      }
    });
    setBuyCreditItems([...cred]);
  };

  const standardCountHandler = (value) => {
    const cred = [...buyCreditItems];
    // If value is empty, reset everything to 0
    if (!value || isNaN(value)) {
      cred.forEach((c) => {
        c.count = 0;
        c.price = 0;
      });
      setBuyCreditItems([...cred]);
      return;
    }

    // Reset all count and price before applying new changes
    cred.forEach((c) => {
      c.count = 0;
      c.price = 0;
    });

    // Get price for STANDARD type
    const resReport = reports.find((option) => option?.name === "STANDARD");
    const brickPrice = resReport?.brickPrice || 0;

    // Update only STANDARD type
    cred.forEach((c) => {
      if (c.type === "STANDARD") {
        c.count = Number(value) * 10;
        c.price = Number(value) * brickPrice;
      }
    });
    setBuyCreditItems([...cred]);
  };

  const claimCountHandler = (value) => {
    const cred = [...buyCreditItems];

    // If value is empty, reset everything to 0
    if (!value || isNaN(value)) {
      cred.forEach((c) => {
        c.count = 0;
        c.price = 0;
      });
      setBuyCreditItems([...cred]);
      return;
    }

    // Reset all count and price before applying new changes
    cred.forEach((c) => {
      c.count = 0;
      c.price = 0;
    });

    // Get price for STANDARD type
    const resReport = reports.find((option) => option?.name === "CLAIMS");
    const brickPrice = resReport?.brickPrice || 0;

    // Update only STANDARD type
    cred.forEach((c) => {
      if (c.type === "CLAIMS") {
        c.count = Number(value) * 10;
        c.price = Number(value) * brickPrice;
      }
    });
    setBuyCreditItems([...cred]);
  };

  const comprehensiveCountHandler = (value) => {
    const cred = [...buyCreditItems];

    if (!value || isNaN(value)) {
      cred.forEach((c) => {
        c.count = 0;
        c.price = 0;
      });
      setBuyCreditItems([...cred]);
      return;
    }

    // Reset all count and price before applying new changes
    cred.forEach((c) => {
      c.count = 0;
      c.price = 0;
    });

    // Get price for STANDARD type
    const resReport = reports.find(
      (option) => option?.name === "COMPREHENSIVE"
    );
    const brickPrice = resReport?.brickPrice || 0;

    // Update only STANDARD type
    cred.forEach((c) => {
      if (c.type === "COMPREHENSIVE") {
        c.count = Number(value) * 10;
        c.price = Number(value) * brickPrice;
      }
    });
    setBuyCreditItems([...cred]);
  };

  const openAddCardPopUp = () => {
    savedCards();
    setShowAddOrRemoveCardPopup(true);
  };

  const handleCardPopupClose = () => {
    setCardName("");
    setCardNumber("");
    setCardExpirationDetails("");
    setIsCardDefault(false);
    setShowAddOrRemoveCardPopup(false);
  };

  const cardSelectHandler = (e, card, ind) => {};

  const isValidCardNumber = (cardNumber) => {
    const digits = cardNumber.replace(/\D/g, ""); // Remove non-digit characters
    let sum = 0;
    let shouldDouble = false;

    // Loop through the digits from right to left
    for (let i = digits.length - 1; i >= 0; i--) {
      let digit = parseInt(digits[i], 10);
      if (shouldDouble) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
      sum += digit;
      shouldDouble = !shouldDouble;
    }

    return sum % 10 === 0;
  };

  // Function to identify the card type based on the first few digits
  const getCardType = (cardNumber) => {
    const patterns = {
      visa: /^4[0-9]{0,}$/, // Visa starts with 4
      mastercard: /^(5[1-5]|2[2-7])/, // Mastercard starts with 51-55 or 22-27
      amex: /^3[47]/, // American Express starts with 34 or 37
      discover: /^6(?:011|5[0-9]{2})/, // Discover starts with 6011, 65
    };

    for (const [cardType, pattern] of Object.entries(patterns)) {
      if (pattern.test(cardNumber)) {
        return cardType;
      }
    }
    return "unknown";
  };

  const handleAddCardSubmit = (event) => {
    event.preventDefault();
    if (!error && cardNumber.replace(/\s/g, "").length >= 13) {
      alert(`Card number is valid: ${cardNumber} (${cardType.toUpperCase()})`);
    } else {
      alert("Please enter a valid card number.");
    }
  };

  const removeCardHandler = (indx) => {
    let updatedAddresses = [...selAddress];
    // updatedAddresses.splice(indx, 1); // remove the address
   
    const newAfterCreditsApply = [...afterCreditsApply];
    const newUpdatedAddresses = updatedAddresses.filter((_, i) => i !== indx);
    const removedAddress = updatedAddresses[indx];

    // Re-initialize summary
    let newSummary = [
      { type: "Basic", count: 0, value: 0 },
      { type: "Standard", count: 0, value: 0 },
      { type: "Claims", count: 0, value: 0 },
      { type: "Comprehensive", count: 0, value: 0 },
      { type: "Rush", count: 0, value: 0 },
    ];
    // Loop through addresses and update counts/values
    for (let addr of newUpdatedAddresses) {
      if (addr.type) {
        const index = newSummary.findIndex(
          (s) => s.type.toUpperCase() === addr.type.toUpperCase()
        );
        if (index !== -1) {
          newSummary[index].count += 1;
          newSummary[index].value += Number(addr.price || 0);
        }
      }
      // Handle delivery summary for 'Rush'
      if (
        addr.delivery &&
        addr.delivery !== "" &&
        addr.delivery.toUpperCase() !== "NORMAL"
      ) {
        const rushIndex = newSummary.findIndex(
          (s) => s.type.toUpperCase() === "RUSH"
        );
        if (rushIndex !== -1) {
          newSummary[rushIndex].count += 1;
          newSummary[rushIndex].value += Number(addr.deliveryPrice || 0);
        }
      }
    }
    // const updatedCredits = newAfterCreditsApply.filter(
    //   (credit) =>
    //     credit.type.toUpperCase() !== removedAddress.type.toUpperCase()

    // );

    const updatedCredits = afterCreditsApply
      .map((credit) => {
        if (credit.type.toUpperCase() === removedAddress.type.toUpperCase()) {
          const newCount = credit.count - 1;
          const newValue = credit.value - Number(removedAddress.price || 0);
          // Only return if count > 0
          if (newCount > 0) {
            return {
              ...credit,
              count: newCount,
              value: newValue,
            };
          } else {
            return null; // Remove this entry if count becomes 0
          }
        }
        return credit; // Keep others
      })
      .filter(Boolean);

    //     let removed = false;
    // const updatedCredits = afterCreditsApply.filter((credit) => {
    //   if (
    //     !removed &&
    //     credit.type.toUpperCase() === removedAddress.type.toUpperCase()
    //   ) {
    //     removed = true; // Skip this one
    //     return false;
    //   }
    //   return true; // Keep others
    // });


    const newCreditsTotal = updatedCredits.reduce(
      (sum, item) => sum + item.value,
      0
    );

    setSelAddress([...newUpdatedAddresses]);
    setSummaryOptions([...newSummary]);
    setAfterCreditsApply(updatedCredits);
    setCreditsTotal(newCreditsTotal);
  };

  const toggleChange = (index) => {
    setTrueToggle((prev) => ({
      ...prev, // Keep the previous state
      [index]: !prev[index] ?? false, // Toggle only the button at the given index
    }));
  };

  const [creditsLoading, setCreditsLoading] = useState(false);

  const placeOrderFromSavedCard = async () => {
    if (EstimateBrickTotal > 0 && allCards.length <= 0) {
      toast.error("Please add a card to continue..!", {
        duration: 6000,
        icon: (
          <FontAwesomeIcon
            style={{
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.6rem"
                : isXlScreen
                ? "1.5rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "0.9rem"
                : isMediumScreen
                ? "1.4rem"
                : "1rem",
            }}
            icon={faCircleExclamation}
          />
        ),
        style: {
          backgroundColor: "#FFC1B4",
          color: "red",
          fontSize: is4kScreen
            ? "1.9rem"
            : isXxlScreen
            ? "1.15rem"
            : isXlScreen
            ? "1rem"
            : isIpadProPortrait
            ? "1.8rem"
            : isLargeScreen
            ? "1rem"
            : isMediumScreen
            ? "1.1rem"
            : "1rem",
          marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
        },
      });
      return;
    }
    if (EstimateBrickTotal > 0) {
      let tempPaymentDetails = {
        customerId: `${customerId}`,
        expMonth: "",
        expYear: "",
        cardName: "",
        cardNumber: "",
        amount: 0,
        saveCard: false,
        makeDefaultCard: false,
        vaultId: "",
        paypalCustomerId: "",
      };
      tempPaymentDetails.amount = EstimateBrickTotal;
      tempPaymentDetails.cardName = selectedCard?.brandName;
      let expDetails = selectedCard?.cardExpiry
        ? selectedCard?.cardExpiry?.split("-")
        : [];

      tempPaymentDetails.expMonth = expDetails.length > 1 ? expDetails[1] : "";
      tempPaymentDetails.expYear = expDetails.length > 0 ? expDetails[0] : "";
      tempPaymentDetails.cardNumber = selectedCard?.cardNumber;
      tempPaymentDetails.vaultId = selectedCard?.vaultId;
      tempPaymentDetails.paypalCustomerId = selectedCard?.paypalCustomerId;
      let temp = {
        paypalRequest: "",
      };
      temp.paypalRequest = encryptKey(JSON.stringify(tempPaymentDetails));
      try {
        setCreditsLoading(!creditsLoading);
        let result = await fetch(`${POST_PAYPAL_PAYMENT}`, {
          method: "POST",
          body: JSON.stringify(temp),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${GetToken()}`, // Add your token here
          },
        });
        const res = await result.json();
        if (result.ok) {
          setPaidTransactionId(res?.transactionId);
          const info = {
            customerId: Number(customerId),
            productId: productId,
            brickPrice: EstimateBrickTotal,
            brickQuantity: quantityOfBrics,
            refundPrice: 0,
            isAutorenew: "No",
            paymentParams: "",
            refundParams: "",
            discount: brickDiscount,
            promotionCode: brickPromo,
            paymentType: "Charge",
            cardLastDigits: res.metadata.cardLastDigits,
            paymentTransactionId: res?.transactionId,
          };
          const brickRes = await fetch(`${POST_ORDER_CREDITS}`, {
            method: "POST",
            body: JSON.stringify(info),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${GetToken()}`, // Add your token here
            },
          });

          const resData = await brickRes.json();
          if (brickRes.ok) {
            toast.success("Credits Purchase Success", {
              duration: 6000,
              icon: (
                <FontAwesomeIcon
                  style={{
                    color: "green",
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.6rem"
                      : isXlScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "0.9rem"
                      : isMediumScreen
                      ? "1.4rem"
                      : "1rem",
                  }}
                  icon={faCircleCheck}
                />
              ),
              style: {
                backgroundColor: "#E7EFC7",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
                marginTop: is4kScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : "",
              },
            });
            setShowCredits(false);
            onReportsHandler();
            filteredCreitsCheckHandler();
            checkCreditsAvailabe();
            onCreditCheckHandler();
            setIsBricksPromoApplied(false);
            setShowBrickPromoErrorMsg(false);
            setBrickDiscount(0);
            setBrickPromo("");
          } else {
            toast.error(resData?.message || "Failed to purchase credits.", {
              duration: 6000,
              icon: (
                <FontAwesomeIcon
                  style={{
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.6rem"
                      : isXlScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "0.9rem"
                      : isMediumScreen
                      ? "1.4rem"
                      : "1rem",
                  }}
                  icon={faCircleExclamation}
                />
              ),
              style: {
                backgroundColor: "#FFC1B4",
                color: "red",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
                marginTop: is4kScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : "",
              },
            });
          }
          // }
          setInputData(0);
          setSelBrickToBuy({});
          setBuyCreditItems((prev) =>
            prev.map((item) => ({ ...item, count: 0, price: 0 }))
          );
        }
        checkCreditsAvailabe();
      } catch (e) {
        if (e?.status === 401) {
          navigate("/login");
        }

        toast.error(e, {
          duration: 6000,
          icon: (
            <FontAwesomeIcon
              style={{
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.6rem"
                  : isXlScreen
                  ? "1.5rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "0.9rem"
                  : isMediumScreen
                  ? "1.4rem"
                  : "1rem",
              }}
              icon={faCircleExclamation}
            />
          ),
          style: {
            backgroundColor: "#FFC1B4",
            color: "red",
            fontSize: is4kScreen
              ? "1.9rem"
              : isXxlScreen
              ? "1.15rem"
              : isXlScreen
              ? "1rem"
              : isIpadProPortrait
              ? "1.8rem"
              : isLargeScreen
              ? "1rem"
              : isMediumScreen
              ? "1.1rem"
              : "1rem",
            marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
          },
        });
      } finally {
        setCreditsLoading(false);
      }
    } else if (brickPromo && EstimateBrickTotal <= 0) {
      const info = {
        customerId: Number(customerId),
        productId: productId,
        brickPrice: EstimateBrickTotal,
        brickQuantity: quantityOfBrics,
        refundPrice: 0,
        isAutorenew: "No",
        paymentParams: "",
        refundParams: "",
        discount: brickDiscount,
        promotionCode: brickPromo,
        paymentType: "Promo",
        cardLastDigits: null,
        paymentTransactionId: null,
      };

      try {
        setCreditsLoading(!creditsLoading);

        const brickRes = await fetch(`${POST_ORDER_CREDITS}`, {
          method: "POST",
          body: JSON.stringify(info),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${TOKEN}`, // Add your token here
          },
        });

        if (brickRes.ok) {
          toast.success("Credits Purchase Successful", {
            duration: 6000,
            icon: (
              <FontAwesomeIcon
                style={{
                  color: "green",
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isXxlScreen
                    ? "1.15rem"
                    : isXlScreen
                    ? "1rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "1rem"
                    : isMediumScreen
                    ? "1.1rem"
                    : "1rem",
                }}
                icon={faCircleCheck}
              />
            ),
            style: {
              backgroundColor: "#E7EFC7",
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.15rem"
                : isXlScreen
                ? "1rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "1rem"
                : isMediumScreen
                ? "1.1rem"
                : "1rem",
              marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
            },
          });
          setBrickPromo("");
          setBrickDiscount(0);
          setShowCredits(false);
          setIsBricksPromoApplied(false);
          setShowBrickPromoErrorMsg(false);
          setBrickDiscount(0);
          setBrickPromo("");
          onReportsHandler();
          onCreditCheckHandler();
          setInputData(0);
          setSelBrickToBuy({});
          setBuyCreditItems((prev) =>
            prev.map((item) => ({ ...item, count: 0, price: 0 }))
          );
        } else {
          toast.error("Credits Purchase Failed..!", {
            duration: 6000,
            icon: (
              <FontAwesomeIcon
                style={{
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isXxlScreen
                    ? "1.15rem"
                    : isXlScreen
                    ? "1rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "1rem"
                    : isMediumScreen
                    ? "1.1rem"
                    : "1rem",
                }}
                icon={faCircleExclamation}
              />
            ),
            style: {
              backgroundColor: "#FFC1B4",
              color: "red",
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.15rem"
                : isXlScreen
                ? "1rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "1rem"
                : isMediumScreen
                ? "1.1rem"
                : "1rem",
              marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
            },
          });
        }
      } catch (e) {
        console.log(e);
      } finally {
        setCreditsLoading(false);
      }
    } else if (EstimateBrickTotal < 0) return;
  };

  const placeOrderFromNewCard = async () => {
    const cardNum = cardNumber.replace(/\s/g, "");
    const [expMonth, expYear] = cardExpirationDetails.split("/");
    const yearPrefix = new Date().getFullYear();
    const stringfiedYearPrefix = yearPrefix.toString().slice(0, 2);
    const expiry = stringfiedYearPrefix + expYear;

    if (EstimateBrickTotal > 0) {
      let tempPaymentDetails = {
        customerId: `${customerId}`,
        expMonth: `${expMonth}`,
        expYear: `${expiry}`,
        cardName: `${cardName}`,
        cardNumber: `${cardNum}`,
        amount: 0,
        saveCard: `${saveCard}`,
        makeDefaultCard: `${makeDefaultCard}`,
        vaultId: "",
        paypalCustomerId: "",
      };
      tempPaymentDetails.amount = EstimateBrickTotal;

      let temp = {
        paypalRequest: "",
      };
      temp.paypalRequest = encryptKey(JSON.stringify(tempPaymentDetails));

      try {
        setCreditsLoading(!creditsLoading);

        let result = await fetch(`${POST_PAYPAL_PAYMENT}`, {
          method: "POST",
          body: JSON.stringify(temp),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${GetToken()}`, // Add your token here
          },
        });

        const res = await result.json();
        if (result.ok) {
          setPaidTransactionId(res?.transactionId);
          const info = {
            customerId: Number(customerId),
            productId: productId,
            brickPrice: EstimateBrickTotal,
            brickQuantity: quantityOfBrics,
            refundPrice: 0,
            isAutorenew: "No",
            paymentParams: "",
            refundParams: "",
            discount: brickDiscount,
            promotionCode: brickPromo,
            paymentType: "Charge",
            cardLastDigits: res.metadata.cardLastDigits,
            paymentTransactionId: res?.transactionId,
          };

          const brickRes = await fetch(`${POST_ORDER_CREDITS}`, {
            method: "POST",
            body: JSON.stringify(info),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${GetToken()}`, // Add your token here
            },
          });
          const resData = await brickRes.json();
          if (brickRes.ok) {
            toast.success("Credits Purchase Success", {
              duration: 6000,
              icon: (
                <FontAwesomeIcon
                  style={{
                    color: "green",
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.6rem"
                      : isXlScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "0.9rem"
                      : isMediumScreen
                      ? "1.4rem"
                      : "1rem",
                  }}
                  icon={faCircleCheck}
                />
              ),
              style: {
                backgroundColor: "#E7EFC7",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
                marginTop: is4kScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : "",
              },
            });
            setShowCredits(false);
            onReportsHandler();
            filteredCreitsCheckHandler();
            checkCreditsAvailabe();
            savedCards();
            setCardName("");
            setCardNumber("");
            setCardExpirationDetails("");
            onCreditCheckHandler();
            setIsBricksPromoApplied(false);
            setShowBrickPromoErrorMsg(false);
            setBrickDiscount(0);
            setBrickPromo("");
          } else {
            toast.error(resData?.message || "Failed to purchase credits.", {
              duration: 6000,
              icon: (
                <FontAwesomeIcon
                  style={{
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.6rem"
                      : isXlScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "0.9rem"
                      : isMediumScreen
                      ? "1.4rem"
                      : "1rem",
                  }}
                  icon={faCircleExclamation}
                />
              ),
              style: {
                backgroundColor: "#FFC1B4",
                color: "red",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
                marginTop: is4kScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : "",
              },
            });
          }
          // }
          setInputData(0);
          setSelBrickToBuy({});
          setBuyCreditItems((prev) =>
            prev.map((item) => ({ ...item, count: 0, price: 0 }))
          );
        } else {
          toast.error(res?.message || "Payment failed. Please try again.", {
            duration: 6000,
            icon: (
              <FontAwesomeIcon
                style={{
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isXxlScreen
                    ? "1.6rem"
                    : isXlScreen
                    ? "1.5rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "0.9rem"
                    : isMediumScreen
                    ? "1.4rem"
                    : "1rem",
                }}
                icon={faCircleExclamation}
              />
            ),
            style: {
              backgroundColor: "#FFC1B4",
              color: "red",
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.15rem"
                : isXlScreen
                ? "1rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "1rem"
                : isMediumScreen
                ? "1.1rem"
                : "1rem",
              marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
            },
          });
        }
        checkCreditsAvailabe();
      } catch (e) {
        if (e?.status === 401) {
          navigate("/login");
        }
        toast.error(e, {
          duration: 6000,
          icon: (
            <FontAwesomeIcon
              style={{
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.6rem"
                  : isXlScreen
                  ? "1.5rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "0.9rem"
                  : isMediumScreen
                  ? "1.4rem"
                  : "1rem",
              }}
              icon={faCircleExclamation}
            />
          ),
          style: {
            backgroundColor: "#FFC1B4",
            color: "red",
            fontSize: is4kScreen
              ? "1.9rem"
              : isXxlScreen
              ? "1.15rem"
              : isXlScreen
              ? "1rem"
              : isIpadProPortrait
              ? "1.8rem"
              : isLargeScreen
              ? "1rem"
              : isMediumScreen
              ? "1.1rem"
              : "1rem",
            marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
          },
        });
      } finally {
        setCreditsLoading(false);
      }
    } else if (brickPromo && EstimateBrickTotal <= 0) {
      try {
        setCreditsLoading(!creditsLoading);
        const info = {
          customerId: Number(customerId),
          productId: productId,
          brickPrice: EstimateBrickTotal,
          brickQuantity: quantityOfBrics,
          refundPrice: 0,
          isAutorenew: "No",
          paymentParams: "",
          refundParams: "",
          discount: brickDiscount,
          promotionCode: brickPromo,
          paymentType: "Promo",
          cardLastDigits: null,
          paymentTransactionId: null,
        };

        const brickRes = await fetch(`${POST_ORDER_CREDITS}`, {
          method: "POST",
          body: JSON.stringify(info),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${GetToken()}`, // Add your token here
          },
        });

        const resData = await brickRes.json();
        if (brickRes.ok) {
          toast.success("Credits Purchase Success", {
            duration: 6000,
            icon: (
              <FontAwesomeIcon
                style={{
                  color: "green",
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isXxlScreen
                    ? "1.6rem"
                    : isXlScreen
                    ? "1.5rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "0.9rem"
                    : isMediumScreen
                    ? "1.4rem"
                    : "1rem",
                }}
                icon={faCircleCheck}
              />
            ),
            style: {
              backgroundColor: "#E7EFC7",
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.15rem"
                : isXlScreen
                ? "1rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "1rem"
                : isMediumScreen
                ? "1.1rem"
                : "1rem",
              marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
            },
          });
          setShowCredits(false);
          onReportsHandler();
          filteredCreitsCheckHandler();
          checkCreditsAvailabe();
          savedCards();
          setCardName("");
          setCardNumber("");
          setCardExpirationDetails("");
          onCreditCheckHandler();
          setIsBricksPromoApplied(false);
          setShowBrickPromoErrorMsg(false);
          setBrickDiscount(0);
          setBrickPromo("");
        } else {
          toast.error(resData?.message || "Failed to purchase credits.", {
            duration: 6000,
            icon: (
              <FontAwesomeIcon
                style={{
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isXxlScreen
                    ? "1.6rem"
                    : isXlScreen
                    ? "1.5rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "0.9rem"
                    : isMediumScreen
                    ? "1.4rem"
                    : "1rem",
                }}
                icon={faCircleExclamation}
              />
            ),
            style: {
              backgroundColor: "#FFC1B4",
              color: "red",
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.15rem"
                : isXlScreen
                ? "1rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "1rem"
                : isMediumScreen
                ? "1.1rem"
                : "1rem",
              marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
            },
          });
        }
        setInputData(0);
        setSelBrickToBuy({});
        setBuyCreditItems((prev) =>
          prev.map((item) => ({ ...item, count: 0, price: 0 }))
        );
        checkCreditsAvailabe();
      } catch (e) {
        if (e?.status === 401) {
          navigate("/login");
        }
        console.log(e);
        toast.error(e, {
          duration: 6000,
          icon: (
            <FontAwesomeIcon
              style={{
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.6rem"
                  : isXlScreen
                  ? "1.5rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "0.9rem"
                  : isMediumScreen
                  ? "1.4rem"
                  : "1rem",
              }}
              icon={faCircleExclamation}
            />
          ),
          style: {
            backgroundColor: "#FFC1B4",
            color: "red",
            fontSize: is4kScreen
              ? "1.9rem"
              : isXxlScreen
              ? "1.15rem"
              : isXlScreen
              ? "1rem"
              : isIpadProPortrait
              ? "1.8rem"
              : isLargeScreen
              ? "1rem"
              : isMediumScreen
              ? "1.1rem"
              : "1rem",
            marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
          },
        });
      } finally {
        setCreditsLoading(false);
      }
    }
  };

  const handleChooseCardPaymentType = () => {
    if (selectCardType === "savedCard") {
      placeOrderFromSavedCard();
    } else if (selectCardType === "addCard") {
      if (saveCard && allCards.length >= 5) {
        toast.error("Cannot Add more than 5 cards", {
          style: {
            backgroundColor: "#FFC1B4",
            color: "red",
            fontSize: is4kScreen
              ? "1.9rem"
              : isXxlScreen
              ? "1.15rem"
              : isXlScreen
              ? "1rem"
              : isIpadProPortrait
              ? "1.8rem"
              : isLargeScreen
              ? "1rem"
              : isMediumScreen
              ? "1.1rem"
              : "1rem",
          },
        });
        return;
      }
      placeOrderFromNewCard();
    }
  };

  const changePrimaryCard = async (e, selIndex) => {
    let tempAllCards = allCards.length > 0 ? [...allCards] : [];
    if (tempAllCards.length && tempAllCards.length >= selIndex) {
      let selCard = tempAllCards[selIndex];
      selCard["isDefault"] = true;
      setSelectedCard(selCard);
      try {
        setChanegCardLoading(!changeCardLoading);
        const response = await fetch(
          `${BASEURL}paymentcards/${CUSTOMERID}/true/${selCard.paymentCardId}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${GetToken()}`, // Add your TOKEN here
            },
          }
        );

        tempAllCards[selIndex] = selCard;
        if (response) {
          savedCards();
        }
      } catch (err) {
        console.log(err);
        toast.error(e, {
          duration: 6000,
          icon: (
            <FontAwesomeIcon
              style={{
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.6rem"
                  : isXlScreen
                  ? "1.5rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "0.9rem"
                  : isMediumScreen
                  ? "1.4rem"
                  : "1rem",
              }}
              icon={faCircleExclamation}
            />
          ),
          style: {
            backgroundColor: "#FFC1B4",
            color: "red",
            fontSize: is4kScreen
              ? "1.9rem"
              : isXxlScreen
              ? "1.15rem"
              : isXlScreen
              ? "1rem"
              : isIpadProPortrait
              ? "1.8rem"
              : isLargeScreen
              ? "1rem"
              : isMediumScreen
              ? "1.1rem"
              : "1rem",
            marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
          },
        });
      } finally {
        setChanegCardLoading(false);
      }
    }
    setAllCards([...tempAllCards]);
  };

  async function onReportsHandler() {
    try {
      setLoading(!loading);
      let result = await api({
        method: "GET",
        url: "/products",
      });

      const filteredReports = result.filter((item) => item.name !== "EXPANDED");
      setCCFilteredReports(filteredReports);
    } catch (e) {
      if (e?.status === 401) {
        navigate("/login");
      }
    } finally {
      setLoading(false);
    }
  }

  const handleIncrement = () => {
    if (!selBrickToBuy?.brickName) return; // Ensure a brick is selected
    const newValue = Number(inputData) + 1;
    setInputData(newValue);

    switch (selBrickToBuy.brickName) {
      case "BASIC":
        basicCountHandler(newValue);
        break;
      case "STANDARD":
        standardCountHandler(newValue);
        break;
      case "CLAIMS":
        claimCountHandler(newValue);
        break;
      case "COMPREHENSIVE":
        comprehensiveCountHandler(newValue);
        break;
    }
  };

  const handleDecrement = () => {
    if (!selBrickToBuy?.brickName || inputData <= 1) return; // Prevent decrementing below zero
    const newValue = inputData - 1;
    setInputData(newValue);

    switch (selBrickToBuy.brickName) {
      case "BASIC":
        basicCountHandler(newValue);
        break;
      case "STANDARD":
        standardCountHandler(newValue);
        break;
      case "CLAIMS":
        claimCountHandler(newValue);
        break;
      case "COMPREHENSIVE":
        comprehensiveCountHandler(newValue);
        break;
    }
  };

  useEffect(() => {
    let tempAddr = [...selAddress];
    const reportType = discountMataData?.reportType?.toUpperCase();
    const promoType = discountMataData?.promoCodeFor;
    const appliesOn = discountMataData?.appliesOn;
    const discountType = discountMataData?.discountType;
    const promoCodeFor = discountMataData?.promoCodeFor;

    // Determine which addresses match the report type
    let matchedAddresses = [];
    if (appliesOn === "entire") {
      matchedAddresses = tempAddr.filter(
        (addr) => addr.type.toUpperCase() === reportType
      );
    } else if (appliesOn === "singleReport") {
      const firstMatch = tempAddr.find(
        (addr) => addr.type.toUpperCase() === reportType
      );
      if (firstMatch) matchedAddresses = [firstMatch];
    }

    // Determine the highest cost product
    let highestProduct = null;
    if (Object.keys(highestCostProduct).length > 0) {
      const productsToCheck = [
        highestCostProduct,
        secHighest,
        thirdHighest,
        leastCost,
      ];
      for (let product of productsToCheck) {
        const foundProduct = summaryOptions.find(
          (s) => s.count > 0 && s.type.toUpperCase() === product.name
        );
        if (foundProduct) {
          highestProduct = foundProduct.type;
          break;
        }
      }
    }

    const discountedItems =
      discountMataData &&
      tempAddr.map((item) => {
        return item.price - (item.price * discountMataData?.discount) / 100;
      });
    // ✅ Flag to apply promo only once for single report
    let promoApplied = false;

    tempAddr.forEach((addrVal, ind) => {
      const isMatched = matchedAddresses.some(
        (addr) => addr.type.toUpperCase() === addrVal?.type?.toUpperCase()
      );

      let promoCode = null;
      let calculatedDiscount = 0;
      let calculatedTotalPrice = 0;
      const discountedItems =
        discountMataData &&
        tempAddr.map((item) => {
          return (item.price * discountMataData?.discount) / 100;
        });
      const sameEntireItem = matchedAddresses.map((item) => {
        return (item.price * discountMataData?.discount) / 100;
      });
      const discountedDeliveryPrice =
        discountMataData &&
        tempAddr.map(
          (item) => (item.deliveryPrice * discountMataData?.discount) / 100
        );
      const dicountedFixedItems =
        discountMataData &&
        tempAddr.map((item) => {
          return discountMataData?.discount / selAddress.length;
        });
      const fixedItemsDeliveryPrice =
        discountMataData &&
        tempAddr.map((item) => discountMataData?.discount / selAddress.length);

      const sameEntireFixedItem = matchedAddresses.map((item) => {
        return discountMataData?.discount / matchedAddresses.length;
      });

      // === Percent Discount Logic ===
      if (discountType === "P") {
        if (appliesOn === "entire" && promoType === "Order") {
          if (reportType === "ANY") {
            promoCode = promo;
            calculatedDiscount = discountedItems[ind];
            calculatedTotalPrice =
              Number(addrVal?.price) +
              Number(addrVal?.deliveryPrice) -
              Number(discountedItems[ind]);
          } else if (
            reportType === addrVal?.type &&
            matchedAddresses.length >= 1
            //  &&
            // isMatched
          ) {
            promoCode = promo;
            calculatedDiscount = sameEntireItem[0];
            calculatedTotalPrice =
              Number(addrVal?.price) +
              Number(addrVal?.deliveryPrice) -
              sameEntireItem[0];
          } else {
            promoCode = null;
            calculatedDiscount = 0;
            calculatedTotalPrice =
              Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
          }
        } else if (appliesOn === "entire" && promoCodeFor === "Rush") {
          promoCode = promo;
          calculatedDiscount = discountedDeliveryPrice[ind];
          calculatedTotalPrice =
            Number(addrVal?.price) +
            Number(addrVal?.deliveryPrice) -
            discountedDeliveryPrice[ind];
        } else if (appliesOn === "singleReport" && promoType === "Order") {
          if (reportType === "ANY") {
            if (
              highestProduct &&
              highestProduct.toUpperCase() === addrVal?.type &&
              !promoApplied
            ) {
              promoCode = promo;
              calculatedDiscount = discount;
              calculatedTotalPrice =
                Number(addrVal?.price) +
                Number(addrVal?.deliveryPrice) -
                (addrVal.deliveryPrice * discountMataData?.discount) / 100;
              promoApplied = true;
            } else {
              promoCode = null;
              calculatedDiscount = 0;
              calculatedTotalPrice =
                Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
            }
          } else if (reportType === addrVal?.type && !promoApplied) {
            promoCode = promo;
            calculatedDiscount = discount;
            calculatedTotalPrice =
              Number(addrVal?.price) +
              Number(addrVal?.deliveryPrice) -
              discount;
            promoApplied = true;
          } else {
            calculatedTotalPrice =
              Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
          }
        } else if (appliesOn === "singleReport" && promoCodeFor === "Rush") {
          if (
            highestProduct.toUpperCase() === addrVal?.type &&
            discountMataData?.appliesOn === "singleReport" &&
            !promoApplied
          ) {
            promoCode = promo;
            calculatedDiscount = 15 * (discountMataData?.discount / 100);
            calculatedTotalPrice =
              Number(addrVal?.price) +
              Number(addrVal?.deliveryPrice) -
              calculatedDiscount;
            promoApplied = true;
          }
        }
      }

      // === Flat Discount Logic ===
      if (discountType === "F") {
        if (appliesOn === "entire" && promoType === "Order") {
          if (reportType === "ANY") {
            promoCode = promo;
            calculatedDiscount = Math.min(
              addrVal?.price,
              dicountedFixedItems[ind]
            );
            calculatedTotalPrice =
              Number(addrVal?.price) +
              Number(addrVal?.deliveryPrice) -
              calculatedDiscount;
          } else if (
            reportType === addrVal?.type &&
            matchedAddresses?.length >= 1 &&
            isMatched
          ) {
            promoCode = promo;
            calculatedDiscount = sameEntireFixedItem[ind];
            calculatedTotalPrice =
              Number(addrVal?.price) +
              Number(addrVal?.deliveryPrice) -
              sameEntireItem[ind];
          } else {
            promoCode = null;
            calculatedDiscount = 0;
            calculatedTotalPrice =
              Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
          }
        } else if (appliesOn === "entire" && promoCodeFor === "Rush") {
          promoCode = promo;
          let temp = summaryOptions.reduce((accum, item) => {
            return item.type.toUpperCase() === "RUSH"
              ? accum + item.value
              : accum;
          }, 0);
          let baseValue = temp;

          let capedValue = Math.min(fixedItemsDeliveryPrice[ind], 15);

          calculatedDiscount = capedValue;

          calculatedTotalPrice =
            Number(addrVal?.price) +
            Number(addrVal?.deliveryPrice) -
            calculatedDiscount;
        } else if (appliesOn === "singleReport" && promoType === "Order") {
          if (reportType === "ANY") {
            if (
              highestProduct &&
              highestProduct.toUpperCase() === addrVal?.type &&
              !promoApplied
            ) {
              let foundProduct = summaryOptions.find(
                (item) =>
                  item.type.toUpperCase() === highestProduct.toUpperCase()
              );

              if (!foundProduct) {
                promoCode = null;
                calculatedDiscount = 0;
                calculatedTotalPrice =
                  Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
                return;
              }

              promoCode = promo;
              let unitPrice = foundProduct.value / foundProduct.count;
              calculatedDiscount = Math.min(
                discountMataData?.discount,
                unitPrice
              );
              calculatedTotalPrice =
                Number(addrVal?.price) +
                Number(addrVal?.deliveryPrice) -
                calculatedDiscount;
              promoApplied = true;
            }
          } else if (reportType === addrVal?.type && !promoApplied) {
            let foundProduct = summaryOptions.find(
              (item) => item.type === addrVal?.type
            );

            if (!foundProduct) {
              promoCode = null;
              calculatedDiscount = 0;
              calculatedTotalPrice =
                Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
              return;
            }

            promoCode = promo;
            let unitPrice = foundProduct.value / foundProduct.count;
            calculatedDiscount = Math.min(
              discountMataData?.discount,
              unitPrice
            );
            calculatedTotalPrice =
              Number(addrVal?.price) +
              Number(addrVal?.deliveryPrice) -
              calculatedDiscount;
            promoApplied = true;
          }
        } else if (appliesOn === "singleReport" && promoCodeFor === "Rush") {
          if (
            highestProduct.toUpperCase() === addrVal?.type &&
            discountMataData?.appliesOn === "singleReport" &&
            !promoApplied
          ) {
            promoCode = promo;
            calculatedDiscount = discountMataData?.discount;
            calculatedTotalPrice =
              Number(addrVal?.price) +
              Number(addrVal?.deliveryPrice) -
              calculatedDiscount;
            promoApplied = true;
          }
        }
      }

      // === Build Final Address Object ===
      const addr = {
        streetAddress: addrVal?.street || "",
        city: addrVal?.city || "",
        state: addrVal?.state || "",
        zip: addrVal?.postalCode || "",
        lat: addrVal?.lat ? String(addrVal.lat) : "",
        lon: addrVal?.lng ? String(addrVal.lng) : "",
        type: addrVal?.type,
        claimProjectNo: "",
        itemPrice: onPayBtnSel === 0 ? 0 : addrVal?.price,
        deliveryPrice: 0,
        totalPrice: calculatedTotalPrice,
        delivery: addrVal?.delivery,
        quantity: 1,
        promotionCode: promoCode,
        // promoTest: promoCode,
        paymentType: onPayBtnSel,
        discount: calculatedDiscount,
        ccEmail: "",
        teamNote: "",
      };
    });
  }, [discountMataData]);

  const [isPromoAppliedState, setIsPromoAppliedState] = useState(null);
  useEffect(() => {
    setIsPromoAppliedState(isPromoApplied);
  }, [isPromoApplied]);

  const placeOrderFromSavedCardHandler = async () => {
    // credits payment
    if (onPayBtnSel === 0) {
      if (EstimatedTotal > 0) {
        if (EstimatedTotal > 0 && allCards.length <= 0) {
          toast.error("Please add a card to continue..!", {
            duration: 6000,
            icon: (
              <FontAwesomeIcon
                style={{
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isXxlScreen
                    ? "1.6rem"
                    : isXlScreen
                    ? "1.5rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "0.9rem"
                    : isMediumScreen
                    ? "1.4rem"
                    : "1rem",
                }}
                icon={faCircleExclamation}
              />
            ),
            style: {
              backgroundColor: "#FFC1B4",
              color: "red",
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.15rem"
                : isXlScreen
                ? "1rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "1rem"
                : isMediumScreen
                ? "1.1rem"
                : "1rem",
              marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
            },
          });
          return;
        }
        if (!selectedCard) {
          toast.error("Please select a card to continue..!", {
            duration: 6000,
            icon: (
              <FontAwesomeIcon
                style={{
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isXxlScreen
                    ? "1.6rem"
                    : isXlScreen
                    ? "1.5rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "0.9rem"
                    : isMediumScreen
                    ? "1.4rem"
                    : "1rem",
                }}
                icon={faCircleExclamation}
              />
            ),
            style: {
              backgroundColor: "#FFC1B4",
              color: "red",
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.15rem"
                : isXlScreen
                ? "1rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "1rem"
                : isMediumScreen
                ? "1.1rem"
                : "1rem",
              marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
            },
          });
          return;
        }
        let tempPaymentDetails = {
          customerId: `${customerId}`,
          expMonth: "",
          expYear: "",
          cardName: "",
          cardNumber: "",
          amount: 0,
          saveCard: false,
          makeDefaultCard: false,
          vaultId: "",
          paypalCustomerId: "",
        };
        tempPaymentDetails.amount = EstimatedTotal;
        tempPaymentDetails.cardName = customerName;
        let expDetails = selectedCard?.cardExpiry
          ? selectedCard?.cardExpiry.split("-")
          : [];
        tempPaymentDetails.expMonth =
          expDetails.length > 1 ? expDetails[1] : "";
        tempPaymentDetails.expYear = expDetails.length > 0 ? expDetails[0] : "";
        tempPaymentDetails.cardNumber = selectedCard?.cardNumber;
        tempPaymentDetails.vaultId = selectedCard?.vaultId;
        tempPaymentDetails.paypalCustomerId = selectedCard?.paypalCustomerId;
        let temp = {
          paypalRequest: "",
        };
        temp.paypalRequest = encryptKey(JSON.stringify(tempPaymentDetails));
        try {
          setPaymentLoading(!paymentLoading);
          let result = await fetch(`${POST_PAYPAL_PAYMENT}`, {
            method: "POST",
            // body: JSON.stringify(tempPaymentDetails),
            body: JSON.stringify(temp),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${GetToken()}`, // Add your token here
            },
          });
          const res = await result.json();
          if (result.ok) {
            if (
              "isSuccess" in res &&
              "paymentStatus" in res &&
              res?.paymentStatus === "COMPLETED"
            ) {
              "transactionId" in res &&
                setPaidTransactionId(res["transactionId"]);
              let tempFormattedAddr = [];

              let tempAddr = [...selAddress];

              if (tempAddr.length > 0) {
                tempAddr.forEach((addrVal, ind) => {
                  let addr = {
                    streetAddress: "",
                    city: "",
                    state: "",
                    zip: "",
                    lat: "",
                    lon: "",
                    type: "",
                    claimProjectNo: "",
                    itemPrice: 0,
                    deliveryPrice: 0,
                    totalPrice: 0,
                    delivery: "",
                    quantity: 1,
                    promotionCode: "",
                    paymentType: onPayBtnSel,
                    discount: 0,
                    ccEmail: "",
                    teamNote: "",
                  };

                  addr.streetAddress = addrVal?.street;
                  addr.city = addrVal?.city;
                  addr.state = addrVal?.state;
                  addr.zip = addrVal?.postalCode;
                  let len = String(addrVal?.address).length;
                  addr.lat = addrVal?.lat ? String(addrVal?.lat) : "";
                  addr.lon = addrVal?.lng ? String(addrVal.lng) : "";
                  addr.type = addrVal?.type;
                  addr.itemPrice = onPayBtnSel === 0 ? 0 : addrVal?.price;
                  addr.delivery = addrVal?.delivery;
                  addr.promotionCode = null;
                  addr.discount = null;
                  addr.deliveryPrice = addrVal?.deliveryPrice;
                  addr.totalPrice = 0 + addrVal?.deliveryPrice;
                  addr.teamNote = additionalInfo[ind]?.notes;
                  addr.claimProjectNo = additionalInfo[ind]?.claimNumber;
                  addr.ccEmail = additionalInfo[ind]?.additionalMails.join(",");
                  tempFormattedAddr.push(addr);
                });
              }
              let tempReportDetails = {
                orderItems: [...tempFormattedAddr],
                customerId: `${customerId}`,
                paymentType: onPayBtnSel,
                managerNote: "",
                teamNote2: "",
                additionalEmails: "",
                reportLogo: "",
                reportFile: "",
                sendReportTo: "",
                status: "InQueue",
                cardLastDigits: selectedCard?.cardNumber,
                paymentTransactionId: res?.transactionId,
              };

              // fetching from customer portal
              let orderResult = await fetch(`${POST_ORDER_REPORTS}`, {
                method: "POST",
                body: JSON.stringify(tempReportDetails),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`, // Add your token here
                },
              });

              if (orderResult.ok) {
                setLoading(false);
                localStorage.removeItem("sel-places");
                localStorage.removeItem("selectedAddress");
                Cookies.remove("selectedAddress");
                toast.success("Order Placed Successfully!", {
                  duration: 6000,
                  icon: (
                    <FontAwesomeIcon
                      style={{
                        color: "green",
                        fontSize: is4kScreen
                          ? "1.9rem"
                          : isXxlScreen
                          ? "1.6rem"
                          : isXlScreen
                          ? "1.5rem"
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "0.9rem"
                          : isMediumScreen
                          ? "1.4rem"
                          : "1rem",
                      }}
                      icon={faCircleCheck}
                    />
                  ),
                  style: {
                    backgroundColor: "#E7EFC7",
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.15rem"
                      : isXlScreen
                      ? "1rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "1rem"
                      : isMediumScreen
                      ? "1.1rem"
                      : "1rem",
                    marginTop: is4kScreen
                      ? "2rem"
                      : isIpadProPortrait
                      ? "2rem"
                      : "",
                  },
                });
                               localStorage.setItem("orderDetails", JSON.stringify(tempFormattedAddr));
localStorage.setItem("orderReportDetails", JSON.stringify(tempReportDetails));
                navigate("/order/order-confirmation", {
                  state: { tempFormattedAddr, tempReportDetails },
                });
              } else {
                toast.error("Failed to place the order, Please try again", {
                  duration: 6000,
                  icon: (
                    <FontAwesomeIcon
                      style={{
                        fontSize: is4kScreen
                          ? "1.9rem"
                          : isXxlScreen
                          ? "1.6rem"
                          : isXlScreen
                          ? "1.5rem"
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "0.9rem"
                          : isMediumScreen
                          ? "1.4rem"
                          : "1rem",
                      }}
                      icon={faCircleExclamation}
                    />
                  ),
                  style: {
                    backgroundColor: "#FFC1B4",
                    color: "red",
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.15rem"
                      : isXlScreen
                      ? "1rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "1rem"
                      : isMediumScreen
                      ? "1.1rem"
                      : "1rem",
                    marginTop: is4kScreen
                      ? "2rem"
                      : isIpadProPortrait
                      ? "2rem"
                      : "",
                  },
                });
                return;
              }
            }
          } else {
            toast.error(res.message || "Payment failed, Please try again", {
              duration: 6000,
              icon: (
                <FontAwesomeIcon
                  style={{
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.6rem"
                      : isXlScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "0.9rem"
                      : isMediumScreen
                      ? "1.4rem"
                      : "1rem",
                  }}
                  icon={faCircleExclamation}
                />
              ),
              style: {
                backgroundColor: "#FFC1B4",
                color: "red",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
                marginTop: is4kScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : "",
              },
            });
          }
        } catch (e) {
          if (e?.status === 401) {
            navigate("/login");
          }

          console.log(e);
          toast.error(e, {
            duration: 6000,
            icon: (
              <FontAwesomeIcon
                style={{
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isXxlScreen
                    ? "1.6rem"
                    : isXlScreen
                    ? "1.5rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "0.9rem"
                    : isMediumScreen
                    ? "1.4rem"
                    : "1rem",
                }}
                icon={faCircleExclamation}
              />
            ),
            style: {
              backgroundColor: "#FFC1B4",
              color: "red",
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.15rem"
                : isXlScreen
                ? "1rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "1rem"
                : isMediumScreen
                ? "1.1rem"
                : "1rem",
              marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
            },
          });
        } finally {
          setPaymentLoading(false);
        }
      } else {
        let tempAddr = [...selAddress];
        let tempFormattedAddr = [];
        if (tempAddr.length > 0) {
          tempAddr.map((addrVal, addrInd) => {
            let addr = {
              streetAddress: "",
              city: "",
              state: "",
              zip: "",
              lat: "",
              lon: "",
              type: "",
              claimProjectNo: "",
              itemPrice: 0,
              deliveryPrice: 0,
              totalPrice: 0,
              delivery: "",
              quantity: 1,
              promotionCode: "",
              paymentType: onPayBtnSel,
              discount: 0,
              ccEmail: "",
              teamNote: "",
            };
            addr.streetAddress = addrVal?.street;
            addr.city = addrVal?.city;
            addr.state = addrVal?.state;
            addr.zip = addrVal?.postalCode;
            let len = String(addrVal?.address).length;
            addr.lat = addrVal?.lat ? String(addrVal?.lat) : "";
            addr.lon = addrVal?.lng ? String(addrVal?.lng) : "";
            addr.type = addrVal?.type;
            addr.itemPrice = 0;
            addr.delivery = addrVal?.delivery;
            addr.deliveryPrice = addrVal?.deliveryPrice;
            addr.totalPrice = 0 + Number(addrVal?.deliveryPrice);
            addr.teamNote = additionalInfo[addrInd]?.notes;
            addr.claimProjectNo = additionalInfo[addrInd]?.claimNumber;
            addr.ccEmail = additionalInfo[addrInd]?.additionalMails.join(",");
            tempFormattedAddr.push(addr);
          });
        }
        let tempReportDetails = {
          orderItems: [...tempFormattedAddr],
          customerId: `${customerId}`,
          paymentType: onPayBtnSel,
          managerNote: "",
          teamNote2: "",
          additionalEmails: "",
          reportLogo: "",
          reportFile: "",
          sendReportTo: "",
          status: "InQueue",
          cardLastDigits: null,
          paymentTransactionId: null,
        };

        try {
          setPaymentLoading(!paymentLoading);
          let orderResult = await fetch(`${POST_ORDER_REPORTS}`, {
            method: "POST",
            body: JSON.stringify(tempReportDetails),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${GetToken()}`, // Add your token here
            },
          });
          if (orderResult) {
            toast.success("Order Placed Successfully with Credits", {
              duration: 6000,
              icon: (
                <FontAwesomeIcon
                  style={{
                    color: "green",
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.6rem"
                      : isXlScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "0.9rem"
                      : isMediumScreen
                      ? "1.4rem"
                      : "1rem",
                  }}
                  icon={faCircleCheck}
                />
              ),
              style: {
                backgroundColor: "#E7EFC7",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
                marginTop: is4kScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : "",
              },
            });

            localStorage.removeItem("selectedAddress");
            localStorage.removeItem("sel-places");
            Cookies.remove("selectedAddress");
            setLoading(false);
               localStorage.setItem("orderDetails", JSON.stringify(tempFormattedAddr));
localStorage.setItem("orderReportDetails", JSON.stringify(tempReportDetails));
            navigate("/order/order-confirmation", {
              state: { tempFormattedAddr, tempReportDetails },
            });
          }
        } catch (error) {
          console.log(error);
          toast.error(error, {
            duration: 6000,
            icon: (
              <FontAwesomeIcon
                style={{
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isXxlScreen
                    ? "1.6rem"
                    : isXlScreen
                    ? "1.5rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "0.9rem"
                    : isMediumScreen
                    ? "1.4rem"
                    : "1rem",
                }}
                icon={faCircleExclamation}
              />
            ),
            style: {
              backgroundColor: "#FFC1B4",
              color: "red",
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.15rem"
                : isXlScreen
                ? "1rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "1rem"
                : isMediumScreen
                ? "1.1rem"
                : "1rem",
              marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
            },
          });
        } finally {
          setPaymentLoading(false);
        }
      }
    }
    // -----------------------------------------------
    // card payment
    else if (onPayBtnSel === 1) {
      if (EstimatedTotal > 0) {
        if (EstimatedTotal > 0 && allCards.length <= 0) {
          toast.error("Please add a card to continue..!", {
            duration: 6000,
            icon: (
              <FontAwesomeIcon
                style={{
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isXxlScreen
                    ? "1.6rem"
                    : isXlScreen
                    ? "1.5rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "0.9rem"
                    : isMediumScreen
                    ? "1.4rem"
                    : "1rem",
                }}
                icon={faCircleExclamation}
              />
            ),
            style: {
              backgroundColor: "#FFC1B4",
              color: "red",
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.15rem"
                : isXlScreen
                ? "1rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "1rem"
                : isMediumScreen
                ? "1.1rem"
                : "1rem",
              marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
            },
          });
          return;
        }
        if (!selectedCard) {
          toast.error("Please select a card to continue..!", {
            duration: 6000,
            icon: (
              <FontAwesomeIcon
                style={{
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isXxlScreen
                    ? "1.6rem"
                    : isXlScreen
                    ? "1.5rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "0.9rem"
                    : isMediumScreen
                    ? "1.4rem"
                    : "1rem",
                }}
                icon={faCircleExclamation}
              />
            ),
            style: {
              backgroundColor: "#FFC1B4",
              color: "red",
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.15rem"
                : isXlScreen
                ? "1rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "1rem"
                : isMediumScreen
                ? "1.1rem"
                : "1rem",
              marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
            },
          });
          return;
        }
        let tempPaymentDetails = {
          customerId: `${customerId}`,
          expMonth: "",
          expYear: "",
          cardName: "",
          cardNumber: "",
          amount: 0,
          saveCard: false,
          makeDefaultCard: false,
          vaultId: "",
          paypalCustomerId: "",
        };
        tempPaymentDetails.amount = EstimatedTotal;
        tempPaymentDetails.cardName = customerName;
        let expDetails = selectedCard?.cardExpiry
          ? selectedCard?.cardExpiry.split("-")
          : [];
        tempPaymentDetails.expMonth =
          expDetails.length > 1 ? expDetails[1] : "";
        tempPaymentDetails.expYear = expDetails.length > 0 ? expDetails[0] : "";
        tempPaymentDetails.cardNumber = selectedCard?.cardNumber;
        tempPaymentDetails.vaultId = selectedCard?.vaultId;
        tempPaymentDetails.paypalCustomerId = selectedCard?.paypalCustomerId;
        let temp = {
          paypalRequest: "",
        };

        temp.paypalRequest = encryptKey(JSON.stringify(tempPaymentDetails));

        try {
          setPaymentLoading(!paymentLoading);
          let result = await fetch(`${POST_PAYPAL_PAYMENT}`, {
            method: "POST",
            body: JSON.stringify(temp),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${GetToken()}`, // Add your token here
            },
          });
          const res = await result.json();
          if (result.ok) {
            if (
              "isSuccess" in res &&
              "paymentStatus" in res &&
              res?.paymentStatus === "COMPLETED"
            ) {
              "transactionId" in res &&
                setPaidTransactionId(res["transactionId"]);
              let tempFormattedAddr = [];
              let highestProduct = null;
              let tempAddr = [...selAddress];
              let isPromoApplied = false;
              const reportType = discountMataData?.reportType?.toUpperCase();
              const promoType = discountMataData?.promoCodeFor;
              const appliesOn = discountMataData?.appliesOn;
              const discountType = discountMataData?.discountType;
              const promoCodeFor = discountMataData?.promoCodeFor;
              let promoCode = null;
              let calculatedDiscount = 0;
              let calculatedTotalPrice = 0;
              let matchedAddresses = [];
              if (appliesOn === "entire") {
                matchedAddresses = tempAddr.filter(
                  (addr) => addr.type.toUpperCase() === reportType
                );
              } else if (appliesOn === "singleReport") {
                const firstMatch = tempAddr.find(
                  (addr) => addr.type.toUpperCase() === reportType
                );
                if (firstMatch) matchedAddresses = [firstMatch];
              }

              if (Object.keys(highestCostProduct).length > 0) {
                let productsToCheck = [
                  highestCostProduct,
                  secHighest,
                  thirdHighest,
                  leastCost,
                ];
                for (let product of productsToCheck) {
                  let foundProduct = summaryOptions.find((s) => {
                    return s.count > 0 && s.type.toUpperCase() === product.name;
                  });
                  if (foundProduct) {
                    highestProduct = foundProduct.type;
                    break;
                  }
                }
              }

              const discountedItems =
                discountMataData &&
                tempAddr.map((item) => {
                  return (
                    item.price - (item.price * discountMataData?.discount) / 100
                  );
                });

              const dicountedFixedItems =
                discountMataData &&
                tempAddr.map((item) => {
                  return discountMataData?.discount / selAddress.length;
                });

              const discountedDeliveryPrice =
                discountMataData &&
                tempAddr.map(
                  (item) =>
                    (item.deliveryPrice * discountMataData?.discount) / 100
                );

              const discountDeliveryFixedPrice =
                discountMataData &&
                tempAddr.map((item) => {
                  return item.deliveryPrice - discountMataData?.discount;
                });
              let discountIndex = 0;
              if (tempAddr.length > 0) {
                tempAddr.forEach((addrVal, ind) => {
                  let addr = {
                    streetAddress: "",
                    city: "",
                    state: "",
                    zip: "",
                    lat: "",
                    lon: "",
                    type: "",
                    claimProjectNo: "",
                    itemPrice: 0,
                    deliveryPrice: 0,
                    totalPrice: 0,
                    delivery: "",
                    quantity: 1,
                    promotionCode: "",
                    paymentType: onPayBtnSel,
                    discount: 0,
                    ccEmail: "",
                    teamNote: "",
                  };

                  const isMatched = matchedAddresses.some(
                    (addr) =>
                      addr.type.toUpperCase() === addrVal?.type?.toUpperCase()
                  );

                  const discountedItems =
                    discountMataData &&
                    tempAddr.map((item) => {
                      return (item.price * discountMataData?.discount) / 100;
                    });
                  const sameEntireItem = matchedAddresses.map((item, ind) => {
                    return (item.price * discountMataData?.discount) / 100;
                  });
                  const discountedDeliveryPrice =
                    discountMataData &&
                    tempAddr.map(
                      (item) =>
                        (item.deliveryPrice * discountMataData?.discount) / 100
                    );
                  const dicountedFixedItems =
                    discountMataData &&
                    tempAddr.map((item) => {
                      return discountMataData?.discount / selAddress.length;
                    });
                  const fixedItemsDeliveryPrice =
                    discountMataData &&
                    tempAddr.map(
                      (item) => discountMataData?.discount / selAddress.length
                    );

                  const sameEntireFixedItem = matchedAddresses.map((item) => {
                    return discountMataData?.discount / matchedAddresses.length;
                  });

                  if (onPayBtnSel === 0) {
                    promoCode = null;
                    calculatedDiscount = 0;
                    calculatedTotalPrice =
                      addrVal?.delivery === "RUSH"
                        ? Number(addrVal?.deliveryPrice)
                        : 0;
                  } else if (!discountMataData && !promo) {
                    promoCode = null;
                    calculatedDiscount = 0;
                    calculatedTotalPrice =
                      Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
                  }

                  // === Percent Discount Logic ===
                  else if (discountType === "P") {
                    if (appliesOn === "entire" && promoType === "Order") {
                      if (reportType === "ANY") {
                        promoCode = promo;
                        calculatedDiscount = discountedItems[ind];
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice) -
                          Number(discountedItems[ind]);
                      } else if (
                        reportType === addrVal?.type &&
                        matchedAddresses.length >= 1
                        // &&
                        // isMatched
                      ) {
                        promoCode = promo;
                        calculatedDiscount = sameEntireItem[0];
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice) -
                          calculatedDiscount;
                      } else {
                        promoCode = null;
                        calculatedDiscount = 0;
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice);
                      }
                    } else if (
                      appliesOn === "entire" &&
                      promoCodeFor === "Rush"
                    ) {
                      promoCode = promo;
                      calculatedDiscount = discountedDeliveryPrice[ind];
                      calculatedTotalPrice =
                        Number(addrVal?.price) +
                        Number(addrVal?.deliveryPrice) -
                        discountedDeliveryPrice[ind];
                    } else if (
                      appliesOn === "singleReport" &&
                      promoType === "Order"
                    ) {
                      if (reportType === "ANY") {
                        if (
                          highestProduct &&
                          highestProduct.toUpperCase() === addrVal?.type &&
                          !isPromoApplied
                        ) {
                          promoCode = promo;
                          calculatedDiscount = discount;
                          calculatedTotalPrice =
                            Number(addrVal?.price) +
                            Number(addrVal?.deliveryPrice) -
                            discount;
                          isPromoApplied = true;
                        } else {
                          promoCode = null;
                          calculatedDiscount = 0;
                          calculatedTotalPrice =
                            Number(addrVal?.price) +
                            Number(addrVal?.deliveryPrice);
                        }
                      } else if (
                        reportType === addrVal?.type &&
                        !isPromoApplied
                      ) {
                        promoCode = promo;
                        calculatedDiscount = discount;
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice) -
                          discount;
                        isPromoApplied = true;
                      } else {
                        promoCode = null;
                        calculatedDiscount = 0;
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice);
                      }
                    } else if (
                      appliesOn === "singleReport" &&
                      promoCodeFor === "Rush"
                    ) {
                      if (
                        highestProduct.toUpperCase() === addrVal?.type &&
                        discountMataData?.appliesOn === "singleReport" &&
                        !isPromoApplied
                      ) {
                        promoCode = promo;
                        calculatedDiscount =
                          15 * (discountMataData?.discount / 100);
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice) -
                          calculatedDiscount;
                        isPromoApplied = true;
                      } else {
                        promoCode = null;
                        calculatedDiscount = 0;
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice);
                      }
                    }
                  } else if (discountType === "F") {
                    if (appliesOn === "entire" && promoType === "Order") {
                      if (reportType === "ANY") {
                        promoCode = promo;
                        calculatedDiscount = Math.min(
                          addrVal?.price,
                          dicountedFixedItems[ind]
                        );
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice) -
                          calculatedDiscount;
                      } else if (
                        reportType === addrVal?.type &&
                        matchedAddresses.length >= 1 &&
                        isMatched
                      ) {
                        promoCode = promo;
                        calculatedDiscount = sameEntireFixedItem[0];
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice) -
                          sameEntireFixedItem[0];
                      } else {
                        promoCode = null;
                        calculatedDiscount = 0;
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice);
                      }
                    } else if (
                      appliesOn === "entire" &&
                      promoCodeFor === "Rush"
                    ) {
                      promoCode = promo;
                      let temp = summaryOptions.reduce((accum, item) => {
                        return item.type.toUpperCase() === "RUSH"
                          ? accum + item.value
                          : accum;
                      }, 0);
                      let baseValue = temp;
                      let capedValue = Math.min(
                        fixedItemsDeliveryPrice[ind],
                        15
                      );
                      calculatedDiscount = capedValue;
                      calculatedTotalPrice =
                        Number(addrVal?.price) +
                        Number(addrVal?.deliveryPrice) -
                        calculatedDiscount;
                    } else if (
                      appliesOn === "singleReport" &&
                      promoType === "Order"
                    ) {
                      if (reportType === "ANY") {
                        if (
                          highestProduct &&
                          highestProduct.toUpperCase() === addrVal?.type &&
                          !isPromoApplied
                        ) {
                          promoCode = promo;
                          calculatedDiscount = discount;
                          calculatedTotalPrice =
                            Number(addrVal?.price) +
                            Number(addrVal?.deliveryPrice) -
                            calculatedDiscount;
                          isPromoApplied = true;
                        } else {
                          promoCode = null;
                          calculatedDiscount = 0;
                          calculatedTotalPrice =
                            Number(addrVal?.price) +
                            Number(addrVal?.deliveryPrice);
                        }
                      } else if (
                        reportType === addrVal?.type &&
                        !isPromoApplied
                      ) {
                        promoCode = promo;
                        calculatedDiscount = discount;
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice) -
                          calculatedDiscount;
                        isPromoApplied = true;
                      } else {
                        promoCode = null;
                        calculatedDiscount = 0;
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice);
                      }
                    } else if (
                      appliesOn === "singleReport" &&
                      promoCodeFor === "Rush"
                    ) {
                      if (
                        highestProduct.toUpperCase() === addrVal?.type &&
                        discountMataData?.appliesOn === "singleReport" &&
                        !isPromoApplied
                      ) {
                        promoCode = promo;
                        calculatedDiscount = discount;
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice) -
                          calculatedDiscount;
                        isPromoApplied = true;
                      } else {
                        promoCode = null;
                        calculatedDiscount = 0;
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice);
                      }
                    }
                  }

                  addr.streetAddress = addrVal?.street;
                  addr.city = addrVal?.city;
                  addr.state = addrVal?.state;
                  addr.zip = addrVal?.postalCode;
                  let len = String(addrVal?.address).length;
                  addr.lat = addrVal?.lat ? String(addrVal?.lat) : "";
                  addr.lon = addrVal?.lng ? String(addrVal.lng) : "";
                  addr.type = addrVal?.type;
                  addr.itemPrice = onPayBtnSel === 0 ? 0 : addrVal?.price;
                  addr.delivery = addrVal?.delivery;
                  addr.promotionCode = isPromoAppliedState ? promoCode : null;
                  addr.discount = isPromoAppliedState ? calculatedDiscount : 0;
                  addr.deliveryPrice = addrVal?.deliveryPrice;
                  addr.totalPrice = isPromoAppliedState
                    ? calculatedTotalPrice
                    : Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
                  addr.teamNote = additionalInfo[ind]?.notes;
                  addr.claimProjectNo = additionalInfo[ind]?.claimNumber;
                  addr.ccEmail = additionalInfo[ind]?.additionalMails.join(",");
                  tempFormattedAddr.push(addr);
                });
              }

              let tempReportDetails = {
                orderItems: [...tempFormattedAddr],
                customerId: `${customerId}`,
                paymentType: onPayBtnSel,
                managerNote: "",
                teamNote2: "",
                additionalEmails: "",
                reportLogo: "",
                reportFile: "",
                sendReportTo: "",
                status: "InQueue",
                cardLastDigits: selectedCard?.cardNumber,
                paymentTransactionId: res?.transactionId,
              };

              // fetching from customer portal
              let orderResult = await fetch(`${POST_ORDER_REPORTS}`, {
                method: "POST",
                body: JSON.stringify(tempReportDetails),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`, // Add your token here
                },
              });

              if (orderResult.ok) {
                setLoading(false);
                localStorage.removeItem("sel-places");
                localStorage.removeItem("selectedAddress");
                Cookies.remove("selectedAddress");
                toast.success("Order Placed Successfully!", {
                  duration: 6000,
                  icon: (
                    <FontAwesomeIcon
                      style={{
                        color: "green",
                        fontSize: is4kScreen
                          ? "1.9rem"
                          : isXxlScreen
                          ? "1.6rem"
                          : isXlScreen
                          ? "1.5rem"
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "0.9rem"
                          : isMediumScreen
                          ? "1.4rem"
                          : "1rem",
                      }}
                      icon={faCircleCheck}
                    />
                  ),
                  style: {
                    backgroundColor: "#E7EFC7",
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.15rem"
                      : isXlScreen
                      ? "1rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "1rem"
                      : isMediumScreen
                      ? "1.1rem"
                      : "1rem",
                    marginTop: is4kScreen
                      ? "2rem"
                      : isIpadProPortrait
                      ? "2rem"
                      : "",
                  },
                });
               localStorage.setItem("orderDetails", JSON.stringify(tempFormattedAddr));
localStorage.setItem("orderReportDetails", JSON.stringify(tempReportDetails));
                navigate("/order/order-confirmation", {
                  state: { tempFormattedAddr, tempReportDetails },
                });
              } else {
                toast.error("Failed to place the order, Please try again", {
                  duration: 6000,
                  icon: (
                    <FontAwesomeIcon
                      style={{
                        fontSize: is4kScreen
                          ? "1.9rem"
                          : isXxlScreen
                          ? "1.6rem"
                          : isXlScreen
                          ? "1.5rem"
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "0.9rem"
                          : isMediumScreen
                          ? "1.4rem"
                          : "1rem",
                      }}
                      icon={faCircleExclamation}
                    />
                  ),
                  style: {
                    backgroundColor: "#FFC1B4",
                    color: "red",
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.15rem"
                      : isXlScreen
                      ? "1rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "1rem"
                      : isMediumScreen
                      ? "1.1rem"
                      : "1rem",
                    marginTop: is4kScreen
                      ? "2rem"
                      : isIpadProPortrait
                      ? "2rem"
                      : "",
                  },
                });
                return;
              }
            }
          } else {
            toast.error(res.message || "Payment failed, Please try again", {
              duration: 6000,
              icon: (
                <FontAwesomeIcon
                  style={{
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.6rem"
                      : isXlScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "0.9rem"
                      : isMediumScreen
                      ? "1.4rem"
                      : "1rem",
                  }}
                  icon={faCircleExclamation}
                />
              ),
              style: {
                backgroundColor: "#FFC1B4",
                color: "red",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
                marginTop: is4kScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : "",
              },
            });
          }
        } catch (e) {
          if (e?.status === 401) {
            // toast.error(`UnAurthorised,${e}`);
            navigate("/login");
          }
          console.log(e);
          toast.error(e, {
            duration: 6000,
            icon: (
              <FontAwesomeIcon
                style={{
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isXxlScreen
                    ? "1.6rem"
                    : isXlScreen
                    ? "1.5rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "0.9rem"
                    : isMediumScreen
                    ? "1.4rem"
                    : "1rem",
                }}
                icon={faCircleExclamation}
              />
            ),
            style: {
              backgroundColor: "#FFC1B4",
              color: "red",
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.15rem"
                : isXlScreen
                ? "1rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "1rem"
                : isMediumScreen
                ? "1.1rem"
                : "1rem",
              marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
            },
          });
        } finally {
          setPaymentLoading(false);
        }
      } else {
        let tempFormattedAddr = [];
        let highestProduct = null;
        let tempAddr = [...selAddress];
        let isPromoApplied = false;
        const reportType = discountMataData?.reportType?.toUpperCase();
        const promoType = discountMataData?.promoCodeFor;
        const appliesOn = discountMataData?.appliesOn;
        const discountType = discountMataData?.discountType;
        const promoCodeFor = discountMataData?.promoCodeFor;
        let promoCode = null;
        let calculatedDiscount = 0;
        let calculatedTotalPrice = 0;
        let matchedAddresses = [];
        if (appliesOn === "entire") {
          matchedAddresses = tempAddr.filter(
            (addr) => addr.type.toUpperCase() === reportType
          );
        } else if (appliesOn === "singleReport") {
          const firstMatch = tempAddr.find(
            (addr) => addr.type.toUpperCase() === reportType
          );
          if (firstMatch) matchedAddresses = [firstMatch];
        }

        if (Object.keys(highestCostProduct).length > 0) {
          let productsToCheck = [
            highestCostProduct,
            secHighest,
            thirdHighest,
            leastCost,
          ];
          for (let product of productsToCheck) {
            let foundProduct = summaryOptions.find((s) => {
              return s.count > 0 && s.type.toUpperCase() === product.name;
            });
            if (foundProduct) {
              highestProduct = foundProduct.type;
              break;
            }
          }
        }

        const discountedItems =
          discountMataData &&
          tempAddr.map((item) => {
            return item.price - (item.price * discountMataData?.discount) / 100;
          });

        const dicountedFixedItems =
          discountMataData &&
          tempAddr.map((item) => {
            return discountMataData?.discount / selAddress.length;
          });

        const discountedDeliveryPrice =
          discountMataData &&
          tempAddr.map(
            (item) => (item.deliveryPrice * discountMataData?.discount) / 100
          );

        const discountDeliveryFixedPrice =
          discountMataData &&
          tempAddr.map((item) => {
            return item.deliveryPrice - discountMataData?.discount;
          });
        let discountIndex = 0;
        if (tempAddr.length > 0) {
          tempAddr.forEach((addrVal, ind) => {
            let addr = {
              streetAddress: "",
              city: "",
              state: "",
              zip: "",
              lat: "",
              lon: "",
              type: "",
              claimProjectNo: "",
              itemPrice: 0,
              deliveryPrice: 0,
              totalPrice: 0,
              delivery: "",
              quantity: 1,
              promotionCode: "",
              paymentType: 3,
              discount: 0,
              ccEmail: "",
              teamNote: "",
            };

            const isMatched = matchedAddresses.some(
              (addr) => addr.type.toUpperCase() === addrVal?.type?.toUpperCase()
            );

            const discountedItems =
              discountMataData &&
              tempAddr.map((item) => {
                return (item.price * discountMataData?.discount) / 100;
              });
            const sameEntireItem = matchedAddresses.map((item, ind) => {
              return (item.price * discountMataData?.discount) / 100;
            });
            const discountedDeliveryPrice =
              discountMataData &&
              tempAddr.map(
                (item) =>
                  (item.deliveryPrice * discountMataData?.discount) / 100
              );
            const dicountedFixedItems =
              discountMataData &&
              tempAddr.map((item) => {
                return discountMataData?.discount / selAddress.length;
              });
            const fixedItemsDeliveryPrice =
              discountMataData &&
              tempAddr.map(
                (item) => discountMataData?.discount / selAddress.length
              );

            const sameEntireFixedItem = matchedAddresses.map((item) => {
              return discountMataData?.discount / matchedAddresses.length;
            });

            if (onPayBtnSel === 0) {
              promoCode = null;
              calculatedDiscount = 0;
              calculatedTotalPrice =
                addrVal?.delivery === "RUSH"
                  ? Number(addrVal?.deliveryPrice)
                  : 0;
            } else if (!discountMataData && !promo) {
              promoCode = null;
              calculatedDiscount = 0;
              calculatedTotalPrice =
                Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
            }

            // === Percent Discount Logic ===
            else if (discountType === "P") {
              if (appliesOn === "entire" && promoType === "Order") {
                if (reportType === "ANY") {
                  promoCode = promo;
                  calculatedDiscount = discountedItems[ind];
                  calculatedTotalPrice =
                    Number(addrVal?.price) +
                    Number(addrVal?.deliveryPrice) -
                    Number(discountedItems[ind]);
                } else if (
                  reportType === addrVal?.type &&
                  matchedAddresses.length >= 1
                  // &&
                  // isMatched
                ) {
                  promoCode = promo;
                  calculatedDiscount = sameEntireItem[0];
                  calculatedTotalPrice =
                    Number(addrVal?.price) +
                    Number(addrVal?.deliveryPrice) -
                    calculatedDiscount;
                } else {
                  promoCode = null;
                  calculatedDiscount = 0;
                  calculatedTotalPrice =
                    Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
                }
              } else if (appliesOn === "entire" && promoCodeFor === "Rush") {
                promoCode = promo;
                calculatedDiscount = discountedDeliveryPrice[ind];
                calculatedTotalPrice =
                  Number(addrVal?.price) +
                  Number(addrVal?.deliveryPrice) -
                  discountedDeliveryPrice[ind];
              } else if (
                appliesOn === "singleReport" &&
                promoType === "Order"
              ) {
                if (reportType === "ANY") {
                  if (
                    highestProduct &&
                    highestProduct.toUpperCase() === addrVal?.type &&
                    !isPromoApplied
                  ) {
                    promoCode = promo;
                    calculatedDiscount = discount;
                    calculatedTotalPrice =
                      Number(addrVal?.price) +
                      Number(addrVal?.deliveryPrice) -
                      discount;
                    isPromoApplied = true;
                  } else {
                    promoCode = null;
                    calculatedDiscount = 0;
                    calculatedTotalPrice =
                      Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
                  }
                } else if (reportType === addrVal?.type && !isPromoApplied) {
                  promoCode = promo;
                  calculatedDiscount = discount;
                  calculatedTotalPrice =
                    Number(addrVal?.price) +
                    Number(addrVal?.deliveryPrice) -
                    discount;
                  isPromoApplied = true;
                } else {
                  promoCode = null;
                  calculatedDiscount = 0;
                  calculatedTotalPrice =
                    Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
                }
              } else if (
                appliesOn === "singleReport" &&
                promoCodeFor === "Rush"
              ) {
                if (
                  highestProduct.toUpperCase() === addrVal?.type &&
                  discountMataData?.appliesOn === "singleReport" &&
                  !isPromoApplied
                ) {
                  promoCode = promo;
                  calculatedDiscount = 15 * (discountMataData?.discount / 100);
                  calculatedTotalPrice =
                    Number(addrVal?.price) +
                    Number(addrVal?.deliveryPrice) -
                    calculatedDiscount;
                  isPromoApplied = true;
                } else {
                  promoCode = null;
                  calculatedDiscount = 0;
                  calculatedTotalPrice =
                    Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
                }
              }
            } else if (discountType === "F") {
              if (appliesOn === "entire" && promoType === "Order") {
                if (reportType === "ANY") {
                  promoCode = promo;
                  calculatedDiscount = Math.min(
                    addrVal?.price,
                    dicountedFixedItems[ind]
                  );
                  calculatedTotalPrice =
                    Number(addrVal?.price) +
                    Number(addrVal?.deliveryPrice) -
                    calculatedDiscount;
                } else if (
                  reportType === addrVal?.type &&
                  matchedAddresses.length >= 1 &&
                  isMatched
                ) {
                  promoCode = promo;
                  calculatedDiscount =
                    matchedAddresses.length === 1
                      ? Math.min(
                          matchedAddresses[0].price,
                          sameEntireFixedItem[0]
                        )
                      : sameEntireFixedItem[0];
                  calculatedTotalPrice =
                    Number(addrVal?.price) +
                    Number(addrVal?.deliveryPrice) -
                    calculatedDiscount;
                } else {
                  promoCode = null;
                  calculatedDiscount = 0;
                  calculatedTotalPrice =
                    Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
                }
              } else if (appliesOn === "entire" && promoCodeFor === "Rush") {
                promoCode = promo;
                calculatedDiscount = fixedItemsDeliveryPrice[ind];
                calculatedTotalPrice =
                  Number(addrVal?.price) +
                  Number(addrVal?.deliveryPrice) -
                  fixedItemsDeliveryPrice[ind];
              } else if (
                appliesOn === "singleReport" &&
                promoType === "Order"
              ) {
                if (reportType === "ANY") {
                  if (
                    highestProduct &&
                    highestProduct.toUpperCase() === addrVal?.type &&
                    !isPromoApplied
                  ) {
                    promoCode = promo;
                    calculatedDiscount = discount;
                    calculatedTotalPrice =
                      Number(addrVal?.price) +
                      Number(addrVal?.deliveryPrice) -
                      calculatedDiscount;
                    isPromoApplied = true;
                  } else {
                    promoCode = null;
                    calculatedDiscount = 0;
                    calculatedTotalPrice =
                      Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
                  }
                } else if (reportType === addrVal?.type && !isPromoApplied) {
                  promoCode = promo;
                  calculatedDiscount = discount;
                  calculatedTotalPrice =
                    Number(addrVal?.price) +
                    Number(addrVal?.deliveryPrice) -
                    calculatedDiscount;
                  isPromoApplied = true;
                } else {
                  promoCode = null;
                  calculatedDiscount = 0;
                  calculatedTotalPrice =
                    Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
                }
              } else if (
                appliesOn === "singleReport" &&
                promoCodeFor === "Rush"
              ) {
                if (
                  highestProduct.toUpperCase() === addrVal?.type &&
                  discountMataData?.appliesOn === "singleReport" &&
                  !isPromoApplied
                ) {
                  promoCode = promo;
                  calculatedDiscount = discount;
                  calculatedTotalPrice =
                    Number(addrVal?.price) +
                    Number(addrVal?.deliveryPrice) -
                    calculatedDiscount;
                  isPromoApplied = true;
                } else {
                  promoCode = null;
                  calculatedDiscount = 0;
                  calculatedTotalPrice =
                    Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
                }
              }
            }

            addr.streetAddress = addrVal?.street;
            addr.city = addrVal?.city;
            addr.state = addrVal?.state;
            addr.zip = addrVal?.postalCode;
            let len = String(addrVal?.address).length;
            addr.lat = addrVal?.lat ? String(addrVal?.lat) : "";
            addr.lon = addrVal?.lng ? String(addrVal.lng) : "";
            addr.type = addrVal?.type;
            addr.itemPrice = onPayBtnSel === 0 ? 0 : addrVal?.price;
            addr.delivery = addrVal?.delivery;
            addr.promotionCode = promoCode;
            addr.discount = calculatedDiscount;
            addr.deliveryPrice = addrVal?.deliveryPrice;
            addr.totalPrice = calculatedTotalPrice;
            addr.teamNote = additionalInfo[ind]?.notes;
            addr.claimProjectNo = additionalInfo[ind]?.claimNumber;
            addr.ccEmail = additionalInfo[ind]?.additionalMails.join(",");
            tempFormattedAddr.push(addr);
          });
        }

        let tempReportDetails = {
          orderItems: [...tempFormattedAddr],
          customerId: `${customerId}`,
          paymentType: 3,
          managerNote: "",
          teamNote2: "",
          additionalEmails: "",
          reportLogo: "",
          reportFile: "",
          sendReportTo: "",
          status: "InQueue",
          cardLastDigits: null,
          paymentTransactionId: null,
        };

        // fetching from customer portal
        try {
          setPaymentLoading(!paymentLoading);
          let orderResult = await fetch(`${POST_ORDER_REPORTS}`, {
            method: "POST",
            body: JSON.stringify(tempReportDetails),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`, // Add your token here
            },
          });

          if (orderResult.ok) {
            setLoading(false);
            localStorage.removeItem("sel-places");
            localStorage.removeItem("selectedAddress");
            Cookies.remove("selectedAddress");
            toast.success("Order Placed Successfully!", {
              duration: 6000,
              icon: (
                <FontAwesomeIcon
                  style={{
                    color: "green",
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.6rem"
                      : isXlScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "0.9rem"
                      : isMediumScreen
                      ? "1.4rem"
                      : "1rem",
                  }}
                  icon={faCircleCheck}
                />
              ),
              style: {
                backgroundColor: "#E7EFC7",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
                marginTop: is4kScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : "",
              },
            });
                           localStorage.setItem("orderDetails", JSON.stringify(tempFormattedAddr));
localStorage.setItem("orderReportDetails", JSON.stringify(tempReportDetails));
            navigate("/order/order-confirmation", {
              state: { tempFormattedAddr, tempReportDetails },
            });
          } else {
            toast.error("Failed to place the order, Please try again", {
              duration: 6000,
              icon: (
                <FontAwesomeIcon
                  style={{
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.6rem"
                      : isXlScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "0.9rem"
                      : isMediumScreen
                      ? "1.4rem"
                      : "1rem",
                  }}
                  icon={faCircleExclamation}
                />
              ),
              style: {
                backgroundColor: "#FFC1B4",
                color: "red",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
                marginTop: is4kScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : "",
              },
            });
            return;
          }
        } catch (e) {
          toast.error(e, {
            duration: 6000,
            icon: (
              <FontAwesomeIcon
                style={{
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isXxlScreen
                    ? "1.6rem"
                    : isXlScreen
                    ? "1.5rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "0.9rem"
                    : isMediumScreen
                    ? "1.4rem"
                    : "1rem",
                }}
                icon={faCircleExclamation}
              />
            ),
            style: {
              backgroundColor: "#FFC1B4",
              color: "red",
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.15rem"
                : isXlScreen
                ? "1rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "1rem"
                : isMediumScreen
                ? "1.1rem"
                : "1rem",
              marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
            },
          });
        } finally {
          setPaymentLoading(false);
        }
      }
    }
  };

  const placeOrderFromNewCardHandler = async () => {
    const cardData = newCardObj[0];
    const cardNum = cardData.cardNumber.replace(/\s/g, "");

    const [expMonth, expYear] = cardData.expiryDate.split("/");
    const yearPrefix = new Date().getFullYear();
    const stringfiedYearPrefix = yearPrefix.toString().slice(0, 2);
    const expiry = stringfiedYearPrefix + expYear;

    if (onPayBtnSel === 1) {
      if (EstimatedTotal > 0) {
        let tempPaymentDetails = {
          customerId: `${customerId}`,
          expMonth: `${expMonth}`,
          expYear: `${expiry}`,
          cardName: `${cardData?.cardName}`,
          cardNumber: `${cardNum}`,
          amount: `${EstimatedTotal}`,
          saveCard: `${cardData?.saveCard}`,
          makeDefaultCard: `${cardData?.makeDefaultCard}`,
          vaultId: "",
          paypalCustomerId: "",
        };

        let temp = {
          paypalRequest: "",
        };

        temp.paypalRequest = encryptKey(JSON.stringify(tempPaymentDetails));

        try {
          setPaymentLoading(!paymentLoading);
          let result = await fetch(`${POST_PAYPAL_PAYMENT}`, {
            method: "POST",
            // body: JSON.stringify(tempPaymentDetails),
            body: JSON.stringify(temp),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${GetToken()}`, // Add your token here
            },
          });

          const res = await result.json();
          if (result.ok) {
            // const res = await result.json();

            if (
              "isSuccess" in res &&
              "paymentStatus" in res &&
              res?.paymentStatus === "COMPLETED"
            ) {
              "transactionId" in res &&
                setPaidTransactionId(res["transactionId"]);
              let tempFormattedAddr = [];
              let highestProduct = null;
              let tempAddr = [...selAddress];
              let isPromoApplied = false;
              const reportType = discountMataData?.reportType?.toUpperCase();
              const promoType = discountMataData?.promoCodeFor;
              const appliesOn = discountMataData?.appliesOn;
              const discountType = discountMataData?.discountType;
              const promoCodeFor = discountMataData?.promoCodeFor;
              let promoCode = null;
              let calculatedDiscount = 0;
              let calculatedTotalPrice = 0;
              let matchedAddresses = [];
              if (appliesOn === "entire") {
                matchedAddresses = tempAddr.filter(
                  (addr) => addr.type.toUpperCase() === reportType
                );
              } else if (appliesOn === "singleReport") {
                const firstMatch = tempAddr.find(
                  (addr) => addr.type.toUpperCase() === reportType
                );
                if (firstMatch) matchedAddresses = [firstMatch];
              }

              if (Object.keys(highestCostProduct).length > 0) {
                let productsToCheck = [
                  highestCostProduct,
                  secHighest,
                  thirdHighest,
                  leastCost,
                ];
                for (let product of productsToCheck) {
                  let foundProduct = summaryOptions.find((s) => {
                    return s.count > 0 && s.type.toUpperCase() === product.name;
                  });

                  if (foundProduct) {
                    highestProduct = foundProduct.type;
                    break;
                  }
                }
              }

              const discountedItems =
                discountMataData &&
                tempAddr.map((item) => {
                  return (
                    item.price - (item.price * discountMataData?.discount) / 100
                  );
                });

              const dicountedFixedItems =
                discountMataData &&
                tempAddr.map((item) => {
                  return discountMataData?.discount / selAddress.length;
                });

              const discountedDeliveryPrice =
                discountMataData &&
                tempAddr.map(
                  (item) =>
                    (item.deliveryPrice * discountMataData?.discount) / 100
                );

              const discountDeliveryFixedPrice =
                discountMataData &&
                tempAddr.map((item) => {
                  return item.deliveryPrice - discountMataData?.discount;
                });
              let discountIndex = 0;
              if (tempAddr.length > 0) {
                tempAddr.forEach((addrVal, ind) => {
                  let addr = {
                    streetAddress: "",
                    city: "",
                    state: "",
                    zip: "",
                    lat: "",
                    lon: "",
                    type: "",
                    claimProjectNo: "",
                    itemPrice: 0,
                    deliveryPrice: 0,
                    totalPrice: 0,
                    delivery: "",
                    quantity: 1,
                    promotionCode: "",
                    paymentType: onPayBtnSel,
                    discount: 0,
                    ccEmail: "",
                    teamNote: "",
                  };

                  const isMatched = matchedAddresses.some(
                    (addr) =>
                      addr.type.toUpperCase() === addrVal?.type?.toUpperCase()
                  );

                  const discountedItems =
                    discountMataData &&
                    tempAddr.map((item) => {
                      return (item.price * discountMataData?.discount) / 100;
                    });
                  const sameEntireItem = matchedAddresses.map((item, ind) => {
                    return (item.price * discountMataData?.discount) / 100;
                  });
                  const discountedDeliveryPrice =
                    discountMataData &&
                    tempAddr.map(
                      (item) =>
                        (item.deliveryPrice * discountMataData?.discount) / 100
                    );
                  const dicountedFixedItems =
                    discountMataData &&
                    tempAddr.map((item) => {
                      return discountMataData?.discount / selAddress.length;
                    });
                  const fixedItemsDeliveryPrice =
                    discountMataData &&
                    tempAddr.map(
                      (item) => discountMataData?.discount / selAddress.length
                    );

                  const sameEntireFixedItem = matchedAddresses.map((item) => {
                    return discountMataData?.discount / matchedAddresses.length;
                  });

                  if (onPayBtnSel === 0) {
                    promoCode = null;
                    calculatedDiscount = 0;
                    calculatedTotalPrice =
                      addrVal?.delivery === "RUSH"
                        ? Number(addrVal?.deliveryPrice)
                        : 0;
                  } else if (!discountMataData && !promo) {
                    promoCode = null;
                    calculatedDiscount = 0;
                    calculatedTotalPrice =
                      Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
                  }

                  // === Percent Discount Logic ===
                  else if (discountType === "P") {
                    if (appliesOn === "entire" && promoType === "Order") {
                      if (reportType === "ANY") {
                        promoCode = promo;
                        calculatedDiscount = discountedItems[ind];
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice) -
                          Number(discountedItems[ind]);
                      } else if (
                        reportType === addrVal?.type &&
                        matchedAddresses.length >= 1
                        // &&
                        // isMatched
                      ) {
                        promoCode = promo;
                        calculatedDiscount = sameEntireItem[0];
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice) -
                          calculatedDiscount;

                        // discountIndex++;
                        // console.log("discountIndex", discountIndex);
                      } else {
                        promoCode = null;
                        calculatedDiscount = 0;
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice);
                      }
                    } else if (
                      appliesOn === "entire" &&
                      promoCodeFor === "Rush"
                    ) {
                      promoCode = promo;
                      calculatedDiscount = discountedDeliveryPrice[ind];
                      calculatedTotalPrice =
                        Number(addrVal?.price) +
                        Number(addrVal?.deliveryPrice) -
                        discountedDeliveryPrice[ind];
                    } else if (
                      appliesOn === "singleReport" &&
                      promoType === "Order"
                    ) {
                      if (reportType === "ANY") {
                        if (
                          highestProduct &&
                          highestProduct.toUpperCase() === addrVal?.type &&
                          !isPromoApplied
                        ) {
                          promoCode = promo;
                          calculatedDiscount = discount;
                          calculatedTotalPrice =
                            Number(addrVal?.price) +
                            Number(addrVal?.deliveryPrice) -
                            discount;
                          isPromoApplied = true;
                        } else {
                          promoCode = null;
                          calculatedDiscount = 0;
                          calculatedTotalPrice =
                            Number(addrVal?.price) +
                            Number(addrVal?.deliveryPrice);
                        }
                      } else if (
                        reportType === addrVal?.type &&
                        !isPromoApplied
                      ) {
                        promoCode = promo;
                        calculatedDiscount = discount;
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice) -
                          discount;
                        isPromoApplied = true;
                      } else {
                        promoCode = null;
                        calculatedDiscount = 0;
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice);
                      }
                    } else if (
                      appliesOn === "singleReport" &&
                      promoCodeFor === "Rush"
                    ) {
                      if (
                        highestProduct.toUpperCase() === addrVal?.type &&
                        discountMataData?.appliesOn === "singleReport" &&
                        !isPromoApplied
                      ) {
                        promoCode = promo;
                        calculatedDiscount =
                          15 * (discountMataData?.discount / 100);
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice) -
                          calculatedDiscount;
                        isPromoApplied = true;
                      } else {
                        promoCode = null;
                        calculatedDiscount = 0;
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice);
                      }
                    }
                  } else if (discountType === "F") {
                    if (appliesOn === "entire" && promoType === "Order") {
                      if (reportType === "ANY") {
                        promoCode = promo;
                        calculatedDiscount = Math.min(
                          addrVal?.price,
                          dicountedFixedItems[ind]
                        );
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice) -
                          calculatedDiscount;
                      } else if (
                        reportType === addrVal?.type &&
                        matchedAddresses.length >= 1 &&
                        isMatched
                      ) {
                        promoCode = promo;
                        calculatedDiscount = sameEntireFixedItem[0];
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice) -
                          sameEntireFixedItem[0];
                      } else {
                        promoCode = null;
                        calculatedDiscount = 0;
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice);
                      }
                    } else if (
                      appliesOn === "entire" &&
                      promoCodeFor === "Rush"
                    ) {
                      promoCode = promo;
                      let capedValue = Math.min(
                        fixedItemsDeliveryPrice[ind],
                        15
                      );
                      calculatedDiscount = capedValue;
                      calculatedTotalPrice =
                        Number(addrVal?.price) +
                        Number(addrVal?.deliveryPrice) -
                        calculatedDiscount;
                    } else if (
                      appliesOn === "singleReport" &&
                      promoType === "Order"
                    ) {
                      if (reportType === "ANY") {
                        if (
                          highestProduct &&
                          highestProduct.toUpperCase() === addrVal?.type &&
                          !isPromoApplied
                        ) {
                          promoCode = promo;
                          calculatedDiscount = discount;
                          calculatedTotalPrice =
                            Number(addrVal?.price) +
                            Number(addrVal?.deliveryPrice) -
                            calculatedDiscount;
                          isPromoApplied = true;
                        } else {
                          promoCode = null;
                          calculatedDiscount = 0;
                          calculatedTotalPrice =
                            Number(addrVal?.price) +
                            Number(addrVal?.deliveryPrice);
                        }
                      } else if (
                        reportType === addrVal?.type &&
                        !isPromoApplied
                      ) {
                        // promoCode = promo;
                        // calculatedDiscount = discount;
                        // calculatedTotalPrice =
                        //   Number(addrVal?.price) +
                        //   Number(addrVal?.deliveryPrice) -
                        //   discount;
                        // isPromoApplied = true;

                        promoCode = promo;
                        calculatedDiscount = discount;
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice) -
                          calculatedDiscount;
                        isPromoApplied = true;
                      } else {
                        promoCode = null;
                        calculatedDiscount = 0;
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice);
                      }
                    } else if (
                      appliesOn === "singleReport" &&
                      promoCodeFor === "Rush"
                    ) {
                      if (
                        highestProduct.toUpperCase() === addrVal?.type &&
                        discountMataData?.appliesOn === "singleReport" &&
                        !isPromoApplied
                      ) {
                        promoCode = promo;
                        calculatedDiscount = discount;
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice) -
                          calculatedDiscount;
                        isPromoApplied = true;
                      } else {
                        promoCode = null;
                        calculatedDiscount = 0;
                        calculatedTotalPrice =
                          Number(addrVal?.price) +
                          Number(addrVal?.deliveryPrice);
                      }
                    }
                  }

                  addr.streetAddress = addrVal?.street;
                  addr.city = addrVal?.city;
                  addr.state = addrVal?.state;
                  addr.zip = addrVal?.postalCode;
                  let len = String(addrVal?.address).length;
                  addr.lat = addrVal?.lat ? String(addrVal?.lat) : "";
                  addr.lon = addrVal?.lng ? String(addrVal.lng) : "";
                  addr.type = addrVal?.type;
                  addr.itemPrice = onPayBtnSel === 0 ? 0 : addrVal?.price;
                  addr.delivery = addrVal?.delivery;
                  addr.promotionCode = isPromoAppliedState ? promoCode : null;
                  addr.discount = isPromoAppliedState ? calculatedDiscount : 0;
                  addr.deliveryPrice = addrVal?.deliveryPrice;
                  addr.totalPrice = isPromoAppliedState
                    ? calculatedTotalPrice
                    : Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
                  addr.teamNote = additionalInfo[ind]?.notes;
                  addr.claimProjectNo = additionalInfo[ind]?.claimNumber;
                  addr.ccEmail = additionalInfo[ind]?.additionalMails.join(",");
                  tempFormattedAddr.push(addr);
                });
              }

              let tempReportDetails = {
                orderItems: [...tempFormattedAddr],
                customerId: `${customerId}`,
                paymentType: onPayBtnSel,
                managerNote: "",
                teamNote2: "",
                additionalEmails: "",
                reportLogo: "",
                reportFile: "",
                sendReportTo: "",
                status: "InQueue",
                cardLastDigits: cardNum.slice(-4),
                paymentTransactionId: res?.transactionId,
              };

              // fetching from customer portal
              let orderResult = await fetch(`${POST_ORDER_REPORTS}`, {
                method: "POST",
                body: JSON.stringify(tempReportDetails),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`, // Add your token here
                },
              });

              if (orderResult.ok) {
                setLoading(false);

                localStorage.removeItem("sel-places");
                localStorage.removeItem("selectedAddress");
                Cookies.remove("selectedAddress");
                setNewCardDetails({
                  cardName: "",
                  cardNumber: "",
                  expiryDate: "",
                  saveCard: false,
                  makeDefaultCard: false,
                });
                toast.success("Order Placed Successfully!", {
                  duration: 6000,
                  icon: (
                    <FontAwesomeIcon
                      style={{
                        color: "green",
                        fontSize: is4kScreen
                          ? "1.9rem"
                          : isXxlScreen
                          ? "1.6rem"
                          : isXlScreen
                          ? "1.5rem"
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "0.9rem"
                          : isMediumScreen
                          ? "1.4rem"
                          : "1rem",
                      }}
                      icon={faCircleCheck}
                    />
                  ),
                  style: {
                    backgroundColor: "#E7EFC7",
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.15rem"
                      : isXlScreen
                      ? "1rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "1rem"
                      : isMediumScreen
                      ? "1.1rem"
                      : "1rem",
                    marginTop: is4kScreen
                      ? "2rem"
                      : isIpadProPortrait
                      ? "2rem"
                      : "",
                  },
                });
               localStorage.setItem("orderDetails", JSON.stringify(tempFormattedAddr));
localStorage.setItem("orderReportDetails", JSON.stringify(tempReportDetails));
                navigate("/order/order-confirmation", {
                  state: { tempFormattedAddr, tempReportDetails },
                });
              } else {
                toast.error("Failed to place the order, Please try again", {
                  duration: 6000,
                  icon: (
                    <FontAwesomeIcon
                      style={{
                        fontSize: is4kScreen
                          ? "1.9rem"
                          : isXxlScreen
                          ? "1.6rem"
                          : isXlScreen
                          ? "1.5rem"
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "0.9rem"
                          : isMediumScreen
                          ? "1.4rem"
                          : "1rem",
                      }}
                      icon={faCircleExclamation}
                    />
                  ),
                  style: {
                    backgroundColor: "#FFC1B4",
                    color: "red",
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.15rem"
                      : isXlScreen
                      ? "1rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "1rem"
                      : isMediumScreen
                      ? "1.1rem"
                      : "1rem",
                    marginTop: is4kScreen
                      ? "2rem"
                      : isIpadProPortrait
                      ? "2rem"
                      : "",
                  },
                });
                return;
              }
            }
          } else {
            toast.error(res.message || "Payment failed, Please try again", {
              duration: 6000,
              icon: (
                <FontAwesomeIcon
                  style={{
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.6rem"
                      : isXlScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "0.9rem"
                      : isMediumScreen
                      ? "1.4rem"
                      : "1rem",
                  }}
                  icon={faCircleExclamation}
                />
              ),
              style: {
                backgroundColor: "#FFC1B4",
                color: "red",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
                marginTop: is4kScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : "",
              },
            });
          }
        } catch (e) {
          if (e?.status === 401) {
            // toast.error(`UnAurthorised,${e}`);
            navigate("/login");
          }

          console.log(e);
        } finally {
          setPaymentLoading(false);
        }
      } else {
        let tempFormattedAddr = [];
        let highestProduct = null;
        let tempAddr = [...selAddress];
        let isPromoApplied = false;
        const reportType = discountMataData?.reportType?.toUpperCase();
        const promoType = discountMataData?.promoCodeFor;
        const appliesOn = discountMataData?.appliesOn;
        const discountType = discountMataData?.discountType;
        const promoCodeFor = discountMataData?.promoCodeFor;
        let promoCode = null;
        let calculatedDiscount = 0;
        let calculatedTotalPrice = 0;
        let matchedAddresses = [];
        if (appliesOn === "entire") {
          matchedAddresses = tempAddr.filter(
            (addr) => addr.type.toUpperCase() === reportType
          );
        } else if (appliesOn === "singleReport") {
          const firstMatch = tempAddr.find(
            (addr) => addr.type.toUpperCase() === reportType
          );
          if (firstMatch) matchedAddresses = [firstMatch];
        }

        if (Object.keys(highestCostProduct).length > 0) {
          let productsToCheck = [
            highestCostProduct,
            secHighest,
            thirdHighest,
            leastCost,
          ];
          for (let product of productsToCheck) {
            let foundProduct = summaryOptions.find((s) => {
              return s.count > 0 && s.type.toUpperCase() === product.name;
            });

            if (foundProduct) {
              highestProduct = foundProduct.type;
              break;
            }
          }
        }

        const discountedItems =
          discountMataData &&
          tempAddr.map((item) => {
            return item.price - (item.price * discountMataData?.discount) / 100;
          });

        const dicountedFixedItems =
          discountMataData &&
          tempAddr.map((item) => {
            return discountMataData?.discount / selAddress.length;
          });

        const discountedDeliveryPrice =
          discountMataData &&
          tempAddr.map(
            (item) => (item.deliveryPrice * discountMataData?.discount) / 100
          );

        const discountDeliveryFixedPrice =
          discountMataData &&
          tempAddr.map((item) => {
            return item.deliveryPrice - discountMataData?.discount;
          });
        let discountIndex = 0;
        if (tempAddr.length > 0) {
          tempAddr.forEach((addrVal, ind) => {
            let addr = {
              streetAddress: "",
              city: "",
              state: "",
              zip: "",
              lat: "",
              lon: "",
              type: "",
              claimProjectNo: "",
              itemPrice: 0,
              deliveryPrice: 0,
              totalPrice: 0,
              delivery: "",
              quantity: 1,
              promotionCode: "",
              paymentType: 3,
              discount: 0,
              ccEmail: "",
              teamNote: "",
            };

            const isMatched = matchedAddresses.some(
              (addr) => addr.type.toUpperCase() === addrVal?.type?.toUpperCase()
            );

            const discountedItems =
              discountMataData &&
              tempAddr.map((item) => {
                return (item.price * discountMataData?.discount) / 100;
              });
            const sameEntireItem = matchedAddresses.map((item, ind) => {
              return (item.price * discountMataData?.discount) / 100;
            });
            const discountedDeliveryPrice =
              discountMataData &&
              tempAddr.map(
                (item) =>
                  (item.deliveryPrice * discountMataData?.discount) / 100
              );
            const dicountedFixedItems =
              discountMataData &&
              tempAddr.map((item) => {
                return discountMataData?.discount / selAddress.length;
              });
            const fixedItemsDeliveryPrice =
              discountMataData &&
              tempAddr.map(
                (item) => discountMataData?.discount / selAddress.length
              );

            const sameEntireFixedItem = matchedAddresses.map((item) => {
              return discountMataData?.discount / matchedAddresses.length;
            });

            if (onPayBtnSel === 0) {
              promoCode = null;
              calculatedDiscount = 0;
              calculatedTotalPrice =
                addrVal?.delivery === "RUSH"
                  ? Number(addrVal?.deliveryPrice)
                  : 0;
            } else if (!discountMataData && !promo) {
              promoCode = null;
              calculatedDiscount = 0;
              calculatedTotalPrice =
                Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
            }

            // === Percent Discount Logic ===
            else if (discountType === "P") {
              if (appliesOn === "entire" && promoType === "Order") {
                if (reportType === "ANY") {
                  promoCode = promo;
                  calculatedDiscount = discountedItems[ind];
                  calculatedTotalPrice =
                    Number(addrVal?.price) +
                    Number(addrVal?.deliveryPrice) -
                    Number(discountedItems[ind]);
                } else if (
                  reportType === addrVal?.type &&
                  matchedAddresses.length >= 1
                  // &&
                  // isMatched
                ) {
                  promoCode = promo;
                  calculatedDiscount = sameEntireItem[0];
                  calculatedTotalPrice =
                    Number(addrVal?.price) +
                    Number(addrVal?.deliveryPrice) -
                    calculatedDiscount;
                } else {
                  promoCode = null;
                  calculatedDiscount = 0;
                  calculatedTotalPrice =
                    Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
                }
              } else if (appliesOn === "entire" && promoCodeFor === "Rush") {
                promoCode = promo;
                calculatedDiscount = discountedDeliveryPrice[ind];
                calculatedTotalPrice =
                  Number(addrVal?.price) +
                  Number(addrVal?.deliveryPrice) -
                  discountedDeliveryPrice[ind];
              } else if (
                appliesOn === "singleReport" &&
                promoType === "Order"
              ) {
                if (reportType === "ANY") {
                  if (
                    highestProduct &&
                    highestProduct.toUpperCase() === addrVal?.type &&
                    !isPromoApplied
                  ) {
                    promoCode = promo;
                    calculatedDiscount = discount;
                    calculatedTotalPrice =
                      Number(addrVal?.price) +
                      Number(addrVal?.deliveryPrice) -
                      discount;
                    isPromoApplied = true;
                  } else {
                    promoCode = null;
                    calculatedDiscount = 0;
                    calculatedTotalPrice =
                      Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
                  }
                } else if (reportType === addrVal?.type && !isPromoApplied) {
                  promoCode = promo;
                  calculatedDiscount = discount;
                  calculatedTotalPrice =
                    Number(addrVal?.price) +
                    Number(addrVal?.deliveryPrice) -
                    discount;
                  isPromoApplied = true;
                } else {
                  promoCode = null;
                  calculatedDiscount = 0;
                  calculatedTotalPrice =
                    Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
                }
              } else if (
                appliesOn === "singleReport" &&
                promoCodeFor === "Rush"
              ) {
                if (
                  highestProduct.toUpperCase() === addrVal?.type &&
                  discountMataData?.appliesOn === "singleReport" &&
                  !isPromoApplied
                ) {
                  promoCode = promo;
                  calculatedDiscount = 15 * (discountMataData?.discount / 100);
                  calculatedTotalPrice =
                    Number(addrVal?.price) +
                    Number(addrVal?.deliveryPrice) -
                    calculatedDiscount;
                  isPromoApplied = true;
                } else {
                  promoCode = null;
                  calculatedDiscount = 0;
                  calculatedTotalPrice =
                    Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
                }
              }
            } else if (discountType === "F") {
              if (appliesOn === "entire" && promoType === "Order") {
                if (reportType === "ANY") {
                  promoCode = promo;
                  calculatedDiscount = Math.min(
                    addrVal?.price,
                    dicountedFixedItems[ind]
                  );
                  calculatedTotalPrice =
                    Number(addrVal?.price) +
                    Number(addrVal?.deliveryPrice) -
                    calculatedDiscount;
                } else if (
                  reportType === addrVal?.type &&
                  matchedAddresses.length >= 1 &&
                  isMatched
                ) {
                  promoCode = promo;
                  calculatedDiscount =
                    matchedAddresses.length === 1
                      ? Math.min(
                          matchedAddresses[0].price,
                          sameEntireFixedItem[0]
                        )
                      : sameEntireFixedItem[0];
                  calculatedTotalPrice =
                    Number(addrVal?.price) +
                    Number(addrVal?.deliveryPrice) -
                    calculatedDiscount;
                } else {
                  promoCode = null;
                  calculatedDiscount = 0;
                  calculatedTotalPrice =
                    Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
                }
              } else if (appliesOn === "entire" && promoCodeFor === "Rush") {
                promoCode = promo;
                calculatedDiscount = fixedItemsDeliveryPrice[ind];
                calculatedTotalPrice =
                  Number(addrVal?.price) +
                  Number(addrVal?.deliveryPrice) -
                  fixedItemsDeliveryPrice[ind];
              } else if (
                appliesOn === "singleReport" &&
                promoType === "Order"
              ) {
                if (reportType === "ANY") {
                  if (
                    highestProduct &&
                    highestProduct.toUpperCase() === addrVal?.type &&
                    !isPromoApplied
                  ) {
                    promoCode = promo;
                    calculatedDiscount = discount;
                    calculatedTotalPrice =
                      Number(addrVal?.price) +
                      Number(addrVal?.deliveryPrice) -
                      calculatedDiscount;
                    isPromoApplied = true;
                  } else {
                    promoCode = null;
                    calculatedDiscount = 0;
                    calculatedTotalPrice =
                      Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
                  }
                } else if (reportType === addrVal?.type && !isPromoApplied) {
                  promoCode = promo;
                  calculatedDiscount = discount;
                  calculatedTotalPrice =
                    Number(addrVal?.price) +
                    Number(addrVal?.deliveryPrice) -
                    calculatedDiscount;
                  isPromoApplied = true;
                } else {
                  promoCode = null;
                  calculatedDiscount = 0;
                  calculatedTotalPrice =
                    Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
                }
              } else if (
                appliesOn === "singleReport" &&
                promoCodeFor === "Rush"
              ) {
                if (
                  highestProduct.toUpperCase() === addrVal?.type &&
                  discountMataData?.appliesOn === "singleReport" &&
                  !isPromoApplied
                ) {
                  promoCode = promo;
                  calculatedDiscount = discount;
                  calculatedTotalPrice =
                    Number(addrVal?.price) +
                    Number(addrVal?.deliveryPrice) -
                    calculatedDiscount;
                  isPromoApplied = true;
                } else {
                  promoCode = null;
                  calculatedDiscount = 0;
                  calculatedTotalPrice =
                    Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
                }
              }
            }

            addr.streetAddress = addrVal?.street;
            addr.city = addrVal?.city;
            addr.state = addrVal?.state;
            addr.zip = addrVal?.postalCode;
            let len = String(addrVal?.address).length;
            addr.lat = addrVal?.lat ? String(addrVal?.lat) : "";
            addr.lon = addrVal?.lng ? String(addrVal.lng) : "";
            addr.type = addrVal?.type;
            addr.itemPrice = onPayBtnSel === 0 ? 0 : addrVal?.price;
            addr.delivery = addrVal?.delivery;
            addr.promotionCode = promoCode;
            addr.discount = calculatedDiscount;
            addr.deliveryPrice = addrVal?.deliveryPrice;
            addr.totalPrice = calculatedTotalPrice;
            addr.teamNote = additionalInfo[ind]?.notes;
            addr.claimProjectNo = additionalInfo[ind]?.claimNumber;
            addr.ccEmail = additionalInfo[ind]?.additionalMails.join(",");
            tempFormattedAddr.push(addr);
          });
        }

        let tempReportDetails = {
          orderItems: [...tempFormattedAddr],
          customerId: `${customerId}`,
          paymentType: 3,
          managerNote: "",
          teamNote2: "",
          additionalEmails: "",
          reportLogo: "",
          reportFile: "",
          sendReportTo: "",
          status: "InQueue",
          cardLastDigits: null,
          paymentTransactionId: null,
        };

        // fetching from customer portal
        try {
          setPaymentLoading(!paymentLoading);
          let orderResult = await fetch(`${POST_ORDER_REPORTS}`, {
            method: "POST",
            body: JSON.stringify(tempReportDetails),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`, // Add your token here
            },
          });

          if (orderResult.ok) {
            setLoading(false);

            localStorage.removeItem("sel-places");
            localStorage.removeItem("selectedAddress");
            Cookies.remove("selectedAddress");
            toast.success("Order Placed Successfully!", {
              duration: 6000,
              icon: (
                <FontAwesomeIcon
                  style={{
                    color: "green",
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.6rem"
                      : isXlScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "0.9rem"
                      : isMediumScreen
                      ? "1.4rem"
                      : "1rem",
                  }}
                  icon={faCircleCheck}
                />
              ),
              style: {
                backgroundColor: "#E7EFC7",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
                marginTop: is4kScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : "",
              },
            });
                           localStorage.setItem("orderDetails", JSON.stringify(tempFormattedAddr));
localStorage.setItem("orderReportDetails", JSON.stringify(tempReportDetails));
            navigate("/order/order-confirmation", {
              state: { tempFormattedAddr, tempReportDetails },
            });
          } else {
            toast.error("Failed to place the order, Please try again", {
              duration: 6000,
              icon: (
                <FontAwesomeIcon
                  style={{
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.6rem"
                      : isXlScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "0.9rem"
                      : isMediumScreen
                      ? "1.4rem"
                      : "1rem",
                  }}
                  icon={faCircleExclamation}
                />
              ),
              style: {
                backgroundColor: "#FFC1B4",
                color: "red",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
                marginTop: is4kScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : "",
              },
            });
            return;
          }
        } catch (e) {
          if (e?.status === 401) {
            // toast.error(`UnAurthorised,${e}`);
            navigate("/login");
          }
          console.log(error);
        } finally {
          setPaymentLoading(false);
        }
      }
    } else {
      if (EstimatedTotal > 0) {
        let tempPaymentDetails = {
          customerId: `${customerId}`,
          expMonth: `${expMonth}`,
          expYear: `${expiry}`,
          cardName: `${cardData?.cardName}`,
          cardNumber: `${cardNum}`,
          amount: `${EstimatedTotal}`,
          saveCard: `${cardData?.saveCard}`,
          makeDefaultCard: `${cardData?.makeDefaultCard}`,
          vaultId: "",
          paypalCustomerId: "",
        };

        let temp = {
          paypalRequest: "",
        };
        temp.paypalRequest = encryptKey(JSON.stringify(tempPaymentDetails));
        try {
          setPaymentLoading(!paymentLoading);
          let result = await fetch(`${POST_PAYPAL_PAYMENT}`, {
            method: "POST",

            body: JSON.stringify(temp),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${GetToken()}`, // Add your token here
            },
          });

          const res = await result.json();
          if (result.ok) {
            if (
              "isSuccess" in res &&
              "paymentStatus" in res &&
              res?.paymentStatus === "COMPLETED"
            ) {
              "transactionId" in res &&
                setPaidTransactionId(res["transactionId"]);
              let tempFormattedAddr = [];
              let highestProduct = null;
              let tempAddr = [...selAddress];

              if (tempAddr.length > 0) {
                tempAddr.forEach((addrVal, ind) => {
                  let addr = {
                    streetAddress: "",
                    city: "",
                    state: "",
                    zip: "",
                    lat: "",
                    lon: "",
                    type: "",
                    claimProjectNo: "",
                    itemPrice: 0,
                    deliveryPrice: 0,
                    totalPrice: 0,
                    delivery: "",
                    quantity: 1,
                    promotionCode: "",
                    paymentType: onPayBtnSel,
                    discount: 0,
                    ccEmail: "",
                    teamNote: "",
                  };

                  addr.streetAddress = addrVal?.street;
                  addr.city = addrVal?.city;
                  addr.state = addrVal?.state;
                  addr.zip = addrVal?.postalCode;
                  let len = String(addrVal?.address).length;
                  addr.lat = addrVal?.lat ? String(addrVal?.lat) : "";
                  addr.lon = addrVal?.lng ? String(addrVal.lng) : "";
                  addr.type = addrVal?.type;
                  addr.itemPrice = onPayBtnSel === 0 ? 0 : addrVal?.price;
                  addr.delivery = addrVal?.delivery;
                  addr.promotionCode = null;
                  addr.discount = null;
                  addr.deliveryPrice = addrVal?.deliveryPrice;
                  addr.totalPrice = 0 + Number(addrVal?.deliveryPrice);
                  addr.teamNote = additionalInfo[ind]?.notes;
                  addr.claimProjectNo = additionalInfo[ind]?.claimNumber;
                  addr.ccEmail = additionalInfo[ind]?.additionalMails.join(",");
                  tempFormattedAddr.push(addr);
                });
              }

              let tempReportDetails = {
                orderItems: [...tempFormattedAddr],
                customerId: `${customerId}`,
                paymentType: onPayBtnSel,
                managerNote: "",
                teamNote2: "",
                additionalEmails: "",
                reportLogo: "",
                reportFile: "",
                sendReportTo: "",
                status: "InQueue",
                cardLastDigits: cardNum.slice(-4),
                paymentTransactionId: res?.transactionId,
              };

              // fetching from customer portal
              let orderResult = await fetch(`${POST_ORDER_REPORTS}`, {
                method: "POST",
                body: JSON.stringify(tempReportDetails),
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`, // Add your token here
                },
              });

              if (orderResult.ok) {
                setLoading(false);
                localStorage.removeItem("sel-places");
                localStorage.removeItem("selectedAddress");
                Cookies.remove("selectedAddress");
                setNewCardDetails({
                  cardName: "",
                  cardNumber: "",
                  expiryDate: "",
                  saveCard: false,
                  makeDefaultCard: false,
                });
                toast.success("Order Placed Successfully!", {
                  duration: 6000,
                  icon: (
                    <FontAwesomeIcon
                      style={{
                        color: "green",
                        fontSize: is4kScreen
                          ? "1.9rem"
                          : isXxlScreen
                          ? "1.6rem"
                          : isXlScreen
                          ? "1.5rem"
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "0.9rem"
                          : isMediumScreen
                          ? "1.4rem"
                          : "1rem",
                      }}
                      icon={faCircleCheck}
                    />
                  ),
                  style: {
                    backgroundColor: "#E7EFC7",
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.15rem"
                      : isXlScreen
                      ? "1rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "1rem"
                      : isMediumScreen
                      ? "1.1rem"
                      : "1rem",
                    marginTop: is4kScreen
                      ? "2rem"
                      : isIpadProPortrait
                      ? "2rem"
                      : "",
                  },
                });
               localStorage.setItem("orderDetails", JSON.stringify(tempFormattedAddr));
localStorage.setItem("orderReportDetails", JSON.stringify(tempReportDetails));
                navigate("/order/order-confirmation", {
                  state: { tempFormattedAddr, tempReportDetails },
                });
              } else {
                toast.error("Failed to place the order, Please try again", {
                  duration: 6000,
                  icon: (
                    <FontAwesomeIcon
                      style={{
                        fontSize: is4kScreen
                          ? "1.9rem"
                          : isXxlScreen
                          ? "1.6rem"
                          : isXlScreen
                          ? "1.5rem"
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "0.9rem"
                          : isMediumScreen
                          ? "1.4rem"
                          : "1rem",
                      }}
                      icon={faCircleExclamation}
                    />
                  ),
                  style: {
                    backgroundColor: "#FFC1B4",
                    color: "red",
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.15rem"
                      : isXlScreen
                      ? "1rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "1rem"
                      : isMediumScreen
                      ? "1.1rem"
                      : "1rem",
                    marginTop: is4kScreen
                      ? "2rem"
                      : isIpadProPortrait
                      ? "2rem"
                      : "",
                  },
                });
                return;
              }
            }
          } else {
            toast.error(res.message || "Payment failed, Please try again", {
              duration: 6000,
              icon: (
                <FontAwesomeIcon
                  style={{
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.6rem"
                      : isXlScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "0.9rem"
                      : isMediumScreen
                      ? "1.4rem"
                      : "1rem",
                  }}
                  icon={faCircleExclamation}
                />
              ),
              style: {
                backgroundColor: "#FFC1B4",
                color: "red",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
                marginTop: is4kScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : "",
              },
            });
          }
        } catch (e) {
          if (e?.status === 401) {
            navigate("/login");
          }

          console.log(e);
        } finally {
          setPaymentLoading(false);
        }
      } else {
        let tempAddr = [...selAddress];
        let tempFormattedAddr = [];
        if (tempAddr.length > 0) {
          tempAddr.map((addrVal, addrInd) => {
            let addr = {
              streetAddress: "",
              city: "",
              state: "",
              zip: "",
              lat: "",
              lon: "",
              type: "",
              claimProjectNo: "",
              itemPrice: 0,
              deliveryPrice: 0,
              totalPrice: 0,
              delivery: "",
              quantity: 1,
              promotionCode: "",
              paymentType: onPayBtnSel,
              discount: 0,
              ccEmail: "",
              teamNote: "",
            };
            addr.streetAddress = addrVal?.street;
            addr.city = addrVal?.city;
            addr.state = addrVal?.state;
            addr.zip = addrVal?.postalCode;
            let len = String(addrVal?.address).length;
            addr.lat = addrVal?.lat ? String(addrVal?.lat) : "";
            addr.lon = addrVal?.lng ? String(addrVal?.lng) : "";
            addr.type = addrVal?.type;
            addr.itemPrice = addrVal?.price;
            addr.delivery = addrVal?.delivery;
            addr.deliveryPrice = addrVal?.deliveryPrice;
            addr.totalPrice =
              Number(addrVal?.price) + Number(addrVal?.deliveryPrice);
            tempFormattedAddr.push(addr);
            addr.teamNote = additionalInfo[addrInd]?.notes;
            addr.claimProjectNo = additionalInfo[addrInd]?.claimNumber;
            addr.ccEmail = additionalInfo[addrInd]?.additionalMails.join(",");
          });
        }
        let tempReportDetails = {
          orderItems: [...tempFormattedAddr],
          customerId: `${customerId}`,
          paymentType: onPayBtnSel,
          managerNote: "",
          teamNote2: "",
          additionalEmails: "",
          reportLogo: "",
          reportFile: "",
          sendReportTo: "",
          status: "InQueue",
          cardLastDigits: null,
          paymentTransactionId: null,
        };

        // fetching from customer portal
        try {
          let orderResult = await fetch(`${POST_ORDER_REPORTS}`, {
            method: "POST",
            body: JSON.stringify(tempReportDetails),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${GetToken()}`, // Add your token here
            },
          });
          if (orderResult.ok) {
            setLoading(false);

            localStorage.removeItem("sel-places");
            localStorage.removeItem("selectedAddress");
            Cookies.remove("selectedAddress");
            toast.success("Order Placed Successfully!", {
              duration: 6000,
              icon: (
                <FontAwesomeIcon
                  style={{
                    color: "green",
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.6rem"
                      : isXlScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "0.9rem"
                      : isMediumScreen
                      ? "1.4rem"
                      : "1rem",
                  }}
                  icon={faCircleCheck}
                />
              ),
              style: {
                backgroundColor: "#E7EFC7",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
                marginTop: is4kScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : "",
              },
            });
localStorage.setItem("orderDetails", JSON.stringify(tempFormattedAddr));
localStorage.setItem("orderReportDetails", JSON.stringify(tempReportDetails));
            navigate("/order/order-confirmation", {
              state: { tempFormattedAddr, tempReportDetails },
            });
          } else {
            toast.error("Failed to place the order, Please try again", {
              duration: 6000,
              icon: (
                <FontAwesomeIcon
                  style={{
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.6rem"
                      : isXlScreen
                      ? "1.5rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "0.9rem"
                      : isMediumScreen
                      ? "1.4rem"
                      : "1rem",
                  }}
                  icon={faCircleExclamation}
                />
              ),
              style: {
                backgroundColor: "#FFC1B4",
                color: "red",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
                marginTop: is4kScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : "",
              },
            });
            return;
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  const [selectedSwitch, setSelectedSwitch] = useState(null);

  const handleSwitchChange = (switchId) => {
    setSelectedSwitch((prev) => (prev === switchId ? null : switchId));
  };

  const handleChoosePaymentType = () => {
    if (saveAndAddRadio === "savedCard") {
      placeOrderFromSavedCardHandler();
    } else if (saveAndAddRadio === "addCard") {
      placeOrderFromNewCardHandler();
    }
  };

  const handleChange = (event) => {
    let input = event.target.value;
    // Remove non-digit characters
    input = input.replace(/\D/g, "");
    // Limit the card number to 16-19 digits
    if (input.length > 19) {
      input = input.slice(0, 19);
    }
    // Format the card number (e.g., 1234 5678 9012 3456)
    const formattedInput = input.match(/.{1,4}/g)?.join(" ") || input;
    setCardNumber(formattedInput);
    // Identify card type
    const detectedCardType = getCardType(input);
    setCardType(detectedCardType);
    // Validate using Luhn algorithm
    if (input.length >= 13) {
      const isValid = isValidCardNumber(input);
      setError(isValid ? "" : "Invalid card number");
    } else {
      setError("");
    }
  };

  const [newCardDetails, setNewCardDetails] = useState({
    cardName: "",
    cardNumber: "",
    expiryDate: "",
    saveCard: false,
    makeDefaultCard: false,
  });
  const [newCardObj, setNewCardObj] = useState([]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Handle cardNumber separately for formatting and validation
    if (name === "cardNumber") {
      let input = value.replace(/\D/g, ""); // Remove non-digit characters

      // Limit to 19 digits
      if (input.length > 19) {
        input = input.slice(0, 19);
      }

      // Format into groups of 4 digits
      const formattedInput = input.match(/.{1,4}/g)?.join(" ") || input;

      // Set formatted value
      setNewCardDetails((prevDetails) => ({
        ...prevDetails,
        cardNumber: formattedInput,
      }));

      // Identify card type
      const detectedCardType = getCardType(input);
      setCardType(detectedCardType);

      // Luhn validation
      if (input.length >= 13) {
        const isValid = isValidCardNumber(input);
        setError(isValid ? "" : "Invalid card number");
      } else {
        setError("");
      }
    } else {
      // Handle all other inputs normally
      setNewCardDetails((prevDetails) => ({
        ...prevDetails,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const handleAddCard = () => {
    if (!newCardDetails.cardName || !newCardDetails.cardNumber) {
      return;
    }

    if (newCardDetails?.saveCard === true && allCards.length >= 5) {
      toast.error("Cannot Add more than 5 cards", {
        duration: 6000,
        icon: (
          <FontAwesomeIcon
            style={{
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.6rem"
                : isXlScreen
                ? "1.5rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "0.9rem"
                : isMediumScreen
                ? "1.4rem"
                : "1rem",
            }}
            icon={faCircleExclamation}
          />
        ),
        style: {
          backgroundColor: "#FFC1B4",
          color: "red",
          fontSize: is4kScreen
            ? "1.9rem"
            : isXxlScreen
            ? "1.15rem"
            : isXlScreen
            ? "1rem"
            : isIpadProPortrait
            ? "1.8rem"
            : isLargeScreen
            ? "1rem"
            : isMediumScreen
            ? "1.1rem"
            : "1rem",
          marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
        },
      });
      setSaveAndAddRadio("savedCard");
    } else {
      setNewCardObj((prevCards) => [...prevCards, newCardDetails]);

      setShowAddOrRemoveCardPopup(false);
    }
  };

  // useEffect(() => {
  //   const cardName = newCardDetails?.cardName;
  //   const cardNumber = newCardDetails?.cardNumber.replace(/\s/g, "");
  //   const cardExpirationDetails = newCardDetails?.expiryDate.split("/");

  //   let objcardName = newCardObj[0]?.cardName;
  //   let objexpiryDate = newCardObj[0]?.expiryDate.split("/");
  //   let objcardNumber = newCardObj[0]?.cardNumber.replace(/\s/g, "");
  //   console.log(
  //     "card details for new pyament",
  //     objcardName,
  //     objexpiryDate,
  //     objcardNumber
  //   );
  // }, [newCardDetails, newCardObj]);

  const [showModal, setShowModal] = useState(false);

  const handleOpen = () => {
    setShowModal(!showModal);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const reportData = [
    {
      title: "BASIC",
      sampleReport: [
       "/images/Basic_Sample_page.jpg"
      ],
    },
    {
      title: "STANDARD",
      sampleReport: [
        "/images/Standard_Sample_page.jpg",
      ],
    },
    {
      title: "COMPREHENSIVE",
      sampleReport: [
        "/images/comprehensiveSample_page-01.jpg",
        "/images/comprehensiveSample_page-02.jpg",
        "/images/comprehensiveSample_page-03.jpg",
        "/images/comprehensiveSample_page-04.jpg",
        "/images/comprehensiveSample_page-05.jpg",
        "/images/comprehensiveSample_page-06.jpg",
      ],
    },
    {
      title: "CLAIMS",
      sampleReport: [
           "/images/Claims_Sample_page.jpg",
      ],
    },
  ];

  const [reportFile, setReportFile] = useState(reportData[0].sampleReport);

  const handleChangeReportType = (reportName) => {
    let selectedReport = reportData.find(
      (report) => report.title === reportName
    );
    if (selectedReport) {
      setReportFile(selectedReport.sampleReport);
    }
  };

  const handleScrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const scrollContainerRef = useRef(null);
  const summaryCardRef = useRef(null);

  useEffect(() => {
    if (summaryCardRef.current) {
      summaryCardRef.current.scrollIntoView({
        behavior: "smooth",
        inline: "start",
      });
    }
  }, [summaryOptions.length]); // Replace with the actual trigger (e.g., selectedAddresses)

  const renderScrollTopButton = () => {
    return selAddress.map((item, index) => {
      const lastItem = index === selAddress.length - 1;

      return (
        <React.Fragment key={index}>
          {lastItem &&
          (is4kScreen ||
            isXxlScreen ||
            isXlScreen ||
            isLargeScreen ||
            isMediumScreen) ? (
            <div className="d-flex justify-content-end align-items-center">
              <button style={{ border: "none" }} onClick={handleScrollTop}>
                <FontAwesomeIcon
                  style={{
                    fontSize: is4kScreen
                      ? "1.5rem"
                      : isXxlScreen
                      ? "1.2rem"
                      : isXlScreen
                      ? "2rem"
                      : isLargeScreen
                      ? "0.9rem"
                      : "1rem",
                  }}
                  icon={faCircleArrowUp}
                />
              </button>
            </div>
          ) : null}
        </React.Fragment>
      );
    });
  };

  return (
    <>
      {loadingReports ? (
        <LoadingIndicator />
      ) : (
        <>
          <div
            className="row order-container"
            style={{
              marginTop: is4kScreen
                ? "8rem"
                : isXxlScreen
                ? "5rem"
                : isXlScreen
                ? "4.5rem"
                : isLargeScreen && isPortrait1024
                ? "7rem"
                : isLargeScreen
                ? "4.5rem"
                : isMediumScreen
                ? "6rem"
                : "5.5rem",
            }}
          >
            <StepHeader
              bg1={true}
              bg2={true}
              title1="Enter Address"
              title2="Add Instructions"
              title3="Confirm Order"
              bg3={pageNumber === "2" ? true : false}
            />
            {/* </div> */}
          </div>
          <div></div>
          {pageNumber === "1" && (
            <div
              className="my-4 purchase-cont"
              style={{
                padding: "0px 2rem",
                height: isSmallScreen
                  ? "auto"
                  : selAddress.length > 1
                  ? "auto"
                  : isLargeScreen
                  ? "auto"
                  : isLargeScreen && isPortrait1024
                  ? "100vh"
                  : isMediumScreen
                  ? "auto"
                  : "90vh",
              }}
            >
              <div
                ref={scrollContainerRef}
                className={`d-flex flex-column flex-lg-${
                  isLargeScreen && isPortrait1024 ? "column" : "row"
                } gap-2`}
                style={{
                  height: "100%",
                  paddingLeft: "0px",
                  paddingRight: "0px",
                }}
              >
                {/* Main Content Area */}
                <div
                  className={`col-12 col-md-12 col-lg-${
                    isLargeScreen && isPortrait1024 ? "12" : "9"
                  } `}
                >
                  {!selAddress && (
                    <Card className="h-100 d-flex align-items-center justify-content-center">
                      <p>No Address is selected</p>
                    </Card>
                  )}

                  {selAddress &&
                    selAddress.length &&
                    selAddress.map((address, addressIndex) => (
                      <Card
                        key={addressIndex}
                        className="mb-3"
                        style={{
                          padding: "1rem",
                        }}
                      >
                        <div className="row align-items-center g-2">
                          {/* Icon */}
                          <div className="col-auto">
                            <BsFillHouseFill
                              className="ms-2"
                              size={
                                is4kScreen ? 100 : isIpadProPortrait ? 80 : 50
                              }
                            />
                          </div>

                          {/* Address Info */}
                          <div className="col">
                            <h5
                              className="mb-1"
                              style={{
                                fontSize: isIpadProPortrait ? "1.8rem" : "",
                              }}
                            >
                              <b>{address.address}</b>
                            </h5>
                            <p
                              className="text-muted mb-0"
                              style={{
                                fontSize: isIpadProPortrait
                                  ? "1.6rem"
                                  : isMediumScreen
                                  ? "1rem"
                                  : "",
                              }}
                            >
                              {address.lat} , {address.lng}
                            </p>
                          </div>
                        </div>

                        <hr />

                        <div
                          className={`${
                            isLargeScreen && isLandscape1024 ? "column" : "row"
                          } text-center d-flex justify-content-center flex-wrap`}
                        >
                          {/* Report Type Section */}
                          <div
                            className={`col-12 col-md-12 col-lg-${
                              isLargeScreen ? "12" : isMediumScreen ? "12" : "8"
                            } mb-2  mb-lg-0`}
                          >
                            <h6
                              className="text-center"
                              style={{
                                lineHeight: is4kScreen
                                  ? "4rem"
                                  : isIpadProPortrait
                                  ? "3rem"
                                  : "",
                                fontSize: isIpadProPortrait
                                  ? "1.6rem"
                                  : isMediumScreen
                                  ? "1.2rem"
                                  : "",
                              }}
                            >
                              <b>Pick a Report Type:</b>
                            </h6>
                            <div className="d-flex report-option flex-wrap justify-content-evenly">
                              <>
                                {reports.map((option) => (
                                  <div className="d-flex flex-column">
                                    <button
                                      key={option.name}
                                      className={`report-button ${
                                        address.type === option.name
                                          ? "selected"
                                          : "not-selected"
                                      }`}
                                      style={{
                                        padding: is4kScreen
                                          ? "3rem"
                                          : isIpadProPortrait
                                          ? "3rem"
                                          : "1rem",
                                        minWidth: is4kScreen
                                          ? "15rem"
                                          : isIpadProPortrait
                                          ? "15rem"
                                          : isMediumScreen
                                          ? "10rem"
                                          : "7rem",
                                        fontSize: is4kScreen
                                          ? "1.9rem"
                                          : isIpadProPortrait
                                          ? "1.7rem"
                                          : isMediumScreen
                                          ? "1.25rem"
                                          : "1rem",
                                      }}
                                      onClick={() =>
                                        onReportSelect(addressIndex, option)
                                      }
                                    >
                                      {option.name} <br />{" "}
                                      <span
                                        style={{
                                          color:
                                            address.type === option.name
                                              ? "#ffffff"
                                              : "#000000",
                                        }}
                                      >
                                        ${option.price} USD
                                      </span>
                                    </button>
                                    <div
                                      style={{
                                        fontSize: is4kScreen
                                          ? "1.6rem"
                                          : isXxlScreen
                                          ? "0.9rem"
                                          : isIpadProPortrait
                                          ? "1.4rem"
                                          : isMediumScreen
                                          ? "1.25"
                                          : "12px",
                                        cursor: "pointer",
                                        textDecoration: "underline",
                                        color: "#5dddee",
                                      }}
                                      onClick={() => {
                                        setShowModal(!showModal);
                                        handleChangeReportType(option.name);
                                      }}
                                    >
                                      View Sample
                                    </div>
                                  </div>
                                ))}
                              </>
                            </div>
                          </div>

                          {/* Delivery Option Section */}
                          <div
                            className={`col-12 col-lg-${
                              isLargeScreen && isLandscape1024
                                ? "12"
                                : isMediumScreen
                                ? "12"
                                : "4"
                            } `}
                          >
                            <h6
                              style={{
                                lineHeight: is4kScreen ? "4rem" : "",
                                fontSize: isIpadProPortrait
                                  ? "1.6rem"
                                  : isMediumScreen
                                  ? "1.2rem"
                                  : "",
                              }}
                            >
                              <b>Pick a Delivery Option:</b>
                            </h6>
                            <div className="d-flex justify-content-center align-items-center report-option gap-3">
                              {deliveryOptions.map((option, ind) => (
                                <div className="d-flex flex-column">
                                  <button
                                    key={option.label}
                                    className={`report-button ${
                                      address.delivery === option.label
                                        ? "selected"
                                        : "not-selected"
                                    }`}
                                    style={{
                                      padding: is4kScreen
                                        ? "3rem"
                                        : isIpadProPortrait
                                        ? "3rem"
                                        : "1rem",
                                      minWidth: is4kScreen
                                        ? "15rem"
                                        : isIpadProPortrait
                                        ? "15rem"
                                        : isMediumScreen
                                        ? "10rem"
                                        : "7rem",
                                      fontSize: is4kScreen
                                        ? "1.9rem"
                                        : isIpadProPortrait
                                        ? "1.7rem"
                                        : isMediumScreen
                                        ? "1.25rem"
                                        : "1rem",
                                    }}
                                    onClick={() =>
                                      onDeliveryTypeSelect(addressIndex, option)
                                    }
                                  >
                                    {option.label}
                                    <br />

                                    <span
                                      style={{
                                        color:
                                          address.delivery === option.label
                                            ? "#ffffff"
                                            : "#000000",
                                      }}
                                    >
                                      {option.price === 0
                                        ? "FREE"
                                        : `$${option.price} USD`}
                                    </span>
                                  </button>
                                  <OverlayTrigger
                                    placement="bottom" // Change to "bottom", "left", "right" as needed
                                    trigger={["hover", "focus"]}
                                    overlay={
                                      <Tooltip
                                        id={`tooltip-top${ind}`}
                                        style={{
                                          fontSize: is4kScreen
                                            ? "1.6rem"
                                            : isIpadProPortrait
                                            ? "1.4rem"
                                            : isMediumScreen
                                            ? "1.1rem"
                                            : "1rem",
                                        }}
                                      >
                                        {option.toolTipDes}
                                      </Tooltip>
                                    }
                                  >
                                    <span className="d-inline-block">
                                      <FaQuestionCircle
                                        style={{
                                          cursor: "pointer",
                                          fontSize: is4kScreen
                                            ? "2rem"
                                            : isIpadProPortrait
                                            ? "1.8rem"
                                            : isMediumScreen
                                            ? "1.4rem"
                                            : "1rem",
                                        }}
                                        className="ms-2"
                                      />
                                    </span>
                                  </OverlayTrigger>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>

                        <hr />
                        {/* Form Section */}
                        <div className="form-section orders mb-3">
                          <Row className="mb-1">
                            <Col sm={4} md={6} lg={isIpadProPortrait ? 6 : 5}>
                              <label
                                style={{
                                  width: "100%",
                                  fontSize: is4kScreen
                                    ? "2rem"
                                    : isXxlScreen
                                    ? "1.25rem"
                                    : isXlScreen
                                    ? ""
                                    : isIpadProPortrait
                                    ? "1.8rem"
                                    : isLargeScreen
                                    ? "1rem"
                                    : isMediumScreen
                                    ? "1.3rem"
                                    : isSmallScreen
                                    ? ""
                                    : "1rem",
                                }}
                                className=" text-start col-md-4 col-lg-4"
                              >
                                Notes to Production Team
                                <OverlayTrigger
                                  placement={isSmallScreen ? "top" : "right"}
                                  show={showToolTip}
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip
                                      id="tooltip-top"
                                      style={{
                                        fontSize: is4kScreen
                                          ? "1.5rem"
                                          : isIpadProPortrait
                                          ? "1.4rem"
                                          : "1rem",
                                      }}
                                    >
                                      Add additional details about the structure
                                      or project
                                    </Tooltip>
                                  }
                                  popperConfig={{
                                    modifiers: [
                                      {
                                        name: "preventOverflow",
                                        options: { boundary: "viewport" }, // Keeps tooltip inside screen
                                      },
                                      {
                                        name: "computeStyles",
                                        options: { gpuAcceleration: false }, // Prevents flickering due to rendering
                                      },
                                    ],
                                  }}
                                >
                                  <span
                                    className="d-inline-block"
                                    onMouseEnter={() => setShowToolTip(true)}
                                    onMouseLeave={() => setShowToolTip(false)}
                                  >
                                    <FaQuestionCircle
                                      style={{ cursor: "pointer" }}
                                      className="ms-2"
                                    />
                                  </span>
                                </OverlayTrigger>
                              </label>
                            </Col>
                            <Col sm={8} md={6} lg={isIpadProPortrait ? 6 : 7}>
                              <input
                                type="text"
                                style={{
                                  height: is4kScreen
                                    ? "4.5rem"
                                    : isIpadProPortrait
                                    ? "3.8rem"
                                    : isMediumScreen
                                    ? "3.8rem"
                                    : "3rem",
                                  fontSize: is4kScreen
                                    ? "2rem"
                                    : isXxlScreen
                                    ? ""
                                    : isXlScreen
                                    ? ""
                                    : isIpadProPortrait
                                    ? "1.6rem"
                                    : isLargeScreen
                                    ? "1rem"
                                    : isMediumScreen
                                    ? "1.4rem"
                                    : "",
                                }}
                                className="form-control col-md-8 col-lg-8"
                                value={
                                  additionalInfo[addressIndex]?.notes || ""
                                }
                                onChange={handleAdditionalInfoChange(
                                  addressIndex,
                                  "notes"
                                )}
                              />
                            </Col>
                          </Row>

                          <Row className="mb-1 ">
                            <Col
                              sm={4}
                              md={6}
                              lg={isIpadProPortrait ? 6 : 5}
                              className="d-flex flex-wrap"
                            >
                              <label
                                className="form-label mt-3 fs-sm-2"
                                style={{
                                  fontSize: is4kScreen
                                    ? "2rem"
                                    : isXxlScreen
                                    ? "1.25rem"
                                    : isIpadProPortrait
                                    ? "1.8rem"
                                    : isMediumScreen
                                    ? "1.3rem"
                                    : "1rem",
                                }}
                              >
                                Send Report to Additional Emails
                                <OverlayTrigger
                                  placement={isSmallScreen ? "top" : "right"} // Change to "bottom", "left", "right" as needed
                                  trigger={["hover", "focus"]}
                                  overlay={
                                    <Tooltip
                                      id="tooltip-additinalMails"
                                      style={{
                                        fontSize: is4kScreen
                                          ? "2rem"
                                          : isIpadProPortrait
                                          ? "1.4rem"
                                          : "1rem",
                                      }}
                                    >
                                      You can enter multiple emails with a colon
                                      or comma separating them
                                    </Tooltip>
                                  }
                                >
                                  <span className="d-inline-block">
                                    <FaQuestionCircle
                                      style={{ cursor: "pointer" }}
                                      className="ms-2"
                                      title="I am sending notes"
                                    />
                                  </span>
                                </OverlayTrigger>
                              </label>
                            </Col>
                            <Col sm={8} md={6} lg={isIpadProPortrait ? 6 : 7}>
                              <ReactMultiEmail
                                className="react-multi-email-responsive"
                                style={{
                                  height: is4kScreen
                                    ? "4.5rem"
                                    : isIpadProPortrait
                                    ? "3.8rem"
                                    : isLargeScreen
                                    ? "3rem"
                                    : "",
                                  margin: "0rem",
                                  fontSize: isLargeScreen
                                    ? "1.2rem"
                                    : isIpadProPortrait
                                    ? "1.6rem !important"
                                    : isMediumScreen
                                    ? "1.4rem !important"
                                    : "",
                                }}
                                emails={
                                  additionalInfo[addressIndex]
                                    ?.additionalMails || []
                                }
                                // onChange={(emails) => {
                                //   setAdditionalInfo((prev) => {
                                //     const newData = [...prev];
                                //     newData[addressIndex] = {
                                //       ...newData[addressIndex],
                                //       additionalMails: emails,
                                //     };
                                //     return newData;
                                //   });
                                // }}
                                // autoFocus={true}
                                onChange={(emails) => {
                                  setAdditionalInfo((prev) => {
                                    const newData = [...prev];
                                    newData[addressIndex] = {
                                      ...newData[addressIndex],
                                      additionalMails: emails,
                                    };
                                    return newData;
                                  });
                                }}
                                onFocus={() => setFocused(true)}
                                onBlur={() => setFocused(false)}
                                getLabel={(email, index, removeEmail) => {
                                  return (
                                    <div data-tag key={index}>
                                      <div data-tag-item>{email}</div>
                                      <span
                                        data-tag-handle
                                        onClick={() => removeEmail(index)}
                                      >
                                        ×
                                      </span>
                                    </div>
                                  );
                                }}
                              />
                            </Col>
                          </Row>
                          <Row className="">
                            <Col sm={4} md={6} lg={isIpadProPortrait ? 6 : 5}>
                              <label
                                style={{
                                  fontSize: is4kScreen
                                    ? "2rem"
                                    : isXxlScreen
                                    ? "1.25rem"
                                    : isIpadProPortrait
                                    ? "1.8rem"
                                    : isMediumScreen
                                    ? "1.3rem"
                                    : "1rem",
                                }}
                              >
                                Claims Number
                                <OverlayTrigger
                                  placement={isSmallScreen ? "top" : "right"} // Change to "bottom", "left", "right" as needed
                                  trigger={["hover", "focus"]}
                                  overlay={
                                    <Tooltip
                                      id="tooltip-claims-number"
                                      style={{
                                        fontSize: is4kScreen
                                          ? "2rem"
                                          : isIpadProPortrait
                                          ? "1.4rem"
                                          : "1rem",
                                      }}
                                    >
                                      Enter your claim number and we will put it
                                      in the email delivery for easy reference
                                    </Tooltip>
                                  }
                                >
                                  <span className="d-inline-block">
                                    <FaQuestionCircle
                                      style={{ cursor: "pointer" }}
                                      className="ms-2"
                                      title="I am sending notes"
                                    />
                                  </span>
                                </OverlayTrigger>
                              </label>
                            </Col>
                            <Col sm={8} md={6} lg={isIpadProPortrait ? 6 : 7}>
                              <input
                                type="text"
                                className="form-control"
                                style={{
                                  height: is4kScreen
                                    ? "4.5rem"
                                    : isIpadProPortrait
                                    ? "3.8rem"
                                    : isMediumScreen
                                    ? "3.8rem"
                                    : "3rem",
                                  fontSize: is4kScreen
                                    ? "2rem"
                                    : isPortrait1024
                                    ? "1.6rem"
                                    : isMediumScreen
                                    ? "1.4rem"
                                    : "",
                                }}
                                value={
                                  additionalInfo[addressIndex]?.claimNumber ||
                                  ""
                                }
                                onChange={handleAdditionalInfoChange(
                                  addressIndex,
                                  "claimNumber"
                                )}
                              />
                            </Col>
                          </Row>
                        </div>
                      </Card>
                    ))}
                </div>

                <Card
                  className={`col-12  col-md-12 col-lg-${
                    isLargeScreen && isPortrait1024 ? "12" : "3"
                  } d-flex flex-column`}
                  style={{
                    height:
                      isLargeScreen && isPortrait1024
                        ? "50vh"
                        : isXlScreen
                        ? "70vh"
                        : "65vh",
                    top: is4kScreen
                      ? "15rem"
                      : isXxlScreen && devicePixelRatio >= 1.5
                      ? "9.5rem"
                      : isXxlScreen
                      ? "11.2rem"
                      : isXlScreen && devicePixelRatio >= 1.5
                      ? "5rem"
                      : isXlScreen
                      ? "6rem"
                      : isLargeScreen && isPortrait1024
                      ? "6rem"
                      : isLargeScreen
                      ? "4rem"
                      : isMediumScreen
                      ? ""
                      : "",
                    position: "sticky",
                  }}
                >
                  <Card.Body className="" style={{ width: "100%" }}>
                    <Card.Title
                      className=""
                      style={{
                        fontSize: is4kScreen
                          ? "2.4rem"
                          : isXxlScreen
                          ? "1.5rem"
                          : isXlScreen
                          ? ""
                          : isIpadProPortrait
                          ? "2rem "
                          : isLargeScreen && isPortrait1024
                          ? "1.3rem"
                          : isMediumScreen
                          ? "1.3rem"
                          : "1rem",
                      }}
                    >
                      <b>Summary</b>
                    </Card.Title>
                    <hr />
                    <div
                      className="items  d-flex flex-column"
                      style={{ height: "30vh" }}
                    >
                      {summaryOptions.map((summary) => (
                        <div key={summary.type}>
                          <p
                            className={`d-flex justify-content-between ${
                              summary.count ? "" : "d-none"
                            }`}
                          >
                            <span
                              style={{
                                fontSize: is4kScreen
                                  ? "2rem"
                                  : isXxlScreen
                                  ? "1.2rem"
                                  : isXlScreen
                                  ? ""
                                  : isIpadProPortrait
                                  ? "1.8rem"
                                  : isLargeScreen
                                  ? ""
                                  : isMediumScreen
                                  ? "1.3rem"
                                  : "",
                              }}
                            >
                              {summary.type} x {summary.count}
                            </span>
                            <span
                              style={{
                                fontSize: is4kScreen
                                  ? "2rem"
                                  : isXxlScreen
                                  ? "1.2rem"
                                  : isXlScreen
                                  ? ""
                                  : isIpadProPortrait
                                  ? "1.8rem"
                                  : isLargeScreen
                                  ? ""
                                  : isMediumScreen
                                  ? "1.3rem"
                                  : "",
                              }}
                            >
                              ${summary.value.toFixed(2)} USD
                            </span>
                          </p>
                        </div>
                      ))}
                      {/* <hr /> */}
                      {/* Estimated Total with auto margin */}
                      <p
                        className="d-flex justify-content-between mt-auto"
                        style={{
                          borderTop: "1px solid #ccc",
                          paddingTop: "1rem",
                          fontSize: is4kScreen
                            ? "2.2rem"
                            : isXxlScreen
                            ? "1.2rem"
                            : isIpadProPortrait
                            ? "1.8rem"
                            : isMediumScreen
                            ? "1.3rem"
                            : "1rem",
                        }}
                      >
                        <span>Estimated Total:</span>
                        <span>${EstimatedTotal.toFixed(2)} USD</span>
                      </p>
                    </div>
                  </Card.Body>
                  <div>
                    <div
                      className="mb-3"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingTop: isXlScreen ? "1rem" : "",
                      }}
                    >
                      <button
                        disabled={toggleSummaryBtn}
                        className="btn login-btns "
                        onClick={navigateToPurchaseSummary}
                        style={{
                          fontSize: is4kScreen
                            ? "2rem"
                            : isXxlScreen
                            ? "1.2rem"
                            : isIpadProPortrait
                            ? "1.8rem"
                            : isMediumScreen
                            ? "1.3rem"
                            : "1rem",
                          width: isMediumScreen
                            ? "50%"
                            : isLargeScreen && isPortrait1024
                            ? "40%"
                            : isMediumScreen
                            ? "30%"
                            : "60%",
                          border: "none",
                        }}
                      >
                        Confirm Order
                      </button>
                    </div>
                  </div>
                </Card>
                {/* </div> */}
              </div>
              <Modal
                show={showModal}
                onHide={handleClose}
                onClick={(e) => e.stopPropagation()}
                centered
                scrollable
                backdrop="static"
              >
                <ModalHeader closeButton style={{ background: "lightblue" }}>
                  <ModalTitle>Full Sample</ModalTitle>
                </ModalHeader>
                <ModalBody
                  style={{ height: "80vh" }}
                  className="hide-scrollbar embed-responsive"
                >
                  {reportFile.map((file, ind) => (
                    <img
                      key={ind + 1}
                      src={file}
                      style={{
                        width: "100%",
                        height: "100%",
                        marginTop: "0.5rem",
                        objectFit: "contain",
                        border: "1px solid #000",
                      }}
                    />
                  ))}
                </ModalBody>
              </Modal>
            </div>
          )}
          {pageNumber === "2" && (
            <div
              className="my-4 purchase-cont flex-grow "
              style={{
                padding: "0px 3rem",
                minHeight: "80vh",
              }}
            >
              <div
                className={`${isIpadProPortrait ? "column" : "row "}`}
                style={{ height: "100%" }}
              >
                {/* order details and payment method */}

                <div
                  className={`col-md-${
                    isIpadProPortrait ? "12" : isMediumScreen ? "12" : "9"
                  } `}
                >
                  {/* Order Details Card */}
                  <Card
                    className="mb-3"
                    style={{ maxHeight: "50vh", overflowY: "auto" }}
                  >
                    <CardHeader
                      className="bg-lightblue text-bold"
                      style={{
                        fontFamily: "Calibri Bold",
                        fontSize: is4kScreen
                          ? "2rem"
                          : isXxlScreen
                          ? "1.4rem"
                          : isXlScreen
                          ? "1.2rem"
                          : isIpadProPortrait
                          ? "1.95rem"
                          : isLargeScreen
                          ? ""
                          : isMediumScreen
                          ? "1.7rem"
                          : "",
                        backgroundColor: "lightblue",
                      }}
                    >
                      <b>Order Details</b>
                    </CardHeader>
                    <CardBody className="card-summary-body">
                      {selAddress &&
                        selAddress.length > 0 &&
                        selAddress.map((address, addressIndex) => (
                          <div
                            key={addressIndex}
                            className="p-3 border rounded"
                            style={{ marginBottom: "0.7rem" }}
                          >
                            <div className="row align-items-center g-3 mb-3">
                              {/* House Icon */}
                              <div className="col-2 col-md-1 d-flex justify-content-center">
                                <BsFillHouseFill
                                  size={
                                    is4kScreen
                                      ? 70
                                      : isIpadProPortrait
                                      ? 80
                                      : isMediumScreen
                                      ? 80
                                      : isSmallScreen
                                      ? 50
                                      : 40
                                  }
                                />
                              </div>

                              {/* Address Details */}
                              <div className="col-10 col-md-4">
                                <p
                                  className="mb-1 fw-bold"
                                  style={{
                                    fontSize: is4kScreen
                                      ? "2rem"
                                      : isIpadProPortrait
                                      ? "1.6rem"
                                      : isLargeScreen
                                      ? "1rem"
                                      : isMediumScreen
                                      ? "1.3rem"
                                      : isSmallScreen
                                      ? "1.1rem"
                                      : "1rem",
                                  }}
                                >
                                  {address.address}
                                </p>
                                <span
                                  className="text-muted"
                                  style={{
                                    fontSize: is4kScreen
                                      ? "2rem"
                                      : isIpadProPortrait
                                      ? "1.3rem"
                                      : isMediumScreen
                                      ? "1.1rem"
                                      : "1rem",
                                  }}
                                >
                                  {address.lat}, {address.lng}
                                </span>
                              </div>

                              {/* Report & Delivery Types */}
                              <div className="col-md-5 d-flex flex-wrap justify-content-between gap-2">
                                <div className="flex-fill text-center p-2 ">
                                  <p
                                    className="fw-semibold text-nowrap"
                                    style={{
                                      fontSize: is4kScreen
                                        ? "2rem"
                                        : isIpadProPortrait
                                        ? "1.6rem"
                                        : isMediumScreen
                                        ? "1.3rem"
                                        : "1rem",
                                    }}
                                  >
                                    Report Type
                                  </p>
                                  <div className="bg-secondary text-white p-2 rounded">
                                    <p
                                      className="fw-bold"
                                      style={{
                                        fontSize: is4kScreen
                                          ? "2rem"
                                          : isIpadProPortrait
                                          ? "1.5rem"
                                          : isLargeScreen
                                          ? "0.8rem"
                                          : isSmallScreen
                                          ? "0.9rem"
                                          : "1rem",
                                      }}
                                    >
                                      {address.type || "REPORT"}
                                    </p>
                                    <p
                                      className="fw-bold"
                                      style={{
                                        fontSize: is4kScreen
                                          ? "2rem"
                                          : isIpadProPortrait
                                          ? "1.5rem"
                                          : isLargeScreen
                                          ? "0.8rem"
                                          : isSmallScreen
                                          ? "0.9rem"
                                          : "1rem",
                                      }}
                                    >
                                      ${address.price || "0"} USD
                                    </p>
                                  </div>
                                </div>

                                <div className="flex-fill text-center p-2">
                                  <p
                                    className="fw-semibold text-nowrap"
                                    style={{
                                      fontSize: is4kScreen
                                        ? "2rem"
                                        : isIpadProPortrait
                                        ? "1.6rem"
                                        : isMediumScreen
                                        ? "1.3rem"
                                        : "1rem",
                                    }}
                                  >
                                    Delivery Type
                                  </p>
                                  <div className="bg-secondary text-white p-2 rounded">
                                    <p
                                      className="fw-bold"
                                      style={{
                                        fontSize: is4kScreen
                                          ? "2rem"
                                          : isIpadProPortrait
                                          ? "1.5rem"
                                          : isLargeScreen
                                          ? "0.8rem"
                                          : isSmallScreen
                                          ? "0.9rem"
                                          : "1rem",
                                      }}
                                    >
                                      {address.delivery || "DELIVERY"}
                                    </p>
                                    <p
                                      className="fw-bold"
                                      style={{
                                        fontSize: is4kScreen
                                          ? "2rem"
                                          : isIpadProPortrait
                                          ? "1.5rem"
                                          : isLargeScreen
                                          ? "0.8rem"
                                          : isSmallScreen
                                          ? "0.9rem"
                                          : "1rem",
                                      }}
                                    >
                                      ${address.deliveryPrice || "0"} USD
                                    </p>
                                  </div>
                                </div>
                              </div>

                              {/* Total Price */}
                              <div className="col-12 col-md-2 d-flex justify-content-md-end justify-content-center mt-3 mt-md-0 mt-lg-5">
                                <p
                                  className="fw-bold"
                                  style={{
                                    fontSize: is4kScreen
                                      ? "3rem"
                                      : isXxlScreen
                                      ? "1.8rem"
                                      : isXlScreen
                                      ? "1.7rem"
                                      : isIpadProPortrait
                                      ? "2.6rem"
                                      : isLargeScreen
                                      ? "1.2rem"
                                      : isMediumScreen
                                      ? "1.8rem"
                                      : isSmallScreen
                                      ? "1.4rem"
                                      : "1rem",
                                  }}
                                >
                                  $
                                  {Number(address.price) +
                                    Number(address.deliveryPrice || 0)} USD
                                </p>
                              </div>
                            </div>

                            {/* Notes & Additional Info */}
                            <div className="row align-items-center">
                              <div className="col-md-10 d-flex align-items-center">
                                <p
                                  className="text-muted mb-0"
                                  style={{
                                    fontSize: is4kScreen
                                      ? "1.4rem"
                                      : isIpadProPortrait
                                      ? "1.4rem"
                                      : isLargeScreen
                                      ? "0.9rem"
                                      : isXlScreen
                                      ? "0.9rem"
                                      : isSmallScreen
                                      ? "0.8rem"
                                      : "1rem",
                                  }}
                                >
                                  Notes, Additional Emails, Claims Number
                                </p>
                                <Button
                                  id="myButton"
                                  variant="outline-secondary"
                                  className="ms-2"
                                  style={{
                                    height: isLargeScreen
                                      ? "1.3rem"
                                      : isXlScreen
                                      ? "1.3rem"
                                      : isXxlScreen
                                      ? "1.6rem"
                                      : "",
                                    width: isLargeScreen
                                      ? "1.3rem"
                                      : isXlScreen
                                      ? "1.3rem"
                                      : isXxlScreen
                                      ? "1.6rem"
                                      : "",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                  onClick={() => toggleChange(addressIndex)}
                                >
                                  {trueToggle[addressIndex] ? (
                                    <FontAwesomeIcon
                                      style={{
                                        fontSize: isLargeScreen
                                          ? "0.9rem"
                                          : isXlScreen
                                          ? "1rem"
                                          : isXxlScreen
                                          ? "1.2rem"
                                          : "",
                                      }}
                                      icon={faChevronUp}
                                    />
                                  ) : (
                                    <FontAwesomeIcon
                                      style={{
                                        fontSize: isLargeScreen
                                          ? "0.9rem"
                                          : isXlScreen
                                          ? "1rem"
                                          : isXxlScreen
                                          ? "1.2rem"
                                          : "",
                                      }}
                                      icon={faChevronDown}
                                    />
                                  )}
                                </Button>
                              </div>

                              {/* Remove Button */}
                              {!isPromoApplied && (
                                <div
                                  className="col-md-2 text-end text-danger fw-bold cursor-pointer"
                                  onClick={() =>
                                    removeCardHandler(addressIndex)
                                  }
                                  style={{
                                    fontSize: is4kScreen
                                      ? "1.6rem"
                                      : isSmallScreen
                                      ? "0.7rem"
                                      : isIpadProPortrait
                                      ? "1.4rem"
                                      : "1rem",
                                    cursor: "pointer",
                                  }}
                                >
                                  Remove
                                </div>
                              )}

                              {/* Expanded Notes */}
                              {trueToggle[addressIndex] && (
                                <div className="col-12 mt-2 p-2 bg-light rounded">
                                  <p
                                    className=""
                                    style={{
                                      fontSize: is4kScreen
                                        ? "1.2rem"
                                        : isXxlScreen
                                        ? ""
                                        : isXlScreen
                                        ? " "
                                        : isIpadProPortrait
                                        ? "1.3rem"
                                        : isLargeScreen
                                        ? ""
                                        : isMediumScreen
                                        ? "1.1rem"
                                        : isSmallScreen
                                        ? ""
                                        : "",
                                    }}
                                  >
                                    {additionalInfo[addressIndex]?.notes}
                                  </p>
                                  {additionalInfo[
                                    addressIndex
                                  ]?.additionalMails?.map((email, idx) => (
                                    <p
                                      key={idx}
                                      style={{
                                        fontSize: is4kScreen
                                          ? "1.2rem"
                                          : isXxlScreen
                                          ? ""
                                          : isXlScreen
                                          ? " "
                                          : isIpadProPortrait
                                          ? "1.3rem"
                                          : isLargeScreen
                                          ? "0.9rem"
                                          : isMediumScreen
                                          ? "1.1rem"
                                          : isSmallScreen
                                          ? ""
                                          : "",
                                      }}
                                    >
                                      {email}
                                    </p>
                                  ))}
                                  <p
                                    style={{
                                      fontSize: is4kScreen
                                        ? "1.2rem"
                                        : isXxlScreen
                                        ? ""
                                        : isXlScreen
                                        ? " "
                                        : isIpadProPortrait
                                        ? "1.3rem"
                                        : isLargeScreen
                                        ? "0.9rem"
                                        : isMediumScreen
                                        ? "1.1rem"
                                        : isSmallScreen
                                        ? ""
                                        : "",
                                    }}
                                  >
                                    {additionalInfo[addressIndex]?.claimNumber}
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                    </CardBody>
                  </Card>

                  {/* Payment Method Card */}
                  <Card
                    className=" mt-3"
                    style={{
                      maxHeight: "auto",
                      marginBottom: isSmallScreen ? "1rem" : "",
                    }}
                  >
                    <CardHeader
                      className="bg-lightblue text-bold"
                      style={{
                        fontFamily: "Calibri Bold",
                        fontSize: is4kScreen
                          ? "2rem"
                          : isXxlScreen
                          ? "1.4rem"
                          : isXlScreen
                          ? "1.2rem"
                          : isIpadProPortrait
                          ? "1.95rem"
                          : isLargeScreen
                          ? ""
                          : isMediumScreen
                          ? "1.7rem"
                          : "",
                        backgroundColor: "lightblue",
                      }}
                    >
                      <b>Payment Method</b>
                    </CardHeader>
                    <CardBody>
                      {/* Promo Code Section */}
                      <div className="row align-items-center credits-purchase g-1 mb-3">
                        <div className="col-12 col-md-2 d-flex justify-content-center align-items-center">
                          <b
                            className=""
                            style={{
                              fontSize: is4kScreen
                                ? "1.7rem"
                                : isIpadProPortrait
                                ? "1.6rem"
                                : isMediumScreen
                                ? "1.2rem"
                                : "1rem",
                            }}
                          >
                            Add Promo Code
                          </b>
                        </div>
                        <div className="col-12 col-md-6">
                          <input
                            type="text"
                            value={promo}
                            className="form-control"
                            onChange={onPromoHandler}
                            disabled={onPayBtnSel === 0}
                          />
                        </div>
                        <div className="col-12 col-md-3 mt-2 mt-md-0">
                          <button
                            type="submit"
                            className="topbar-btns search-btn w-100"
                            disabled={promo === "" || onPayBtnSel === 0}
                            onClick={checkPromo}
                            style={{
                              fontSize: is4kScreen
                                ? "1.7rem"
                                : isIpadProPortrait
                                ? "1.6rem"
                                : isMediumScreen
                                ? "1.2rem"
                                : "1rem",
                              marginLeft: isIpadProPortrait
                                ? "0.8rem"
                                : isMediumScreen
                                ? "0.8rem"
                                : "",
                            }}
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                      {onPayBtnSel === 0 && (
                        <div className="row mb-2">
                          <div
                            className="col-md-7 offset-md-2 text-danger"
                            style={{
                              fontSize: is4kScreen
                                ? "1.8rem"
                                : isXxlScreen
                                ? ""
                                : isXlScreen
                                ? ""
                                : isIpadProPortrait
                                ? "1.5rem"
                                : isMediumScreen
                                ? "1.1rem"
                                : "14px",
                            }}
                          >
                            Promo code cannot be applied when paying with
                            credits.
                          </div>
                        </div>
                      )}
                      {showPromoErrorMsg && (
                        <div className="row mb-2">
                          <div
                            className="col-md-7 offset-md-2 text-danger"
                            style={{
                              fontSize: is4kScreen
                                ? "1.8rem"
                                : isXxlScreen
                                ? ""
                                : isXlScreen
                                ? ""
                                : isIpadProPortrait
                                ? "1.5rem"
                                : isMediumScreen
                                ? "1.1rem"
                                : "14px",
                            }}
                          >
                            Please enter a valid Promo Code.
                          </div>
                        </div>
                      )}
                      {discountNotFlag && (
                        <div className="row mb-2">
                          <div
                            className="col-md-7 offset-md-2 text-danger"
                            style={{
                              fontSize: is4kScreen
                                ? "1.8rem"
                                : isXxlScreen
                                ? ""
                                : isXlScreen
                                ? ""
                                : isIpadProPortrait
                                ? "1.5rem"
                                : isMediumScreen
                                ? "1.1rem"
                                : "14px",
                            }}
                          >
                            Promo code not applicable.
                          </div>
                        </div>
                      )}
                      {isPromoApplied && (
                        <div className="row mb-2">
                          <div
                            className="col-md-7 offset-md-2 text-success"
                            style={{
                              fontSize: is4kScreen
                                ? "1.8rem"
                                : isXxlScreen
                                ? ""
                                : isXlScreen
                                ? ""
                                : isIpadProPortrait
                                ? "1.5rem"
                                : isMediumScreen
                                ? "1.1rem"
                                : "14px",
                            }}
                          >
                            Promo code applied successfully!
                          </div>
                        </div>
                      )}
                      <hr />

                      {/* Pay with Credits Section */}
                      <div className="row align-items-center g-2 mb-3">
                        <div className="col-auto">
                          <input
                            type="radio"
                            name="credits"
                            style={{
                              width: is4kScreen
                                ? "1.5rem"
                                : isIpadProPortrait
                                ? "1.3rem"
                                : isMediumScreen
                                ? "0.9rem"
                                : "",
                              height: is4kScreen
                                ? "1.5rem"
                                : isIpadProPortrait
                                ? "1.3rem"
                                : isMediumScreen
                                ? "0.9rem"
                                : "",
                            }}
                            onChange={(e) => {
                              //  setHasManuallySelectedPayment(true);
                              payWithCredits(e, true);
                              setOnPayBtnSel(0);
                            }}
                            value={0}
                            checked={onPayBtnSel === 0}
                            disabled={
                              disablecreditsRadio || disableBasicCredit || promo
                            }
                          />
                        </div>
                        <div className="col">
                          {
                            // disableBasicCredit ? (
                            //   <b
                            //     style={{
                            //       color: "red",
                            //       fontSize: is4kScreen
                            //         ? "2rem"
                            //         : isIpadProPortrait
                            //         ? "1.8rem"
                            //         : isMediumScreen
                            //         ? "1.2rem"
                            //         : "1rem",
                            //       marginLeft: isIpadProPortrait
                            //         ? "0.5rem"
                            //         : isMediumScreen
                            //         ? "0.5rem"
                            //         : "",
                            //     }}
                            //   >
                            //     Cannot pay with credits for Basic report
                            //   </b>
                            // ) :
                            disablecreditsRadio ? (
                              <b
                                style={{
                                  color: "red",
                                  fontSize: is4kScreen
                                    ? "2rem"
                                    : isIpadProPortrait
                                    ? "1.8rem"
                                    : isMediumScreen
                                    ? "1.2rem"
                                    : "1rem",
                                  marginLeft: isIpadProPortrait
                                    ? "0.5rem"
                                    : isMediumScreen
                                    ? "0.5rem"
                                    : "",
                                }}
                              >
                                No Sufficient Credits
                              </b>
                            ) : (
                              <b
                                style={{
                                  fontSize: is4kScreen
                                    ? "2rem"
                                    : isIpadProPortrait
                                    ? "1.8rem"
                                    : isMediumScreen
                                    ? "1.3rem"
                                    : "1rem",
                                  marginLeft: isIpadProPortrait
                                    ? "0.5rem"
                                    : isMediumScreen
                                    ? "0.5rem"
                                    : "",
                                }}
                              >
                                Pay with Credits
                              </b>
                            )
                          }
                        </div>
                        {!disableBasicCredit ? (
                          <div
                            style={{
                              fontSize: is4kScreen
                                ? "1.5rem"
                                : isIpadProPortrait
                                ? "1.4rem"
                                : isMediumScreen
                                ? "0.9rem"
                                : "0.8rem",
                            }}
                            className="col text-end underline-text"
                            onClick={() => setShowCredits(true)}
                          >
                            See Available Credits
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                      <hr />

                      {/* Pay with Card Section */}
                      <div className="row align-items-center g-2">
                        <div className="col-auto">
                          <input
                            type="radio"
                            disabled={!defaultCardNumber}
                            name="creditCard"
                            value={1}
                            onChange={() => {
                              //  setHasManuallySelectedPayment(true);
                              setOnPayBtnSel(1);
                              setCreditsApplied(false);
                              setAfterCreditsApply([]); // Reset credits array
                              setCreditsTotal(0);
                            }}
                            checked={onPayBtnSel === 1}
                            style={{
                              width: is4kScreen
                                ? "1.5rem"
                                : isIpadProPortrait
                                ? "1.3rem"
                                : isMediumScreen
                                ? "0.9rem"
                                : "",
                              height: is4kScreen
                                ? "1.5rem"
                                : isIpadProPortrait
                                ? "1.3rem"
                                : isMediumScreen
                                ? "0.9rem"
                                : "",
                            }}
                          />
                        </div>
                        <div className="col">
                          <b
                            style={{
                              fontSize: is4kScreen
                                ? "2rem"
                                : isIpadProPortrait
                                ? "1.8rem"
                                : isMediumScreen
                                ? "1.2rem"
                                : "1rem",
                              marginLeft: isIpadProPortrait
                                ? "0.5rem"
                                : isMediumScreen
                                ? "0.5rem"
                                : "",
                            }}
                          >
                            Pay with Card
                          </b>
                        </div>
                        <div
                          style={{
                            fontSize: is4kScreen
                              ? "1.5rem"
                              : isIpadProPortrait
                              ? "1.4rem"
                              : isMediumScreen
                              ? "0.9rem"
                              : "0.8rem",
                          }}
                          className="col text-end underline-text"
                          onClick={openAddCardPopUp}
                        >
                          Add/Change Card
                        </div>
                      </div>

                      <div>
                        {saveAndAddRadio === "savedCard" ? (
                          <>
                            <p
                              style={{
                                fontSize: isIpadProPortrait
                                  ? "1.6rem"
                                  : isMediumScreen
                                  ? "1rem"
                                  : "",
                              }}
                            >
                              Paying With Saved Card{" "}
                              <span style={{ fontWeight: "bold" }}>
                                {defaultCardNumber}
                              </span>
                            </p>
                          </>
                        ) : saveAndAddRadio === "addCard" ? (
                          <>
                            <p
                              style={{
                                fontSize: isIpadProPortrait
                                  ? "1.6rem"
                                  : isMediumScreen
                                  ? "1rem"
                                  : "",
                              }}
                            >
                              Paying with New Card{" "}
                              <span style={{ fontWeight: "bold" }}>
                                {newCardObj.length > 0 &&
                                newCardObj[newCardObj.length - 1].cardNumber
                                  ? newCardObj[
                                      newCardObj.length - 1
                                    ].cardNumber.slice(-4)
                                  : ""}
                              </span>
                            </p>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </CardBody>
                  </Card>
                </div>

                {/* Summary */}
                <Card
                  className={`col-md-${
                    isIpadProPortrait ? "12" : isMediumScreen ? "12" : "3"
                  } col-12 mt-md-${
                    isIpadProPortrait ? "3" : isMediumScreen ? "3" : ""
                  } `}
                  style={{ height: "auto" }}
                >
                  <Card.Body>
                    <Card.Title
                      className="summary-title"
                      style={{
                        fontSize: is4kScreen
                          ? "1.9rem"
                          : isXxlScreen
                          ? "1.3rem"
                          : isXlScreen
                          ? ""
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "1.1rem "
                          : "",
                      }}
                    >
                      <b>Summary</b>
                    </Card.Title>
                    <hr style={{ border: "1px solid #ccc", width: "100%" }} />
                    <div
                      className="items d-flex flex-column "
                      style={{
                        height: "40vh",
                        justifyContent: "space-between",
                      }}
                    >
                      <div className="">
                        {selAddress.length > 0 && (
                          <>
                            {summaryOptions.map((summary, index) => (
                              <p
                                className={`d-flex justify-content-between ${
                                  summary.count ? "" : "d-none"
                                }`}
                                style={{
                                  fontSize: is4kScreen
                                    ? "2rem"
                                    : isXxlScreen
                                    ? "1.15rem"
                                    : isXlScreen
                                    ? ""
                                    : isIpadProPortrait
                                    ? "1.8rem"
                                    : isLargeScreen
                                    ? ""
                                    : isMediumScreen
                                    ? "1.3rem"
                                    : "1rem",
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: is4kScreen
                                      ? "2rem"
                                      : isXxlScreen
                                      ? "1.15rem"
                                      : isXlScreen
                                      ? ""
                                      : isIpadProPortrait
                                      ? "1.8rem"
                                      : isLargeScreen
                                      ? ""
                                      : isMediumScreen
                                      ? "1.3rem"
                                      : "1rem",
                                  }}
                                >
                                  {summary.type} x {summary.count}
                                </span>
                                <span>${summary.value.toFixed(2)} USD</span>
                              </p>
                            ))}

                            {afterCreditsApply.length > 0 &&
                              afterCreditsApply.map((brick, bind) => (
                                <p className="item" key={bind}>
                                  <span
                                    style={{
                                      fontSize: is4kScreen
                                        ? "2rem"
                                        : isXxlScreen
                                        ? "1.15rem"
                                        : isXlScreen
                                        ? ""
                                        : isIpadProPortrait
                                        ? "1.8rem"
                                        : isLargeScreen
                                        ? ""
                                        : isMediumScreen
                                        ? "1.3rem"
                                        : "1rem",
                                    }}
                                  >
                                    {brick.type} X {brick.count} Credits
                                  </span>{" "}
                                  <span
                                    style={{
                                      color: "red",
                                      fontSize: is4kScreen
                                        ? "2rem"
                                        : isXxlScreen
                                        ? "1.15rem"
                                        : isXlScreen
                                        ? ""
                                        : isIpadProPortrait
                                        ? "1.8rem"
                                        : isLargeScreen
                                        ? ""
                                        : isMediumScreen
                                        ? "1.3rem"
                                        : "1rem",
                                    }}
                                  >
                                    -${brick.value.toFixed(2)} USD
                                  </span>
                                </p>
                              ))}

                            {discount !== 0 && !discountNotFlag && (
                              <p
                                className="item"
                                style={{
                                  fontSize: is4kScreen
                                    ? "2rem"
                                    : isXxlScreen
                                    ? "1.15rem"
                                    : isXlScreen
                                    ? ""
                                    : isIpadProPortrait
                                    ? "1.8rem"
                                    : isLargeScreen
                                    ? ""
                                    : isMediumScreen
                                    ? "1.3rem"
                                    : "1rem",
                                }}
                              >
                                <span style={{ width: "70%" }}>{promo} </span>
                                <span style={{ color: "red" }}>
                                  -${discount.toFixed(2)} USD
                                </span>
                              </p>
                            )}
                          </>
                        )}
                      </div>
                      <div>
                        <hr
                          style={{ border: "1px solid #ddd", width: "100%" }}
                        />
                        <p
                          className="item"
                          style={{
                            fontSize: is4kScreen
                              ? "2.1rem"
                              : isXxlScreen
                              ? "1.2rem"
                              : isIpadProPortrait
                              ? "1.6rem"
                              : isMediumScreen
                              ? "1.2rem"
                              : "",
                          }}
                        >
                          <span>Estimated Total: </span>
                          <span>
                            $
                            {selAddress.length > 0
                              ? EstimatedTotal.toFixed(2)
                              : 0} USD
                          </span>
                        </p>
                      </div>
                    </div>
                  </Card.Body>
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      marginTop: isIpadProPortrait
                        ? "1.5rem"
                        : isMediumScreen
                        ? "1.5rem"
                        : "",
                    }}
                  >

                    <button
  className="col-md-10 topbar-btns search-btn"
  style={{
    position: "absolute",
    bottom: "0.5em",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: is4kScreen
      ? "1.9rem"
      : isIpadProPortrait
      ? "1.8rem"
      : isMediumScreen
      ? ""
      : "",
    width: isIpadProPortrait ? "40%" : isMediumScreen ? "40%" : "",
  }}
  disabled={
    paymentLoading ||
    selAddress.length === 0 ||
    (saveAndAddRadio === "addCard" && newCardObj.length === 0)
  }
  onClick={() => handleChoosePaymentType()}
>
  {paymentLoading ? (
    <Spinner
      animation="border"
      role="status"
      style={{ padding: is4kScreen ? "0.5rem" : "" }}
    />
  ) : (
    <span title="I am showing">
      {onPayBtnSel === 0 ? "Place Order" : "Pay & Place Order"}
    </span>
  )}
</button>

                  </div>
                </Card>

                {/* Cards Modal */}
                <Modal
                  className="col-12"
                  show={showAddOrRemoveCardPopup}
                  onHide={handleCardPopupClose}
                >
                  <ModalHeader style={{ background: "lightblue" }} closeButton>
                    <ModalTitle>
                      <h5
                        style={{
                          fontSize: is4kScreen
                            ? "2.2rem"
                            : isXxlScreen
                            ? ""
                            : isXlScreen
                            ? ""
                            : isIpadProPortrait
                            ? "1.8rem"
                            : isLargeScreen
                            ? ""
                            : isMediumScreen
                            ? "1.4rem"
                            : "",
                        }}
                      >
                        <b>Add/Change Cards</b>
                      </h5>
                    </ModalTitle>
                  </ModalHeader>
                  <ModalBody>
                    {/* new implementation */}
                    <div>
                      <Container fluid className="align-items-center mt-3 mb-3">
                        <Row>
                          <Col
                            sm={12}
                            md={6}
                            className="d-flex justify-content-md-center aligin-items-center"
                          >
                            <div> 
                              <input
                                name="payementMethodRadio"
                                value="savedCard"
                                checked={saveAndAddRadio === "savedCard"}
                                onChange={(e) =>
                                  setSaveAndAddRadio(e.target.value)
                                }
                                type="radio"
                                style={{
                                  width: is4kScreen
                                    ? "1.5rem"
                                    : isIpadProPortrait
                                    ? "1.4rem"
                                    : "",
                                  height: is4kScreen
                                    ? "1.5rem"
                                    : isIpadProPortrait
                                    ? "1.4rem"
                                    : "",
                                }}
                              />
                            </div>
                            <div style={{ paddingLeft: "5px" }}>
                              <h6
                                style={{
                                  fontSize: is4kScreen
                                    ? "1.6rem"
                                    : isIpadProPortrait
                                    ? "1.5rem"
                                    : isMediumScreen
                                    ? "1.2rem"
                                    : "14px",
                                }}
                              >
                                Pay with Card: {defaultCardNumber || "N/A"}
                              </h6>
                            </div>
                          </Col>
                          <Col
                            sm={12}
                            md={6}
                            className="d-flex justify-content-md-center aligin-items-center"
                          >
                            <div>
                              <input
                                name="paymentMethodRadio"
                                value="addCard"
                                checked={saveAndAddRadio === "addCard"}
                                onChange={(e) =>
                                  setSaveAndAddRadio(e.target.value)
                                }
                                type="radio"
                                style={{
                                  width: is4kScreen
                                    ? "1.5rem"
                                    : isIpadProPortrait
                                    ? "1.4rem"
                                    : "",
                                  height: is4kScreen
                                    ? "1.5rem"
                                    : isIpadProPortrait
                                    ? "1.4rem"
                                    : "",
                                }}
                              />
                            </div>
                            <div style={{ paddingLeft: "5px" }}>
                              <h6
                                style={{
                                  fontSize: is4kScreen
                                    ? "1.6rem"
                                    : isIpadProPortrait
                                    ? "1.5rem"
                                    : isMediumScreen
                                    ? "1.2rem"
                                    : "14px",
                                }}
                              >
                                Add New Card
                              </h6>
                            </div>
                          </Col>
                        </Row>
                      </Container>

                      {saveAndAddRadio === "savedCard" && (
                        <Container fluid>
                          {/* Header Row */}
                          <Row className=" d-none d-sm-flex text-center">
                            <Col sm={4} className=" text-center">
                              <strong
                                style={{
                                  fontSize: is4kScreen
                                    ? "1.6rem"
                                    : isIpadProPortrait
                                    ? "1.5rem"
                                    : isMediumScreen
                                    ? " 1.2rem"
                                    : "14px",
                                }}
                              >
                                Make Default
                              </strong>
                            </Col>
                            <Col sm={4} className="text-center">
                              <strong
                                style={{
                                  fontSize: is4kScreen
                                    ? "1.6rem"
                                    : isIpadProPortrait
                                    ? "1.5rem"
                                    : isMediumScreen
                                    ? " 1.2rem"
                                    : "14px",
                                }}
                              >
                                Card Number
                              </strong>
                            </Col>
                            <Col sm={4} className="text-center">
                              <strong
                                style={{
                                  fontSize: is4kScreen
                                    ? "1.6rem"
                                    : isIpadProPortrait
                                    ? "1.5rem"
                                    : isMediumScreen
                                    ? " 1.2rem"
                                    : "14px",
                                }}
                              >
                                Expiration Date
                              </strong>
                            </Col>
                          </Row>

                          {/* Cards Data */}
                          {allCards.length > 0 &&
                            allCards.map((card, cInx) => (
                              <Row
                                key={cInx}
                                className="border-top py-2 align-items-center"
                              >
                                {/* Is Primary */}
                                <Col
                                  xs={12}
                                  sm={4}
                                  className="d-flex align-items-center gap-1 justify-content-sm-evenly mb-2 mb-sm-0"
                                >
                                  <strong
                                    className="d-sm-none"
                                    style={{ fontSize: "14px" }}
                                  >
                                    Set Default
                                  </strong>
                                  <input
                                    className="m-sm-2"
                                    type="radio"
                                    value={card?.isDefault}
                                    checked={
                                      card?.paymentCardId ===
                                      selectedCard.paymentCardId
                                    }
                                    onChange={(e) => changePrimaryCard(e, cInx)}
                                    style={{
                                      width: is4kScreen
                                        ? "1.5rem"
                                        : isIpadProPortrait
                                        ? "1.4rem"
                                        : "",
                                      height: is4kScreen
                                        ? "1.5rem"
                                        : isIpadProPortrait
                                        ? "1.4rem"
                                        : "",
                                    }}
                                  />
                                </Col>

                                {/* Card Number */}
                                <Col
                                  xs={12}
                                  sm={4}
                                  className="mb-1 mb-sm-0 text-start text-md-center"
                                >
                                  <strong
                                    className="d-sm-none"
                                    style={{ fontSize: "14px" }}
                                  >
                                    Card Number:
                                  </strong>{" "}
                                  <strong
                                    style={{
                                      fontSize: is4kScreen
                                        ? "1.6rem"
                                        : isIpadProPortrait
                                        ? "1.45rem"
                                        : isMediumScreen
                                        ? "1.2rem"
                                        : "14px",
                                    }}
                                  >
                                    {card?.cardNumber}
                                  </strong>
                                </Col>

                                {/* Expiration Date */}
                                <Col
                                  xs={12}
                                  sm={4}
                                  className="mb-2 mb-sm-0 text-start text-md-center"
                                >
                                  <strong
                                    className="d-sm-none"
                                    style={{ fontSize: "14px" }}
                                  >
                                    Expiration Date:
                                  </strong>{" "}
                                  <strong
                                    style={{
                                      fontSize: is4kScreen
                                        ? "1.6rem"
                                        : isIpadProPortrait
                                        ? "1.45rem"
                                        : isMediumScreen
                                        ? "1.2rem"
                                        : "14px",
                                    }}
                                  >
                                    {card?.cardExpiry}
                                  </strong>
                                </Col>
                              </Row>
                            ))}
                        </Container>
                      )}

                      {saveAndAddRadio === "addCard" && (
                        <div className="credits-purchase">
                          <Form style={{ padding: "0px 2em" }}>
                            <Form.Group
                              className="mb-3 row align-items-center"
                              controlId="cardName"
                            >
                              <Form.Label
                                className="col-md-5 col-12 mb-3 text-start"
                                style={{
                                  fontSize: is4kScreen
                                    ? "1.8rem"
                                    : isIpadProPortrait
                                    ? "1.7rem"
                                    : isMediumScreen
                                    ? "1.2rem"
                                    : "",
                                }}
                              >
                                Card Name:
                              </Form.Label>

                              <div className="col-md-5 col-12">
                                <Form.Control
                                  className="col-md-7"
                                  placeholder="Card Name"
                                  name="cardName"
                                  value={newCardDetails.cardName}
                                  onChange={handleInputChange}
                                  type="text"
                                />
                              </div>
                            </Form.Group>

                            <Form.Group
                              className="mb-4 row align-items-center"
                              controlId="cardNumber"
                            >
                              <Form.Label
                                className="col-md-5 col-12 mb-2  text-start"
                                style={{
                                  fontSize: is4kScreen
                                    ? "1.8rem"
                                    : isIpadProPortrait
                                    ? "1.7rem"
                                    : isMediumScreen
                                    ? "1.2rem"
                                    : "",
                                }}
                              >
                                Card Number:
                              </Form.Label>

                              <div className="col-md-5 col-12">
                                <input
                                  type="text"
                                  name="cardNumber"
                                  className="col-md-5 form-control"
                                  id="cardNumber"
                                  value={newCardDetails.cardNumber}
                                  onChange={handleInputChange}
                                  placeholder="1234 5678 9012 3456"
                                  maxLength="19"
                                />
                              </div>

                              {newCardDetails.cardNumber && cardType ? (
                                <Form.Group
                                  className="mb-3 mb-lg-0 row align-items-center"
                                  controlId="expiryDate"
                                >
                                  <Form.Label
                                    className="col-md-5 col-6 mb-2 mb-md-0 text-start"
                                    style={{
                                      fontSize: is4kScreen
                                        ? "1.8rem"
                                        : isIpadProPortrait
                                        ? "1.7rem"
                                        : isMediumScreen
                                        ? "1.2rem"
                                        : "",
                                    }}
                                  >
                                    Card Type:
                                  </Form.Label>

                                  <div className="col-md-5 col-5">
                                    <Form.Label
                                      style={{
                                        fontSize: is4kScreen
                                          ? "1.8rem"
                                          : isIpadProPortrait
                                          ? "1.7rem"
                                          : isMediumScreen
                                          ? "1.2rem"
                                          : "",
                                        paddingLeft: isLargeScreen
                                          ? "0.6rem"
                                          : isXxlScreen
                                          ? "1rem"
                                          : "",
                                      }}
                                    >
                                      {cardType.toUpperCase()}
                                    </Form.Label>
                                  </div>
                                </Form.Group>
                              ) : (
                                ""
                              )}
                              {error && (
                                <p
                                  style={{
                                    color: "red",
                                    textAlign: "center",
                                    fontSize: is4kScreen
                                      ? "1.8rem"
                                      : isIpadProPortrait
                                      ? "1.7rem"
                                      : isMediumScreen
                                      ? "1.2rem"
                                      : "",
                                  }}
                                >
                                  {error}
                                </p>
                              )}
                            </Form.Group>

                            <Form.Group
                              className="mb-3 row align-items-center"
                              controlId="expiryDate"
                            >
                              <Form.Label
                                className="col-md-5 col-12 mb-2 mb-md-0 text-start"
                                style={{
                                  fontSize: is4kScreen
                                    ? "1.8rem"
                                    : isIpadProPortrait
                                    ? "1.7rem"
                                    : isMediumScreen
                                    ? "1.2rem"
                                    : "",
                                }}
                              >
                                Expiration Month/Year:
                              </Form.Label>

                              <div className="col-md-5 col-12">
                                <Form.Control
                                  placeholder="MM/YY"
                                  type="text"
                                  value={newCardDetails.expiryDate}
                                  onChange={(e) =>
                                    changeCardExpirationDetails(e)
                                  }
                                  onKeyDown={handleBackspace}
                                  maxLength={7}
                                />
                              </div>
                            </Form.Group>
                            <Form.Group
                              className="mb-3 row align-items-center w-100 "
                              controlId="expiryDate"
                            >
                              <Form.Label className="col-md-5  col-12 mb-2 mb-md-0 text-center"></Form.Label>

                              <div className="col-md-5  w-full col-12">
                                <div>
                                  {invalidExpiry ? (
                                    <>
                                      <p
                                        className="text-danger"
                                        style={{
                                          fontSize: is4kScreen
                                            ? "1.8rem"
                                            : isIpadProPortrait
                                            ? "1.7rem"
                                            : isMediumScreen
                                            ? "1.2rem"
                                            : "",
                                        }}
                                      >
                                        Invalid Expiry details
                                      </p>
                                    </>
                                  ) : null}
                                </div>
                              </div>
                            </Form.Group>
                          </Form>

                          <Row className="justify-content-center">
                            <Col
                              sm={12}
                              md={8}
                              lg={6}
                              className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3"
                            >
                              {/* Save Card Checkbox */}
                              <Form.Group
                                controlId="saveCard"
                                className="mb-2 sm-pr-2 mb-md-0"
                              >
                                <Form.Check
                                  type="checkbox"
                                  label="Save this card"
                                  name="saveCard"
                                  checked={newCardDetails.saveCard}
                                  onChange={handleInputChange}
                                  style={{
                                    fontSize: is4kScreen
                                      ? "1.8rem"
                                      : isIpadProPortrait
                                      ? "1.5rem"
                                      : isMediumScreen
                                      ? "1.2rem"
                                      : "",
                                  }}
                                />
                              </Form.Group>

                              {/* Make Default Checkbox */}
                              <Form.Group controlId="makeDefault">
                                <Form.Check
                                  type="checkbox"
                                  label="Make default card"
                                  name="makeDefaultCard"
                                  checked={newCardDetails.makeDefaultCard}
                                  onChange={handleInputChange}
                                  disabled={!newCardDetails.saveCard}
                                  style={{
                                    fontSize: is4kScreen
                                      ? "1.8rem"
                                      : isIpadProPortrait
                                      ? "1.5rem"
                                      : isMediumScreen
                                      ? "1.2rem"
                                      : "",
                                  }}
                                />
                              </Form.Group>
                            </Col>
                          </Row>

                          <div className="d-flex justify-content-center mt-3 align-items-center">
                            <button
                              className="search-btn topbar-btns"
                              onClick={() => handleAddCard()}
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontSize: is4kScreen
                                  ? "1.8rem"
                                  : isIpadProPortrait
                                  ? "1.7rem"
                                  : isMediumScreen
                                  ? "1.2rem"
                                  : "",
                              }}
                            >
                              Proceed to Pay
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </ModalBody>
                </Modal>

                {/* credits Modal */}

                <Modal
                  show={showCredits}
                  onHide={handleCreditClose}
                  // className="credit-modal"
                >
                  <ModalHeader style={{ background: "lightblue" }} closeButton>
                    <ModalTitle>
                      <h5
                        style={{
                          fontSize: is4kScreen
                            ? "2.2rem"
                            : isXxlScreen
                            ? ""
                            : isXlScreen
                            ? ""
                            : isIpadProPortrait
                            ? "1.8rem"
                            : isLargeScreen
                            ? ""
                            : isMediumScreen
                            ? "1.4rem"
                            : "",
                        }}
                      >
                        <b>Credit Balance</b>
                      </h5>
                    </ModalTitle>
                  </ModalHeader>
                  <ModalBody>
                    <Container className="">
                      <Row>
                        <Col
                          sm={12}
                          md={12}
                          lg={isIpadProPortrait ? 12 : 7}
                          className={
                            isSmallScreen
                              ? "border-0"
                              : isMediumScreen
                              ? "border-0"
                              : isIpadProPortrait
                              ? "border-0"
                              : "apply-border-left"
                          }
                        >
                          <br></br>

                          <div className="row">
                            {creditSummary.length &&
                              creditSummary.map((c, i) => (
                                <>
                                  {/* <div className='col-md-2'>{c['reportsPurchased']}</div>
                                <div className='col-md-1'>{c['reportsOrdered']}</div> */}
                                  <div
                                    className="col-sm-6 col-6 col-md-6 "
                                    style={{ textAlign: "center" }}
                                  >
                                    <Row>
                                      <Col md={12}>
                                        <p
                                          style={{
                                            fontSize: is4kScreen
                                              ? "1.9rem"
                                              : isXxlScreen
                                              ? ""
                                              : isXlScreen
                                              ? ""
                                              : isIpadProPortrait
                                              ? "1.5rem"
                                              : isLargeScreen
                                              ? ""
                                              : isMediumScreen
                                              ? "1.2rem"
                                              : "14px",
                                          }}
                                        >
                                          <strong>
                                            {`${c.productName} CREDITS`}:
                                          </strong>
                                        </p>
                                      </Col>
                                      <Col md={12}>
                                        <p
                                          style={{
                                            fontSize: is4kScreen
                                              ? "2rem"
                                              : isXxlScreen
                                              ? ""
                                              : isXlScreen
                                              ? ""
                                              : isIpadProPortrait
                                              ? "1.6rem"
                                              : isLargeScreen
                                              ? ""
                                              : isMediumScreen
                                              ? "1.1rem"
                                              : "16px",
                                          }}
                                        >
                                          <strong>{c.overAllRemaining}</strong>
                                        </p>{" "}
                                      </Col>
                                    </Row>
                                  </div>
                                </>
                              ))}
                          </div>
                          <br></br>
                          <div className=" d-flex flex-column align-items-center">
                            <h6
                              style={{
                                textAlign: "center",
                                fontSize: is4kScreen
                                  ? "2rem"
                                  : isXxlScreen
                                  ? ""
                                  : isXlScreen
                                  ? ""
                                  : isIpadProPortrait
                                  ? "1.5rem"
                                  : isLargeScreen
                                  ? ""
                                  : isMediumScreen
                                  ? "1.4rem"
                                  : "15px",
                              }}
                            >
                              BUY MORE CREDITS
                            </h6>
                            <div className="row mt-2 gx-0">
                              {" "}
                              {/* gx-0 removes extra gutter spacing */}
                              {reports.length > 0 &&
                                reports.map((credit, index) => (
                                  <div
                                    key={index}
                                    className="col-sm-6 col-6 col-md-6 d-flex justify-content-center"
                                  >
                                    <div
                                      className={`w-100 p-1 ${
                                        selBrickToBuy?.brickName
                                          ?.trim()
                                          .toUpperCase() ===
                                        credit?.name?.trim().toUpperCase()
                                          ? "selected"
                                          : "not-selected"
                                      }`}
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        border: "1px solid #e1dfdf",
                                        borderRadius: "5px",
                                        minWidth: "3em",
                                        margin: "1em",
                                      }}
                                      onClick={() => {
                                        brickSelectionHandler(credit);
                                      }}
                                    >
                                      <p
                                        style={{
                                          fontSize: is4kScreen
                                            ? "1.8rem"
                                            : isXxlScreen
                                            ? ""
                                            : isXlScreen
                                            ? ""
                                            : isIpadProPortrait
                                            ? "1.5rem"
                                            : isMediumScreen
                                            ? "1.2rem"
                                            : "14px",
                                          marginBottom: "0px",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        <b>{credit.name}</b>
                                      </p>
                                      <p
                                        style={{
                                          fontSize: is4kScreen
                                            ? "1.8rem"
                                            : isXxlScreen
                                            ? ""
                                            : isXlScreen
                                            ? ""
                                            : isIpadProPortrait
                                            ? "1.5rem"
                                            : isMediumScreen
                                            ? "1.2rem"
                                            : "14px",
                                          marginBottom: "0px",
                                        }}
                                      >
                                        {credit.brickQuantity} CREDITS
                                      </p>
                                      <p
                                        style={{
                                          fontSize: is4kScreen
                                            ? "1.8rem"
                                            : isXxlScreen
                                            ? ""
                                            : isXlScreen
                                            ? ""
                                            : isIpadProPortrait
                                            ? "1.5rem"
                                            : isMediumScreen
                                            ? "1.2rem"
                                            : "14px",
                                          color: "#000",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        ${credit.brickPrice} USD
                                      </p>
                                    </div>
                                  </div>
                                ))}
                            </div>
                            {/* Quantity */}
                            <br></br>
                            <div
                              className="d-flex flex-wrap justify-content-center align-items-center gap-3"
                              style={{ width: "100%" }}
                            >
                              {/* Promo Title */}
                              <div className="col-5 col-sm-4 col-md-3 text-center">
                                <b
                                  style={{
                                    fontSize: is4kScreen
                                      ? "1.8rem"
                                      : isXxlScreen
                                      ? ""
                                      : isXlScreen
                                      ? ""
                                      : isIpadProPortrait
                                      ? "1.5rem"
                                      : isMediumScreen
                                      ? "1.2rem"
                                      : "14px",
                                  }}
                                >
                                  Add Promo Code
                                </b>
                              </div>

                              {/* Promo Input */}
                              <div className="col-5 credits-purchase col-sm-4 col-md-4">
                                <input
                                  type="text"
                                  value={brickPromo}
                                  onChange={onBrickPromoHandler}
                                  className="form-control w-100"
                                />
                              </div>

                              {/* Apply Button */}
                              <div className="col-4 col-sm-4 col-md-3 text-center">
                                <button
                                  type="submit"
                                  className=" topbar-btns search-btn w-100"
                                  style={{
                                    // border: "1px solid black",
                                    fontSize: is4kScreen
                                      ? "2rem"
                                      : isIpadProPortrait
                                      ? "1.5rem"
                                      : isMediumScreen
                                      ? "1.2rem"
                                      : "14px",
                                    margin: "0px",
                                  }}
                                  disabled={brickPromo === ""}
                                  onClick={checkBrickPromo}
                                >
                                  Apply
                                </button>
                              </div>
                            </div>
                            <div className="pb-3">
                              {isBricksPromoApplied && (
                                <span
                                  style={{
                                    color: "green",
                                    fontSize: is4kScreen
                                      ? "2rem"
                                      : isIpadProPortrait
                                      ? "1.5rem"
                                      : isMediumScreen
                                      ? "1.2rem"
                                      : "14px",
                                  }}
                                  className="d-block mt-1"
                                >
                                  Promo code applied successfully!
                                </span>
                              )}
                              {showBrickPromoErrorMsg && (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: is4kScreen
                                      ? "2rem"
                                      : isIpadProPortrait
                                      ? "1.5rem"
                                      : isMediumScreen
                                      ? "1.2rem"
                                      : "14px",
                                  }}
                                  className="d-block mt-1"
                                >
                                  Please enter a valid Promo Code.
                                </span>
                              )}
                            </div>

                            <Container
                              fluid
                              className="align-items-center mb-2"
                            >
                              <Row>
                                <Col
                                  sm={12}
                                  md={6}
                                  className="d-flex justify-content-md-center aligin-items-center"
                                >
                                  <div>
                                    <input
                                      name="payementMethodRadio"
                                      value="savedCard"
                                      checked={selectCardType === "savedCard"}
                                      onChange={(e) =>
                                        setSelectCardType(e.target.value)
                                      }
                                      type="radio"
                                      style={{
                                        width: is4kScreen
                                          ? "1.5rem"
                                          : isIpadProPortrait
                                          ? "1.4rem"
                                          : "",
                                        height: is4kScreen
                                          ? "1.5rem"
                                          : isIpadProPortrait
                                          ? "1.4rem"
                                          : "",
                                      }}
                                    />
                                  </div>
                                  <div style={{ paddingLeft: "5px" }}>
                                    <h6
                                      style={{
                                        fontSize: is4kScreen
                                          ? "1.6rem"
                                          : isIpadProPortrait
                                          ? "1.5rem"
                                          : isMediumScreen
                                          ? "1.2rem"
                                          : "14px",
                                      }}
                                    >
                                      Pay with Card:{" "}
                                      {defaultCardNumber || "N/A"}
                                    </h6>
                                  </div>
                                </Col>
                                <Col
                                  sm={12}
                                  md={6}
                                  className="d-flex justify-content-md-center aligin-items-center"
                                >
                                  <div>
                                    <input
                                      name="paymentMethodRadio"
                                      value="addCard"
                                      checked={selectCardType === "addCard"}
                                      // disabled={ }
                                      onChange={(e) =>
                                        setSelectCardType(e.target.value)
                                      }
                                      type="radio"
                                      style={{
                                        width: is4kScreen
                                          ? "1.5rem"
                                          : isIpadProPortrait
                                          ? "1.4rem"
                                          : "",
                                        height: is4kScreen
                                          ? "1.5rem"
                                          : isIpadProPortrait
                                          ? "1.4rem"
                                          : "",
                                      }}
                                    />
                                  </div>
                                  <div style={{ paddingLeft: "5px" }}>
                                    <h6
                                      style={{
                                        fontSize: is4kScreen
                                          ? "1.6rem"
                                          : isIpadProPortrait
                                          ? "1.5rem"
                                          : isMediumScreen
                                          ? "1.2rem"
                                          : "14px",
                                      }}
                                    >
                                      Add New Card
                                    </h6>
                                  </div>
                                </Col>
                              </Row>
                            </Container>

                            {selectCardType === "savedCard" && (
                              <Container fluid>
                                {/* Header Row */}
                                <Row className=" d-none d-sm-flex text-center">
                                  <Col sm={4} className=" text-center">
                                    <strong
                                      style={{
                                        fontSize: is4kScreen
                                          ? "1.6rem"
                                          : isIpadProPortrait
                                          ? "1.5rem"
                                          : isMediumScreen
                                          ? " 1.2rem"
                                          : "14px",
                                      }}
                                    >
                                      Make Default
                                    </strong>
                                  </Col>
                                  <Col sm={4} className="text-center">
                                    <strong
                                      style={{
                                        fontSize: is4kScreen
                                          ? "1.6rem"
                                          : isIpadProPortrait
                                          ? "1.5rem"
                                          : isMediumScreen
                                          ? " 1.2rem"
                                          : "14px",
                                      }}
                                    >
                                      Card Number
                                    </strong>
                                  </Col>
                                  <Col sm={4} className="text-center">
                                    <strong
                                      style={{
                                        fontSize: is4kScreen
                                          ? "1.6rem"
                                          : isIpadProPortrait
                                          ? "1.5rem"
                                          : isMediumScreen
                                          ? " 1.2rem"
                                          : "14px",
                                      }}
                                    >
                                      Expiration Date
                                    </strong>
                                  </Col>
                                </Row>

                                {/* Cards Data */}
                                {allCards.length > 0 &&
                                  allCards.map((card, cInx) => (
                                    <Row
                                      key={cInx}
                                      className={`border-top py-2 align-items-center ${
                                        cInx !== allCards.length - 1
                                          ? "border-bottom"
                                          : ""
                                      }`}
                                    >
                                      {/* Is Primary */}
                                      <Col
                                        xs={12}
                                        sm={4}
                                        className="d-flex align-items-center gap-1 justify-content-sm-evenly mb-2 mb-sm-0"
                                      >
                                        <strong
                                          className="d-sm-none"
                                          style={{ fontSize: "14px" }}
                                        >
                                          Set Default
                                        </strong>
                                        <input
                                          className="m-sm-2"
                                          type="radio"
                                          value={card?.isDefault}
                                          checked={
                                            card?.paymentCardId ===
                                            selectedCard.paymentCardId
                                          }
                                          onChange={(e) =>
                                            changePrimaryCard(e, cInx)
                                          }
                                          style={{
                                            width: is4kScreen
                                              ? "1.5rem"
                                              : isIpadProPortrait
                                              ? "1.4rem"
                                              : "",
                                            height: is4kScreen
                                              ? "1.5rem"
                                              : isIpadProPortrait
                                              ? "1.4rem"
                                              : "",
                                          }}
                                        />
                                      </Col>

                                      {/* Card Number */}
                                      <Col
                                        xs={12}
                                        sm={4}
                                        className="mb-1 mb-sm-0 text-start text-md-center"
                                      >
                                        <strong
                                          className="d-sm-none"
                                          style={{ fontSize: "14px" }}
                                        >
                                          Card Number:
                                        </strong>{" "}
                                        <strong
                                          style={{
                                            fontSize: is4kScreen
                                              ? "1.6rem"
                                              : isIpadProPortrait
                                              ? "1.45rem"
                                              : isMediumScreen
                                              ? "1.2rem"
                                              : "14px",
                                          }}
                                        >
                                          {card?.cardNumber}
                                        </strong>
                                      </Col>

                                      {/* Expiration Date */}
                                      <Col
                                        xs={12}
                                        sm={4}
                                        className="mb-2 mb-sm-0 text-start text-md-center"
                                      >
                                        <strong
                                          className="d-sm-none"
                                          style={{ fontSize: "14px" }}
                                        >
                                          Expiration Date:
                                        </strong>{" "}
                                        <strong
                                          style={{
                                            fontSize: is4kScreen
                                              ? "1.6rem"
                                              : isIpadProPortrait
                                              ? "1.45rem"
                                              : isMediumScreen
                                              ? "1.2rem"
                                              : "14px",
                                          }}
                                        >
                                          {card?.cardExpiry}
                                        </strong>
                                      </Col>
                                    </Row>
                                  ))}
                              </Container>
                            )}

                            {selectCardType === "addCard" && (
                              <div className="credits-purchase">
                                <Form style={{ padding: "0px 2em" }}>
                                  <Form.Group
                                    className="mb-3 row align-items-center"
                                    controlId="cardName"
                                  >
                                    <Form.Label
                                      className={`col-md-${
                                        isIpadProPortrait ? "6" : "5"
                                      } col-12 mb-2 mb-md-0 text-start`}
                                      style={{
                                        fontSize: is4kScreen
                                          ? "1.8rem"
                                          : isIpadProPortrait
                                          ? "1.7rem"
                                          : isMediumScreen
                                          ? "1.2rem"
                                          : "",
                                      }}
                                    >
                                      Card Name:
                                    </Form.Label>

                                    <div
                                      className={`col-md-${
                                        isIpadProPortrait
                                          ? "6"
                                          : isMediumScreen
                                          ? "6"
                                          : "5"
                                      } col-12`}
                                    >
                                      <Form.Control
                                        className="col-md-7"
                                        placeholder="Card Name"
                                        value={cardName}
                                        onChange={(e) =>
                                          changeCardNameHandler(e)
                                        }
                                        type="text"
                                      />
                                    </div>
                                  </Form.Group>

                                  <Form.Group
                                    className="mb-3 row align-items-center"
                                    controlId="cardNumber"
                                  >
                                    <Form.Label
                                      className={`col-md-${
                                        isIpadProPortrait ? "6" : "5"
                                      } col-12 mb-2 mb-md-0 text-start`}
                                      style={{
                                        fontSize: is4kScreen
                                          ? "1.8rem"
                                          : isIpadProPortrait
                                          ? "1.7rem"
                                          : isMediumScreen
                                          ? "1.2rem"
                                          : "",
                                      }}
                                    >
                                      Card Number:
                                    </Form.Label>

                                    <div
                                      className={`col-md-${
                                        isIpadProPortrait
                                          ? "6"
                                          : isMediumScreen
                                          ? "6"
                                          : "5"
                                      } col-12`}
                                    >
                                      <input
                                        type="text"
                                        className="col-md-5 form-control"
                                        id="cardNumber"
                                        value={cardNumber}
                                        onChange={handleChange}
                                        placeholder="1234 5678 9012 3456"
                                        maxLength="19"
                                      />
                                    </div>

                                    {cardNumber && cardType ? (
                                      <Form.Group
                                        className="mb-3 row align-items-center"
                                        controlId="expiryDate"
                                      >
                                        <Form.Label
                                          className={`col-md-${
                                            isIpadProPortrait ? "6" : "5"
                                          } col-12 mb-2 mb-md-0 text-start`}
                                          style={{
                                            fontSize: is4kScreen
                                              ? "1.8rem"
                                              : isIpadProPortrait
                                              ? "1.7rem"
                                              : isMediumScreen
                                              ? "1.2rem"
                                              : "",
                                          }}
                                        >
                                          Card Type:
                                        </Form.Label>

                                        <div className="col-md-5 col-5">
                                          <Form.Label
                                            style={{
                                              fontSize: is4kScreen
                                                ? "1.8rem"
                                                : "",
                                            }}
                                          >
                                            {cardType.toUpperCase()}
                                          </Form.Label>
                                        </div>
                                      </Form.Group>
                                    ) : (
                                      ""
                                    )}
                                    {error && (
                                      <p
                                        style={{
                                          color: "red",
                                          textAlign: "center",
                                          fontSize: is4kScreen ? "1.8rem" : "",
                                        }}
                                      >
                                        {error}
                                      </p>
                                    )}
                                  </Form.Group>

                                  <Form.Group
                                    className={`mb-3 row ${
                                      isLargeScreen ? "" : "align-items-center"
                                    }`}
                                    controlId="expiryDate"
                                  >
                                    <Form.Label
                                      className={`col-md-${
                                        isIpadProPortrait ? "6" : "5"
                                      } col-12 mb-2 mb-md-0 text-start`}
                                      style={{
                                        fontSize: is4kScreen
                                          ? "1.8rem"
                                          : isIpadProPortrait
                                          ? "1.7rem"
                                          : isMediumScreen
                                          ? "1.2rem"
                                          : "",
                                      }}
                                    >
                                      Expiration Month/Year:
                                    </Form.Label>

                                    <div
                                      className={`col-md-${
                                        isIpadProPortrait
                                          ? "6"
                                          : isMediumScreen
                                          ? "6"
                                          : "5"
                                      } col-12`}
                                    >
                                      <Form.Control
                                        placeholder="MM/YY"
                                        type="text"
                                        value={cardExpirationDetails}
                                        onChange={(e) =>
                                          changeCardExpirationDetails(e)
                                        }
                                        onKeyDown={handleBackspace}
                                        maxLength={7}
                                      />
                                    </div>
                                  </Form.Group>
                                  <Form.Group
                                    className="mb-3 row align-items-center w-100 "
                                    controlId="expiryDate"
                                  >
                                    <Form.Label className="col-md-5  col-12 mb-2 mb-md-0 text-center"></Form.Label>

                                    <div className="col-md-5  w-full col-12">
                                      <div>
                                        {invalidExpiry ? (
                                          <>
                                            <p className="text-danger">
                                              Invalid Expiry details
                                            </p>
                                          </>
                                        ) : null}
                                      </div>
                                    </div>
                                  </Form.Group>
                                </Form>

                                <Row>
                                  <Col
                                    sm={12}
                                    md={6}
                                    className="d-flex justify-content-center align-items-center gap-3"
                                  >
                                    {/* Save Card Checkbox */}
                                    <Form.Group
                                      controlId="saveCard"
                                      className="mb-3"
                                    >
                                      <Form.Check
                                        type="checkbox"
                                        label={
                                          "Save this card"
                                          // loadingSave ? "Saving..." : "Save this card"
                                        }
                                        style={{
                                          fontSize: is4kScreen
                                            ? "1.8rem"
                                            : isIpadProPortrait
                                            ? "1.6rem"
                                            : isMediumScreen
                                            ? "1.2rem"
                                            : "",
                                        }}
                                        checked={saveCard}
                                        onChange={(e) =>
                                          setSaveCard(e.target.checked)
                                        }
                                        // disabled={loadingSave}
                                      />
                                    </Form.Group>

                                    {/* Make Default Checkbox */}
                                  </Col>
                                  <Col sm={12} md={6}>
                                    <Form.Group
                                      controlId="makeDefault"
                                      className="mb-3"
                                    >
                                      <Form.Check
                                        type="checkbox"
                                        label={"Make default card"}
                                        checked={makeDefaultCard}
                                        style={{
                                          fontSize: is4kScreen
                                            ? "1.8rem"
                                            : isIpadProPortrait
                                            ? "1.6rem"
                                            : isMediumScreen
                                            ? "1.2rem"
                                            : "",
                                        }}
                                        onChange={(e) =>
                                          setMakeDefaultCard(e.target.checked)
                                        }
                                        disabled={!saveCard || loadingDefault}
                                      />
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </div>
                            )}

                            <br></br>
                          </div>
                        </Col>
                        <Col
                          sm={12}
                          md={12}
                          lg={isIpadProPortrait ? 12 : 5}
                          className=" pt-xs-4 p-2 d-flex  flex-column"
                        >
                          <h6
                            style={{
                              textAlign: "center",
                              marginLeft: "60px",
                              fontSize: is4kScreen
                                ? "2rem"
                                : isXxlScreen
                                ? "1.2rem"
                                : isXlScreen
                                ? ""
                                : isIpadProPortrait
                                ? "1.9rem"
                                : isMediumScreen
                                ? "1.3rem"
                                : "",
                            }}
                          >
                            <b>Summary</b>
                          </h6>

                          <div style={{ height: "30vh" }}>
                            {selBrickToBuy.brickName && (
                              <div className="w-full d-flex flex-wrap w-100 gap-1 justify-content-evenly align-items-center">
                                <div className="col-5 col-md-5 d-flex  flex-row justify-content-start align-items-center p-2">
                                  <p
                                    className="text-center mb-0"
                                    style={{
                                      fontSize: is4kScreen
                                        ? "1.8rem"
                                        : isXxlScreen
                                        ? "1rem"
                                        : isXlScreen
                                        ? "1rem"
                                        : isIpadProPortrait
                                        ? "1.8rem"
                                        : isLargeScreen
                                        ? ""
                                        : isMediumScreen
                                        ? "1.3rem"
                                        : "0.8rem",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {selBrickToBuy.brickName
                                      .charAt(0)
                                      .toUpperCase() +
                                      selBrickToBuy.brickName
                                        .slice(1)
                                        .toLowerCase()}{" "}
                                    <br />
                                    {selBrickToBuy.brickCount} Credits
                                  </p>
                                </div>

                                <div className="col-4 col-md-3 d-flex  justify-content-center " >
                                  <button
                                    style={{
                                      border: "none",
                                      fontSize: is4kScreen
                                        ? "2rem"
                                        : isXxlScreen
                                        ? "1.5rem"
                                        : isIpadProPortrait
                                        ? "1.9rem"
                                        : isMediumScreen
                                        ? "1.3rem"
                                        : "",
                                      paddingLeft: is4kScreen
                                        ? "1.5rem"
                                        : isXxlScreen
                                        ? "0.8rem"
                                        : isIpadProPortrait
                                        ? "1rem"
                                        : isMediumScreen
                                        ? "0.8rem"
                                        : "",
                                      paddingRight: is4kScreen
                                        ? "1.5rem"
                                        : isXxlScreen
                                        ? "0.8rem"
                                        : isIpadProPortrait
                                        ? "1rem"
                                        : isMediumScreen
                                        ? "0.8rem"
                                        : "",
                                    }}
                                    onClick={() =>
                                      handleDecrement(selBrickToBuy)
                                    }
                                  >
                                    -
                                  </button>

                                  <div
                                    className="border"
                                    style={{
                                      margin: "0px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      border: "none",
                                      paddingLeft: is4kScreen
                                        ? "1rem"
                                        : isIpadProPortrait
                                        ? "1rem"
                                        : "10px",
                                      paddingRight: is4kScreen
                                        ? "1rem"
                                        : isIpadProPortrait
                                        ? "1rem"
                                        : "10px",
                                      fontSize: is4kScreen
                                        ? "1.8rem"
                                        : isXxlScreen
                                        ? "1rem"
                                        : isXlScreen
                                        ? "1rem"
                                        : isIpadProPortrait
                                        ? "1.8rem"
                                        : isLargeScreen
                                        ? ""
                                        : isMediumScreen
                                        ? "1.3rem"
                                        : "0.8rem",

                                      fontWeight: "600",
                                    }}
                                  >
                                    {inputData}
                                  </div>
                                  <button
                                    style={{
                                      border: "none",
                                      fontSize: is4kScreen
                                        ? "2rem"
                                        : isXxlScreen
                                        ? "1.5rem"
                                        : isIpadProPortrait
                                        ? "1.9rem"
                                        : isMediumScreen
                                        ? "1.3rem"
                                        : isMediumScreen
                                        ? "0.8rem"
                                        : "",
                                      paddingLeft: is4kScreen
                                        ? "1.5rem"
                                        : isXxlScreen
                                        ? "0.8rem"
                                        : isIpadProPortrait
                                        ? "1rem"
                                        : "",
                                      paddingRight: is4kScreen
                                        ? "1.5rem"
                                        : isXxlScreen
                                        ? "0.8rem"
                                        : isIpadProPortrait
                                        ? "1rem"
                                        : isMediumScreen
                                        ? "0.8rem"
                                        : "",
                                    }}
                                    onClick={() =>
                                      handleIncrement(selBrickToBuy)
                                    }
                                  >
                                    +
                                  </button>
                                </div>
                                {buyCreditItems
                                  .filter(
                                    (summary) =>
                                      summary.type.toUpperCase() ===
                                      selBrickToBuy.brickName.toUpperCase()
                                  ) // Only display relevant type
                                  .map((summary) => (
                                    <div className="col-2 col-md-3  d-flex flex-column justify-content-center align-items-center">
                                      <p
                                        key={summary.id}
                                        className="w-100 text-center  m-0 p-2"
                                        style={{
                                          fontSize: is4kScreen
                                            ? "1.8rem"
                                            : isXxlScreen
                                            ? "1rem"
                                            : isXlScreen
                                            ? "1rem"
                                            : isIpadProPortrait
                                            ? "1.8rem"
                                            : isLargeScreen
                                            ? ""
                                            : isMediumScreen
                                            ? "1.3rem"
                                            : "0.8rem",

                                          fontWeight: "600",
                                        }}
                                      >
                                        <b>${summary.price}</b>
                                      </p>
                                    </div>
                                  ))}
                              </div>
                            )}

                            {brickDiscount !== 0 && (
                              <div className="  d-flex flex-row justify-content-between gap-3 p-3">
                                <span
                                  className="col-md-7"
                                  style={{
                                    wordBreak: "break-word",
                                    overflowWrap: "break-word",
                                    hyphens: "auto",
                                    display: "inline-block",
                                    whiteSpace: "pre-wrap",
                                    fontSize: is4kScreen
                                      ? "1.8rem"
                                      : isXxlScreen
                                      ? "1rem"
                                      : isXlScreen
                                      ? "1rem"
                                      : isIpadProPortrait
                                      ? "1.8rem"
                                      : isLargeScreen
                                      ? ""
                                      : isMediumScreen
                                      ? "1.3rem"
                                      : "0.8rem",

                                    fontWeight: "600",
                                  }}
                                >
                                  {brickPromo}
                                </span>
                                <span
                                  className="col-md-4 text-center"
                                  style={{
                                    color: "red",
                                    fontSize: is4kScreen
                                      ? "1.8rem"
                                      : isXxlScreen
                                      ? "1rem"
                                      : isXlScreen
                                      ? "1rem"
                                      : isIpadProPortrait
                                      ? "1.8rem"
                                      : isLargeScreen
                                      ? ""
                                      : isMediumScreen
                                      ? "1.3rem"
                                      : "0.8rem",
                                    marginLeft: isIpadProPortrait
                                      ? "4rem"
                                      : isXxlScreen
                                      ? "2.1rem"
                                      : isXlScreen
                                      ? "1.9rem"
                                      : "",

                                    fontWeight: "600",
                                  }}
                                >
                                  -${brickDiscount}
                                </span>
                              </div>
                            )}
                          </div>
                          <hr
                            style={{ border: "1px solid #ddd", width: "100%" }}
                          />
                          <p
                            className="item text-center"
                            style={{
                              fontSize: is4kScreen
                                ? "1.8rem"
                                : isXxlScreen
                                ? "1rem"
                                : isXlScreen
                                ? "1rem"
                                : isIpadProPortrait
                                ? "1.8rem"
                                : isLargeScreen
                                ? ""
                                : isMediumScreen
                                ? "1.3rem"
                                : "0.8rem",

                              fontWeight: "600",
                            }}
                          >
                            <b>
                              {" "}
                              <span>Estimated Total: </span>
                              <span>${EstimateBrickTotal} USD</span>
                            </b>
                          </p>
                          <div className="d-flex  w-100 justify-content-center align-items-center ">
                            <button
                              disabled={
                                changeCardLoading ||
                                disableBasicCredit ||
                                showBrickPromoErrorMsg ||
                                (selectCardType === "savedCard" &&
                                  !brickPromo &&
                                  allCards.length <= 0) ||
                                (selectCardType === "addCard" && !cardNumber) ||
                                (selectCardType === "addCard" &&
                                  !cardExpirationDetails) ||
                                (selectCardType === "addCard" && !cardName)
                              }
                              className="col-md-3 topbar-btns  px-4 search-btn"
                              onClick={() => {
                                handleChooseCardPaymentType();
                              }}
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontSize: is4kScreen
                                  ? "1.9rem"
                                  : isIpadProPortrait
                                  ? "1.6rem"
                                  : isMediumScreen
                                  ? "1.2rem "
                                  : "1rem",
                              }}
                            >
                              <Loader
                                response={creditsLoading}
                                action={"Order"}
                              />
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </ModalBody>
                </Modal>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Purchase;
